<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-transcript-search-filters">
    <div class="search-section">
      <div @mouseover="onSearchHover" @mouseout="onSearchLeave" ref="searchBox" class="search">
        <div class="div-search-input">
          <div class="search-button material-icons">search</div>
          <el-tooltip :disabled="!isShowAdvancedFilterResultsTooltip" slot="reference" :visible-arrow="false" effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom">
            <div slot="content" ref="advancedFilterHoverSlot"></div>
            <el-input
              v-if="!isSearchInputDisabled &&  (!isShowGroups || searchType == '2')"
              ref="searchInput"
              class="search-inp"
              :placeholder="'Search transcripts'"
              v-model="advancedFilterPayload.groupA.conditions[0].value"
              @focus="onSearchFocus"
              @blur="onSearchBlur"
              @keypress.enter.native="handleEnterSearch"
            ></el-input>
            <el-input
              v-else
              ref="searchInput"
              class="search-inp"
              :disabled="true"
              @focus="onSearchFocus"
              @blur="onSearchBlur"
              @keypress.enter.native="handleEnterSearch"
            ></el-input>
          </el-tooltip>
          <el-tooltip v-if="searchKeyword&&searchKeyword!=''"  slot="reference" content="Clear" effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom">
            <div class="fas fa-times-circle" @click="clearSearchInput"></div>
          </el-tooltip>
        </div>

        <el-popover transition="" @hide="handlePopoverHideEvent" v-model="showAdvancedSearchFilter" placement="bottom-end" popper-class="advanced-wrapper">
          <el-tooltip slot="reference" ref="advancedSearchTooltip" content="Show search options" effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom">
            <div @mouseover="onSearchHover" @mouseout="onSearchLeave" @click="handleHideAdvancedFilterIconTooltip" class="advanced-search-icon"></div>
          </el-tooltip>
          <div class="wy-analytics-transcript-search-dropdown-menu search-input">
            <div class="heading">
              <div>Advanced Search Options</div>
              <img style="padding-left: 40px; cursor: pointer" src="../../assets/icons/icon_transcript_close.svg" @click="handleCancelAdvancedSearch">
            </div>
            <div class="divider"/>
            <div class="body" ref="advancedFilterBody">
              <div class="main-search-dropdown">
                <div class="sub-heading">
                  Search using:
                </div>
                <div class="sub-items">
                  <el-select 
                    ref="searchByDropdown" 
                    v-model="searchType"
                    popper-class="transcript-search-advanced-search-dropdown" 
                    :placeholder="searchTypeList[0].label"
                  >
                    <el-option
                      v-for="item in searchTypeList"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                      :disabled="item.disabled"
                      :selected="item.key === searchTypeList[0].key"
                      >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div v-if="searchType == '1'">
                <div class="border"></div>
  
                <div>
                  <div class="sub-heading">
                    Find results with:
                  </div>
  
                  <div v-if="!isShowGroups" class="sub-items results-wrapper">   
                            <div class="dropdown-wrapper">
                          <el-select 
                            ref="searchTypeDropdown-0" 
                            :class="{'selected-blue': advancedFilterPayload.groupA.conditions[0].searchType}"
                            v-model="advancedFilterPayload.groupA.conditions[0].searchType"                              
                            popper-class="transcript-search-advanced-search-dropdown" 
                            placeholder="By: Search type"
                          >
                            <el-option
                              v-for="item in searchForList"
                              :key="item.key"
                              :label="item.label"
                              :value="item.key"
                              :disabled="item.disabled"
                              >
                            </el-option>
                          </el-select>
                        </div>                     
                        
                        <div class="dropdown-wrapper">
                          <el-dropdown 
                            ref="messageTypeDropdown-0"
                            trigger="click"
                            placement="bottom-start"
                            class="select-box"
                            :class="{'selected-blue': advancedFilterPayload.groupA.conditions[0].messageType.length}"
                            @visible-change="handleDefaultMessageTypeDropdownVisibleChange"
                          >
                            <span 
                              class="value-box" 
                              :class="{
                                'placeholder-text': !advancedFilterPayload.groupA.conditions[0].messageType.length,
                                'value-text': advancedFilterPayload.groupA.conditions[0].messageType.length
                              }"
                            >
                            {{ handleMessageTypeText(advancedFilterPayload.groupA.conditions[0]) }}
                            <div class="icon-placement-default">
                              <i class="el-icon-arrow-down el-icon--right placement"></i>
                            </div>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                              <el-checkbox-group 
                                v-model="advancedFilterPayload.groupA.conditions[0].messageType"
                                class="message-type-dropdown"
                                >
                                <el-checkbox
                                  v-for="item in searchInList"
                                  class="checkbox"
                                  :key="item.key"
                                  :label="item.apiField"
                                  :disabled="item.disabled"
                                >
                                  {{ item.label }}
                                </el-checkbox>
                              </el-checkbox-group> 
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
  
                        <div class="search-wrapper" :class="{'selected-blue': advancedFilterPayload.groupA.conditions[0].value}">
                          <el-input
                            :class="{'selected-blue remove-border': advancedFilterPayload.groupA.conditions[0].value}"
                            ref="searchForInput"
                            class="search-for-inp"
                            placeholder="For: Keyword/Phrase"
                            v-model="advancedFilterPayload.groupA.conditions[0].value"                              
                          ></el-input>
                        </div>
                      </div>
                  
                  <!-- Group A -->
                  <div v-if="isShowGroups && advancedFilterPayload.groupA" class="group-wrapper">
                    <div>A</div>
  
                    <div class="group">
  
                      <div class="sub-items results-wrapper">
                        <div class="operator-wrapper">                
                          <el-select 
                            ref="innerGroupOperatorDropdown-A"
                            class="selected-blue"
                            v-model="advancedFilterPayload.groupA.operator"                              
                            popper-class="transcript-search-advanced-search-dropdown" 
                          >
                            <el-option
                              v-for="item in operatorsEnum"
                              :key="item.key" 
                              :label="item.label"
                              :value="item.key"
                              :disabled="item.disabled"
                              >
                            </el-option>
                          </el-select>
                        </div>
                        <div>Will apply to each line in this group</div>
                      </div>
  
                      <div class="sub-items">   
                        <div v-for="(condition, index) in advancedFilterPayload.groupA.conditions" :key="index" class="results-wrapper">
                          <div class="dropdown-wrapper">
                            <el-select 
                              :ref="'searchTypeDropdown-'+index" 
                              :class="{'selected-blue': condition.searchType}"
                              v-model="condition.searchType"                              
                              popper-class="transcript-search-advanced-search-dropdown" 
                              placeholder="By: Search type"
                            >
                              <el-option
                                v-for="item in searchForList"
                                :key="item.key" 
                                :label="item.label"
                                :value="item.key"
                                :disabled="item.disabled"
                                >
                              </el-option>
                            </el-select>
                          </div>
        
                          <div class="dropdown-wrapper" >
                            <el-dropdown 
                              :ref="'messageTypeDropdown-'+index"
                              trigger="click"
                              placement="bottom-start"
                              class="select-box"
                              :class="{'selected-blue': condition.messageType.length}"
                              @visible-change="(val) => handleGroupMessageTypeDropdownVisibleChange(val, index)"
                            >
                              <span 
                                class="value-box" 
                                :class="{
                                  'placeholder-text': !condition.messageType.length,
                                  'value-text': condition.messageType.length
                                }"
                              >
                              {{ handleMessageTypeText(condition) }}
                              <div class="icon-placement-group">
                                <i class="el-icon-arrow-down el-icon--right" :class="'group-placement-'+index"></i>
                              </div>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                <el-checkbox-group 
                                  v-model="condition.messageType"
                                  class="message-type-dropdown"
                                  >
                                  <el-checkbox
                                    v-for="item in searchInList"
                                    class="checkbox"
                                    :key="item.key"
                                    :label="item.apiField"
                                    :disabled="item.disabled"
                                  >
                                    {{ item.label }}
                                  </el-checkbox>
                                </el-checkbox-group> 
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
        
                          <div class="search-wrapper" :class="{'selected-blue': condition.value}">
                            <el-input
                              :class="{'selected-blue remove-border': condition.value}"
                              ref="searchForInput"
                              class="search-for-inp"
                              placeholder="For: Keyword/Phrase"
                              v-model="condition.value"                              
                            ></el-input>
                          </div>
                          
                          <div v-if="index==0" class="action-btn garbage-wrapper"></div>
                          <el-button v-else class="action-btn garbage-wrapper" @click="handleDeleteCondition('groupA', condition)">
                            <div class="grey-trash-icon"></div>
                          </el-button>
                        </div>   
  
                      </div>
    
                      <div class="search-condition-group sub-actions">
                        <el-button 
                          v-if="!isAdvancedSearchConditionsMaxed" 
                          @click="handleAddCondition('groupA')"
                          class="action-btn" 
                        >
                          <div class=btn-body>
                            <div class="blue-plus-icon" ></div>
                            <div>Add condition</div>
                          </div>
                        </el-button>
                        <el-button class="action-btn" @click="handleDeleteGroup('groupA')">
                          <div class=btn-body>
                            <div class="blue-trash-icon"></div>
                            <div>Delete group</div>
                          </div>
                        </el-button>
                      </div>
                    </div>
                  </div>
  
                  <!-- Group A-B Operator -->
                  <div v-if="advancedFilterPayload.groupA && advancedFilterPayload.groupB" class="group-operator">
                    <el-select 
                      ref="outerGroupOperatorDropdown-B"
                      :class="{'selected-blue': advancedFilterPayload.groupOperators.groupBOperator}"
                      v-model="advancedFilterPayload.groupOperators.groupBOperator"
                      popper-class="transcript-search-advanced-search-dropdown" 
                      placeholder="Condition"
                    >
                      <el-option
                        v-for="item in operatorsEnumBetweenGroup"
                        :key="item.key" 
                        :label="item.label"
                        :value="item.key"
                        :disabled="item.disabled"
                        >
                      </el-option>
                    </el-select>
                  </div>
  
                  <!-- Group B -->
                  <div v-if="advancedFilterPayload.groupB" class="group-wrapper">
                    <div>B</div>
  
                    <div class="group">
  
                      <div class="sub-items results-wrapper">
                        <div class="operator-wrapper">                
                          <el-select 
                            ref="innerGroupOperatorDropdown-B"
                            class="selected-blue"
                            v-model="advancedFilterPayload.groupB.operator"                              
                            popper-class="transcript-search-advanced-search-dropdown" 
                          >
                            <el-option
                              v-for="item in operatorsEnum"
                              :key="item.key" 
                              :label="item.label"
                              :value="item.key"
                              :disabled="item.disabled"
                              >
                            </el-option>
                          </el-select>
                        </div>
                        <div>Will apply to each line in this group</div>
                      </div>
  
                      <div class="sub-items">     
                        <div v-for="(condition, index) in advancedFilterPayload.groupB.conditions" :key="index" class="results-wrapper">
                          <!--@focus="onSearchForFocus"
                              @blur="onSearchForBlur" -->
                          <div class="dropdown-wrapper">
                            <el-select 
                              :ref="'searchTypeDropdown-'+(index+20)" 
                              :class="{'selected-blue': condition.searchType}"
                              v-model="condition.searchType"                              
                              popper-class="transcript-search-advanced-search-dropdown" 
                              placeholder="By: Search type"
                            >
                              <el-option
                                v-for="item in searchForList"
                                :key="item.key" 
                                :label="item.label"
                                :value="item.key"
                                :disabled="item.disabled"
                                >
                              </el-option>
                            </el-select>
                          </div>
                          
                          <div class="dropdown-wrapper">
                            <el-dropdown 
                              :ref="'messageTypeDropdown-'+(index+20)"
                              trigger="click"
                              placement="bottom-start"
                              class="select-box"
                              :class="{'selected-blue': condition.messageType.length}"
                              @visible-change="(val) => handleGroupMessageTypeDropdownVisibleChange(val, index+20)"
                            >
                              <span 
                                class="value-box" 
                                :class="{
                                  'placeholder-text': !condition.messageType.length,
                                  'value-text': condition.messageType.length
                                }"
                              >
                              {{ handleMessageTypeText(condition) }}
                              <div class="icon-placement-group">
                                <i class="el-icon-arrow-down el-icon--right" :class="'group-placement-' + (index + 20)"></i>
                              </div>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                <el-checkbox-group 
                                  v-model="condition.messageType"
                                  class="message-type-dropdown"
                                  >
                                  <el-checkbox
                                    v-for="item in searchInList"
                                    class="checkbox"
                                    :key="item.key"
                                    :label="item.apiField"
                                    :disabled="item.disabled"
                                  >
                                    {{ item.label }}
                                  </el-checkbox>
                                </el-checkbox-group> 
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
        
                          <div class="search-wrapper" :class="{'selected-blue': condition.value}">
                            <el-input
                              :class="{'selected-blue remove-border': condition.value}"
                              ref="searchForInput"
                              class="search-for-inp"
                              placeholder="For: Keyword/Phrase"
                              v-model="condition.value"                              
                            ></el-input>
                          </div>
  
                          
                          <el-button v-if="index==0" class="action-btn garbage-wrapper" @click="handleDeleteGroup('groupB')">
                            <div class="grey-trash-icon"></div>
                          </el-button>                        
                          <el-button v-else class="action-btn garbage-wrapper" @click="handleDeleteCondition('groupB', condition)">
                            <div class="grey-trash-icon"></div>
                          </el-button>
                        </div>               
                      </div>
    
                      <div class="search-condition-group sub-actions">
                        <el-button 
                          v-if="!isAdvancedSearchConditionsMaxed" 
                          @click="handleAddCondition('groupB')"
                          class="action-btn" 
                        >
                          <div class=btn-body>
                            <div class="blue-plus-icon"></div>
                            <div>Add condition</div>
                          </div>
                        </el-button>
                        <el-button class="action-btn" @click="handleDeleteGroup('groupB')">
                          <div class=btn-body>
                            <div class="blue-trash-icon"></div>
                            <div>Delete group</div>
                          </div>
                        </el-button>
                      </div>
                    </div>
                  </div>
  
                  <!-- Group B-C Operator -->
                  <div v-if="advancedFilterPayload.groupB && advancedFilterPayload.groupC" class="group-operator">
                    <el-select 
                      ref="outerGroupOperatorDropdown-C"
                      :class="{'selected-blue': advancedFilterPayload.groupOperators.groupCOperator}"
                      placeholder="Condition"
                      v-model="advancedFilterPayload.groupOperators.groupCOperator"
                      popper-class="transcript-search-advanced-search-dropdown" 
                    >
                      <el-option
                        v-for="item in operatorsEnumBetweenGroup"
                        :key="item.key" 
                        :label="item.label"
                        :value="item.key"
                        :disabled="item.disabled"
                        >
                      </el-option>
                    </el-select>
                  </div>
  
                  <!-- Group C -->
                  <div v-if="advancedFilterPayload.groupC" class="group-wrapper">
                    <div>C</div>
  
                    <div class="group">
  
                      <div class="sub-items results-wrapper">
                        <div class="operator-wrapper">                
                          <el-select 
                            ref="innerGroupOperatorDropdown-C"
                            class="selected-blue"
                            v-model="advancedFilterPayload.groupC.operator"                          
                            popper-class="transcript-search-advanced-search-dropdown" 
                          >
                            <el-option
                              v-for="item in operatorsEnum"
                              :key="item.key" 
                              :label="item.label"
                              :value="item.key"
                              :disabled="item.disabled"
                              >
                            </el-option>
                          </el-select>
                        </div>
                        <div>Will apply to each line in this group</div>
                      </div>
  
                      <div class="sub-items">  
                        <div v-for="(condition, index) in advancedFilterPayload.groupC.conditions" :key="index" class="results-wrapper">
                          <!--@focus="onSearchForFocus"
                              @blur="onSearchForBlur" -->
                          <div class="dropdown-wrapper">
                            <el-select 
                              :ref="'searchTypeDropdown-'+(index+40)" 
                              :class="{'selected-blue': condition.searchType}"
                              v-model="condition.searchType"                              
                              popper-class="transcript-search-advanced-search-dropdown" 
                              placeholder="By: Search type"
                            >
                              <el-option
                                v-for="item in searchForList"
                                :key="item.key" 
                                :label="item.label"
                                :value="item.key"
                                :disabled="item.disabled"
                                >
                              </el-option>
                            </el-select>
                          </div>
        
                          <div class="dropdown-wrapper">
                            <el-dropdown 
                              :ref="'messageTypeDropdown-'+(index+40)"
                              trigger="click"
                              placement="bottom-start"
                              class="select-box"
                              :class="{'selected-blue': condition.messageType.length}"
                              @visible-change="(val) => handleGroupMessageTypeDropdownVisibleChange(val, index+40)"
                            >
                              <span 
                                class="value-box" 
                                :class="{
                                  'placeholder-text': !condition.messageType.length,
                                  'value-text': condition.messageType.length
                                }"
                              >
                              {{ handleMessageTypeText(condition) }}
                              <div class="icon-placement-group">
                                <i class="el-icon-arrow-down el-icon--right" :class="'group-placement-' + (index + 40)"></i>
                              </div>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                <el-checkbox-group 
                                  v-model="condition.messageType"
                                  class="message-type-dropdown"
                                  >
                                  <el-checkbox
                                    v-for="item in searchInList"
                                    class="checkbox"
                                    :key="item.key"
                                    :label="item.apiField"
                                    :disabled="item.disabled"
                                  >
                                    {{ item.label }}
                                  </el-checkbox>
                                </el-checkbox-group> 
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
        
                          <div class="search-wrapper" :class="{'selected-blue': condition.value}">
                            <el-input
                              :class="{'selected-blue remove-border': condition.value}"
                              ref="searchForInput"
                              class="search-for-inp"
                              placeholder="For: Keyword/Phrase"
                              v-model="condition.value"
                            ></el-input>
                          </div>
    
                          <el-button v-if="index==0" class="action-btn garbage-wrapper" @click="handleDeleteGroup('groupC')">
                            <div class="grey-trash-icon"></div>
                          </el-button>
                          <el-button v-else class="action-btn garbage-wrapper" @click="handleDeleteCondition('groupC', condition)">
                            <div class="grey-trash-icon"></div>
                          </el-button>
                        </div>                  
                      </div>
    
                      <div class="search-condition-group sub-actions">
                        <el-button 
                          v-if="!isAdvancedSearchConditionsMaxed"
                          @click="handleAddCondition('groupC')"
                          class="action-btn" 
                        >
                          <div class=btn-body>
                            <div class="blue-plus-icon" ></div>
                            <div>Add condition</div>
                          </div>
                        </el-button>
                        <el-button class="action-btn" @click="handleDeleteGroup('groupC')">
                          <div class=btn-body>
                            <div class="blue-trash-icon"></div>
                            <div>Delete group</div>
                          </div>
                        </el-button>
                      </div>
                    </div>
                  </div>

                  <div v-if="advancedFilterPayload.groupC || isAdvancedSearchConditionsMaxed" class="max-constraints-wrapper">
                    <b v-if="advancedFilterPayload.groupC && isAdvancedSearchConditionsMaxed">Max number of conditions and groups reached.</b>
                    <b v-else-if="advancedFilterPayload.groupC">Max number of groups reached.</b>
                    <b v-else-if="isAdvancedSearchConditionsMaxed">Max number of conditions reached.</b>
                  </div>
  
  
                </div>
  
                <div class="search-condition-group">
                  <el-button v-if="!isShowGroups" class="action-btn" @click="handleAddMainCondition">
                    <div class=btn-body>
                      <div class="blue-plus-icon"></div>
                      <div>Add condition</div>
                    </div>
                  </el-button>
                  <el-button v-if="!advancedFilterPayload.groupC && !isAdvancedSearchConditionsMaxed" class="action-btn" @click="handleAddMainGroup">
                    <div class=btn-body>
                      <div class="blue-plus-icon"></div>
                      <div>{{ isShowGroups ? 'Add group' : 'Start group' }}</div>
                    </div>
                  </el-button>
                </div>
              </div>
              <div v-else-if="searchType == '2'">
                <div class="border"></div>
                <div class="sub-items results-wrapper conversation-id">  
                  <div class="search-wrapper" :class="{'selected-blue': advancedFilterPayload.groupA.conditions[0].value}" >
                    <el-input
                      :class="{'selected-blue remove-border': advancedFilterPayload.groupA.conditions[0].value}"
                      ref="searchForInput"
                      class="search-for-inp"
                      placeholder="Conversation ID"
                      v-model="advancedFilterPayload.groupA.conditions[0].value"                              
                    ></el-input>
                  </div>
                </div>
                <div v-if="showWarningMsgForKeywordSearch" class="sub-items results-wrapper">  
                  <b>Please note: </b>Applying this search will remove the previously applied Keyword/Phrase search
                </div>  
              </div>

            </div>
            <div class="divider" />
            <div class="footer">
              <el-button plain class="actions-btn reset" @click="handleResetAllAdvancedSearch"><span>Reset all</span></el-button>
              <div v-if="isShowGroups && searchType != '2'">
                <b>Search summary: </b>
                {{ advancedFilterPayload.groupC ? "(": "" }}{{ advancedFilterPayload.groupA ? "GroupA" : "" }} 
                  {{ advancedFilterPayload.groupOperators.groupBOperator 
                    ? operatorsEnum.find((en) => en.key == advancedFilterPayload.groupOperators.groupBOperator).label 
                    : advancedFilterPayload.groupB ? "[Select Condition]" : ""
                  }} 
                {{ advancedFilterPayload.groupB ? "GroupB" : "" }}{{ advancedFilterPayload.groupC ? ")": "" }}
                  {{ advancedFilterPayload.groupOperators.groupCOperator 
                    ? operatorsEnum.find(en => en.key == advancedFilterPayload.groupOperators.groupCOperator).label 
                    : advancedFilterPayload.groupC ? "[Select Condition]" : ""
                  }} 
                {{ advancedFilterPayload.groupC ? "GroupC" : "" }}

              </div>
              <div class="actions">
                <el-button plain class="actions-btn clear-btn" @click="handleCancelAdvancedSearch"><span class="">Cancel</span></el-button>
                <el-button plain class="actions-btn apply-btn" @click="handleApplyAdvancedSearch" :disabled="isAdvancedSearchApplyDisabled"><span class="">Apply</span></el-button>
              </div>
            </div>
          </div>
        </el-popover>
      </div>
      <div v-if="contactReason && contactReason != ''" class="export-div">
        <el-button  v-if="transcriptSearchResultsComponent && transcriptSearchResultsComponent.totalMatchedConversations>0" class="submit-btn transcript-detail-export-btn" round @click="applyExport">
          <div class="export-icon"></div>
          <span class="export-text">Export</span>
        </el-button>
      </div>
    </div>

    <div class="verticalLine">
      
    </div>
    <el-button :disabled="disabledSearchFilters" class="el-dropdown submit-btn save-transcript-btn" :class="transcriptSearchResultsComponent && savedTranscriptResult ? 'saved-transcript-filter' : ''" @click="toggleSavedTranscriptFilter">
      <span class="text">Saved</span>
    </el-button>
    <el-dropdown v-if="!contactReason" placement="bottom-start" trigger="click" ref="contactReasonFilter" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.contactReasonFilter)">
      <el-button @click="showDropdowns" :disabled="disabledSearchFilters" name="conversation topics dropdown btn" class="other" :class="{'selected':transcriptFilters['topicDisplayNames'] && transcriptFilters['topicDisplayNames'].length>0}">
        <span class="contact-reason reset-btn-icon" :class="{'selected':transcriptFilters['topicDisplayNames'] && transcriptFilters['topicDisplayNames'].length>0}" style="display: none;" @click="resetApply($event, $refs.contactReasonFilter, resetContactReasons)"></span>
        <span class="text filterLabel">Conversation Topics</span>
        <span v-if="transcriptFilters['topicDisplayNames'] && transcriptFilters['topicDisplayNames'].length>0" class="applied-filter-number"></span><i class="el-icon-arrow-down el-icon--right" :class="{'hide':transcriptFilters['topicDisplayNames'] && transcriptFilters['topicDisplayNames'].length>0}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu contact-reasons"
        slot="dropdown"
      >
        <div class="cus-msg-card">
          <div class="contact-reason-label">Conversation Topics</div>
          <div class="btn-select-all" @click="handleCancel($refs.contactReasonFilter)">
            <!-- <img src="../../assets/icons/icon_transcript_close.svg" @click="handleCancel($refs.contactReasonFilter)"> -->
          </div>
          <div class="horizontal-line">
            <div class="search-button material-icons">search</div>
            <input
              ref="contactReasonSearch"
              name="filter"
              type="text"
              class="reg-inp"
              :class="{'input-hight-light': contactReasonKeywords!=''}"
              v-model="contactReasonKeywords"
              placeholder="Search conversation topics"
            /><i v-if="contactReasonKeywords!=''" class="fas fa-times-circle" @click="clearSearch($refs.contactReasonFilter)"></i>
            <br />
            <div class="check-box-section" v-loading="topicFilterLoading">
              <el-checkbox v-if="filterdContactReasons.length > 0" class="checkbox-first-row" v-model="isContactReasonSelectedAll" @change="selectAllContactReasons"
                  label="All"></el-checkbox>
              <span class="no-matching-data-text" v-else>no matching data</span>
              <el-checkbox-group v-model="selectedContactReasons">
                <el-checkbox
                  v-for="(item, index) in filterdContactReasons"
                  :key="index"
                  class="checkbox"
                  :name="item.topicDisplayName"
                  :label="item.topicDisplayName"
                  :title="item.topicDisplayName"
                >
                <span class="display-topic-name">{{item.topicDisplayName}}</span>
                <span class="topic-number"> ({{item.totalVolume * $store.getters.xnumber}})</span></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="card-bottom-part">
            <el-button style="margin-left: 18px" v-if="transcriptFilters['topicDisplayNames'] && transcriptFilters['topicDisplayNames'].length>0" plain class="clear-btn" @click="resetContactReasons()"><span class="clear-filter-text">Reset all</span></el-button>
            <div v-else></div>
            <div class="actions">
              <el-button plain class="clear-btn" @click="handleCancel($refs.contactReasonFilter)"><span class="clear-filter-text">Cancel</span></el-button>
              <el-button plain class="apply-btn" @click="handleApply($refs.contactReasonFilter)"><span>Apply</span></el-button>
            </div>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>

    <!--OC-1805 -->
    <el-dropdown trigger="click" ref="besSignalsFilter" placement="bottom-start" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.besSignalsFilter)">
      <el-button @click="showDropdowns" :disabled="disabledSearchFilters" name="containment dropdown btn" class="other" :class="{'selected':transcriptFilters['besSignals'] && transcriptFilters['besSignals'].length>0}">
        <span class="bes-bas reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.besSignalsFilter, resetBesSignals)"></span>
        <span class="text filterLabel">BES Signals</span>
        <span v-if="transcriptFilters['besSignals'] && transcriptFilters['besSignals'].length>0" class="applied-filter-number"></span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':transcriptFilters['besSignals'] && transcriptFilters['besSignals'].length>0}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu containment"
        slot="dropdown"
      >
        <div class="cus-msg-card">
          <div class="filter-header"> BES Signals

            <div class="btn-select-all" @click="handleCancel($refs.besSignalsFilter)">
              <!-- <img src="../../assets/icons/icon_transcript_close.svg" @click="handleCancel($refs.besSignalsFilter)"> -->
            </div>
          </div>
          <div class="horizontal-line">
            <el-checkbox-group v-model="selectedBesSignals">
              <el-checkbox
                v-for="(item, index) in besSignalsList"
                :key="index"
                class="checkbox"
                :name="item.key"
                :label="item.key"
              >
                <div class="signal-flex">
                  {{item.label}}
                  <el-tooltip effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom" :content="item.tooltipContent">
                    <img class="signal-icon" src="../../assets/icons/icon_info.svg" />
                  </el-tooltip>
                </div>
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="card-bottom-part">
            <el-button v-if="transcriptFilters['besSignals'] && transcriptFilters['besSignals'].length>0" plain class="clear-btn" @click="resetBesSignals()"><span class="clear-filter-text">Reset all</span></el-button>
            <span class="transcript-search-cancel-btn" @click="handleCancel($refs.besSignalsFilter)">Cancel</span>
            <span class="transcript-search-apply-btn" @click="handleApply($refs.besSignalsFilter)">Apply</span>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown trigger="click" ref="basSignalsFilter" placement="bottom-start" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.basSignalsFilter)">
      <el-button @click="showDropdowns" :disabled="disabledSearchFilters" name="containment dropdown btn" class="other" :class="{'selected':transcriptFilters['basSignals'] && transcriptFilters['basSignals'].length>0}">
        <span class="bes-bas reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.basSignalsFilter, resetBasSignals)"></span>
        <span class="text filterLabel">BAS Signals</span>
        <span v-if="transcriptFilters['basSignals'] && transcriptFilters['basSignals'].length>0" class="applied-filter-number"></span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':transcriptFilters['basSignals'] && transcriptFilters['basSignals'].length>0}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu containment"
        slot="dropdown"
      >
        <div class="cus-msg-card">
          <div class="filter-header"> BAS Signals

            <div class="btn-select-all" @click="handleCancel($refs.basSignalsFilter)">
              <!-- <img src="../../assets/icons/icon_transcript_close.svg" @click="handleCancel($refs.basSignalsFilter)"> -->
            </div>
          </div>
          <div class="horizontal-line">
            <el-checkbox-group v-model="selectedBasSignals">
              <el-checkbox
                v-for="(item, index) in basSignalsList"
                :key="index"
                class="checkbox"
                :name="item.key"
                :label="item.key"
              >
                <div class="signal-flex">
                  {{item.label}}
                  <el-tooltip effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom" :content="item.tooltipContent">
                    <img class="signal-icon" src="../../assets/icons/icon_info.svg" />
                  </el-tooltip>
                </div>
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="card-bottom-part">
            <el-button v-if="transcriptFilters['basSignals'] && transcriptFilters['basSignals'].length>0" plain class="clear-btn" @click="resetBasSignals()"><span class="clear-filter-text">Reset all</span></el-button>
            <span class="transcript-search-cancel-btn" @click="handleCancel($refs.basSignalsFilter)">Cancel</span>
            <span class="transcript-search-apply-btn" @click="handleApply($refs.basSignalsFilter)">Apply</span>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
    <!--OC-1805 -->

    <el-dropdown trigger="click" ref="containmentFilter" placement="bottom-start" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.containmentFilter)">
      <el-button @click="showDropdowns" :disabled="disabledSearchFilters" name="containment dropdown btn" class="other" :class="{'selected':transcriptFilters['conversationTypes'] && transcriptFilters['conversationTypes'].length>0}">
        <span class="containment reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.containmentFilter, resetContainment)"></span>
        <span class="text filterLabel">Containment</span>
        <span v-if="transcriptFilters['conversationTypes'] && transcriptFilters['conversationTypes'].length>0" class="applied-filter-number"></span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':transcriptFilters['conversationTypes'] && transcriptFilters['conversationTypes'].length>0}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu containment"
        slot="dropdown"
      >
        <div class="cus-msg-card">
          <div class="filter-header"> Containment

            <div class="btn-select-all" @click="handleCancel($refs.containmentFilter)">
              <!-- <img src="../../assets/icons/icon_transcript_close.svg" @click="handleCancel($refs.containmentFilter)"> -->
            </div>
          </div>
          <div class="horizontal-line">
            <el-checkbox-group v-model="selectedContainment">
              <el-checkbox
                v-for="(item, index) in containmentList"
                :key="index"
                class="checkbox"
                :name="item.key"
                :label="item.key"
                :disabled="isDisableItem(item)"
              >{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="card-bottom-part">
            <el-button v-if="transcriptFilters['conversationTypes'] && transcriptFilters['conversationTypes'].length>0" plain class="clear-btn" @click="resetContainment()"><span class="clear-filter-text">Reset all</span></el-button>
            <span class="transcript-search-cancel-btn" @click="handleCancel($refs.containmentFilter)">Cancel</span>
            <span class="transcript-search-apply-btn" @click="handleApply($refs.containmentFilter)">Apply</span>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dropdown placement="bottom-start" trigger="click" ref="responseNameFilter" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.responseNameFilter)">
      <el-button @click="showDropdowns" :disabled="disabledSearchFilters" name="conversation topics dropdown btn" class="other" :class="{'selected':transcriptFilters['responseNames'] && transcriptFilters['responseNames'].length>0}">
        <span class="response-names reset-btn-icon" :class="{'selected':transcriptFilters['responseNames'] && transcriptFilters['responseNames'].length>0}" style="display: none;" @click="resetApply($event, $refs.responseNameFilter, resetResponseName)"></span>
        <span class="text filterLabel">Response Names</span>
        <span v-if="transcriptFilters['responseNames'] && transcriptFilters['responseNames'].length>0" class="applied-filter-number"></span><i class="el-icon-arrow-down el-icon--right" :class="{'hide':transcriptFilters['responseNames'] && transcriptFilters['responseNames'].length>0}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu response-names"
        slot="dropdown"
      >
        <div class="cus-msg-card">
          <div class="contact-reason-label">Response Names</div>
          <div class="btn-select-all" @click="handleCancel($refs.responseNameFilter)">
          </div>
          <div class="horizontal-line">
            <div class="search-button material-icons">search</div>
            <input
              ref="responseNameSearch"
              name="filter"
              type="text"
              class="reg-inp"
              :class="{'input-hight-light': responseNameKeywords!=''}"
              v-model="responseNameKeywords"
              placeholder="Search response names"
            /><i v-if="responseNameKeywords!=''" class="fas fa-times-circle" @click="clearSearch($refs.responseNameFilter)"></i>
            <br />
            <div class="check-box-section" v-loading="topicFilterLoading">
              <el-checkbox v-if="filteredResponseNames.length > 0" class="checkbox-first-row" v-model="isResponseNameSelectedAll" @change="selectAllResponseNames"
                  label="All"></el-checkbox>
              <span class="no-matching-data-text" v-else>no matching data</span>
              <el-checkbox-group v-model="selectedResponseNames">
                <el-checkbox
                  v-for="(item, index) in filteredResponseNames"
                  :key="index"
                  class="checkbox"
                  :name="item.responseName"
                  :label="item.responseName"
                  :title="item.responseName"
                >
                <span class="display-topic-name">{{item.responseName}}</span>
                <span class="topic-number"> ({{item.totalVolume * $store.getters.xnumber}})</span></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="card-bottom-part">
            <el-button style="margin-left: 18px" v-if="transcriptFilters['responseNames'] && transcriptFilters['responseNames'].length>0" plain class="clear-btn" @click="resetResponseName()"><span class="clear-filter-text">Reset all</span></el-button>
            <div v-else></div>
            <div class="actions">
              <el-button plain class="clear-btn" @click="handleCancel($refs.responseNameFilter)"><span class="clear-filter-text">Cancel</span></el-button>
              <el-button plain class="apply-btn" @click="handleApply($refs.responseNameFilter)"><span>Apply</span></el-button>
            </div>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dropdown placement="bottom-start" trigger="click" ref="intentNameFilter" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.intentNameFilter)">
      <el-button @click="showDropdowns" :disabled="disabledSearchFilters" name="conversation topics dropdown btn" class="other" :class="{'selected':transcriptFilters['intentNames'] && transcriptFilters['intentNames'].length>0}">
        <span class="intent-names reset-btn-icon" :class="{'selected':transcriptFilters['intentNames'] && transcriptFilters['intentNames'].length>0}" style="display: none;" @click="resetApply($event, $refs.intentNameFilter, resetIntentNames)"></span>
        <span class="text filterLabel">Intent Names</span>
        <span v-if="transcriptFilters['intentNames'] && transcriptFilters['intentNames'].length>0" class="applied-filter-number"></span><i class="el-icon-arrow-down el-icon--right" :class="{'hide':transcriptFilters['intentNames'] && transcriptFilters['intentNames'].length>0}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu intent-names"
        slot="dropdown"
      >
        <div class="cus-msg-card">
          <div class="contact-reason-label">Intent Names</div>
          <div class="btn-select-all" @click="handleCancel($refs.intentNameFilter)">
          </div>
          <div class="horizontal-line">
            <div class="search-button material-icons">search</div>
            <input
              ref="relatedTopicSearch"
              name="filter"
              type="text"
              class="reg-inp"
              :class="{'input-hight-light': intentNameKeywords!=''}"
              v-model="intentNameKeywords"
              placeholder="Search intent names"
            /><i v-if="intentNameKeywords!=''" class="fas fa-times-circle" @click="clearSearch($refs.intentNameFilter)"></i>
            <br />
            <div class="check-box-section" v-loading="topicFilterLoading">
              <el-checkbox v-if="filteredIntentNames.length > 0" class="checkbox-first-row" v-model="isIntentNameSelectedAll" @change="selectAllIntentNames"
                  label="All"></el-checkbox>
              <span class="no-matching-data-text" v-else>no matching data</span>
              <el-checkbox-group v-model="selectedIntentNames">
                <el-checkbox
                  v-for="(item, index) in filteredIntentNames"
                  :key="index"
                  class="checkbox"
                  :name="item.intentName"
                  :label="item.intentName"
                  :title="item.intentName"
                >
                <span class="display-topic-name">{{item.intentName}}</span>
                <span class="topic-number"> ({{item.totalVolume * $store.getters.xnumber}})</span></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="card-bottom-part">
            <el-button style="margin-left: 18px" v-if="transcriptFilters['intentNames'] && transcriptFilters['intentNames'].length>0" plain class="clear-btn" @click="resetIntentNames()"><span class="clear-filter-text">Reset all</span></el-button>
            <div v-else></div>
            <div class="actions">
              <el-button plain class="clear-btn" @click="handleCancel($refs.intentNameFilter)"><span class="clear-filter-text">Cancel</span></el-button>
              <el-button plain class="apply-btn" @click="handleApply($refs.intentNameFilter)"><span>Apply</span></el-button>
            </div>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dropdown placement="bottom-start" trigger="click" ref="relatedTopicsFilter" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.relatedTopicsFilter)">
      <el-button @click="showDropdowns" :disabled="disabledSearchFilters" name="conversation topics dropdown btn" class="other" :class="{'selected':transcriptFilters['relatedTopics'] && transcriptFilters['relatedTopics'].length>0}">
        <span class="related-topics reset-btn-icon" :class="{'selected':transcriptFilters['relatedTopics'] && transcriptFilters['relatedTopics'].length>0}" style="display: none;" @click="resetApply($event, $refs.relatedTopicsFilter, resetRelatedTopics)"></span>
        <span class="text filterLabel">Related Topics</span>
        <span v-if="transcriptFilters['relatedTopics'] && transcriptFilters['relatedTopics'].length>0" class="applied-filter-number"></span><i class="el-icon-arrow-down el-icon--right" :class="{'hide':transcriptFilters['relatedTopics'] && transcriptFilters['relatedTopics'].length>0}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu related-topics"
        slot="dropdown"
      >
        <div class="cus-msg-card">
          <div class="contact-reason-label">Related Topics</div>
          <div class="btn-select-all" @click="handleCancel($refs.relatedTopicsFilter)">
          </div>
          <div class="horizontal-line">
            <div class="search-button material-icons">search</div>
            <input
              ref="relatedTopicSearch"
              name="filter"
              type="text"
              class="reg-inp"
              :class="{'input-hight-light': relatedTopicKeywords!=''}"
              v-model="relatedTopicKeywords"
              placeholder="Search related topics"
            /><i v-if="relatedTopicKeywords!=''" class="fas fa-times-circle" @click="clearSearch($refs.relatedTopicsFilter)"></i>
            <br />
            <div class="check-box-section" v-loading="topicFilterLoading">
              <el-checkbox v-if="filteredRelatedTopics.length > 0" class="checkbox-first-row" v-model="isRelatedTopicsSelectedAll" @change="selectAllRelatedTopics"
                  label="All"></el-checkbox>
              <span class="no-matching-data-text" v-else>no matching data</span>
              <el-checkbox-group v-model="selectedRelatedTopics">
                <el-checkbox
                  v-for="(item, index) in filteredRelatedTopics"
                  :key="index"
                  class="checkbox"
                  :name="item.topicName"
                  :label="item.topicName"
                  :title="item.topicName"
                >
                <span class="display-topic-name">{{item.topicName}}</span>
                <span class="topic-number"> ({{item.totalVolume * $store.getters.xnumber}})</span></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="card-bottom-part">
            <el-button style="margin-left: 18px" v-if="transcriptFilters['relatedTopics'] && transcriptFilters['relatedTopics'].length>0" plain class="clear-btn" @click="resetRelatedTopics()"><span class="clear-filter-text">Reset all</span></el-button>
            <div v-else></div>
            <div class="actions">
              <el-button plain class="clear-btn" @click="handleCancel($refs.relatedTopicsFilter)"><span class="clear-filter-text">Cancel</span></el-button>
              <el-button plain class="apply-btn" @click="handleApply($refs.relatedTopicsFilter)"><span>Apply</span></el-button>
            </div>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dropdown trigger="click" ref="handlingTimeFilter" placement="bottom-start" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.handlingTimeFilter)">
      <el-button :disabled="disabledSearchFilters" name="handling time dropdown btn" class="other" :class="{'selected':localFilters.handlingTime.updated}">
        <span class="handling-time reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.handlingTimeFilter, resetHandlingTimeRange)"></span>
        <span class="text filterLabel">Total Handling Time</span>
        <span v-if="localFilters.handlingTime.updated" class="applied-filter-number"></span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':localFilters.handlingTime.updated}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu handling-time"
        slot="dropdown"
      >
        <div class="cus-msg-card handling-time">

          <div class="filter-header">
            Total Handling Time

            <div class="btn-select-all" @click="handleCancel($refs.handlingTimeFilter)">
            </div>
            <div v-show="handlingTimeHasError" class="invalid-time-range">
              You have entered an invalid time range
            </div>
          </div>
          <div class="horizontal-line">
            <div class="time">
              <wy-time-picker
                v-model="handlingTimeFilter.fromValue"
                format="hh:mm:ss"
                :timePickerInputHasError="handlingTimeHasError"
                manual-input
                :componentType="'transcriptSearch'"
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
              <span class="dash">-</span>
              <wy-time-picker
                v-model="handlingTimeFilter.toValue"
                format="hh:mm:ss"
                :timePickerInputHasError="handlingTimeHasError"
                manual-input
                :componentType="'transcriptSearch'"
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
            </div>
            <div class="flex">
              <div v-if="localFilters.handlingTime.minHandlingTimeDisplay" class="min-hint">Min: {{localFilters.handlingTime.minHandlingTimeDisplay.hh}}:{{localFilters.handlingTime.minHandlingTimeDisplay.mm}}:{{localFilters.handlingTime.minHandlingTimeDisplay.ss}}</div>
              <div v-if="localFilters.handlingTime.maxHandlingTimeDisplay" class="max-hint"> Max: {{localFilters.handlingTime.maxHandlingTimeDisplay.hh}}:{{localFilters.handlingTime.maxHandlingTimeDisplay.mm}}:{{localFilters.handlingTime.maxHandlingTimeDisplay.ss}}</div>
            </div>
          </div>
          <div class="card-bottom-part">
            <el-button v-if="localFilters.handlingTime.updated" plain class="clear-btn" @click="resetHandlingTimeRange()"><span class="clear-filter-text">Reset all</span></el-button>
            <span class="transcript-search-cancel-btn" @click="handleCancel($refs.handlingTimeFilter)">Cancel</span>
            <span class="transcript-search-apply-btn" @click="handleApply($refs.handlingTimeFilter)">Apply</span>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- <el-dropdown trigger="click" ref="responseTimeFilter" placement="bottom-start" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.responseTimeFilter)">
      <el-button :disabled="disabledSearchFilters" name="res time dropdown btn" class="other" :class="{'selected':localFilters.responseTime.updated}">
        <span class="response-time reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.responseTimeFilter, resetResponseTimeRange)"></span>
        <span class="text filterLabel">Response Time</span>
        <span v-if="localFilters.responseTime.updated" class="applied-filter-number"></span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':localFilters.responseTime.updated}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu response-time"
        slot="dropdown"
      >
        <div class="cus-msg-card response-time">
          <div class="filter-header">
            Response Time

            <div class="btn-select-all" @click="handleCancel($refs.responseTimeFilter)">
            </div>

            <div v-show="responseTimeHasError" class="invalid-time-range">
              You have entered an invalid time range
            </div>
          </div>
          <div class="horizontal-line">
            <div class="time">
              <wy-time-picker
                v-model="responseTimeFilter.fromValue"
                format="hh:mm:ss"
                :timePickerInputHasError="responseTimeHasError"
                end="200"
                :componentType="'transcriptSearch'"
                manual-input
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
              <span class="dash">-</span>
              <wy-time-picker
                v-model="responseTimeFilter.toValue"
                format="hh:mm:ss"
                :componentType="'transcriptSearch'"
                :timePickerInputHasError="responseTimeHasError"
                manual-input
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
            </div>
            <div class="flex">
              <div v-if="localFilters.responseTime.minResponseTimeDisplay" class="min-hint">Min: {{localFilters.responseTime.minResponseTimeDisplay.hh}}:{{localFilters.responseTime.minResponseTimeDisplay.mm}}:{{localFilters.responseTime.minResponseTimeDisplay.ss}}</div>
              <div v-if="localFilters.responseTime.maxResponseTimeDisplay" class="max-hint"> Max: {{localFilters.responseTime.maxResponseTimeDisplay.hh}}:{{localFilters.responseTime.maxResponseTimeDisplay.mm}}:{{localFilters.responseTime.maxResponseTimeDisplay.ss}}</div>
            </div>
          </div>
          <div class="card-bottom-part">
            <el-button v-if="localFilters.responseTime.updated" plain class="clear-btn" @click="resetResponseTimeRange()"><span class="clear-filter-text">Reset all</span></el-button>
            <span class="transcript-search-cancel-btn" @click="handleCancel($refs.responseTimeFilter)">Cancel</span>
            <span class="transcript-search-apply-btn" @click="handleApply($refs.responseTimeFilter)">Apply</span>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown> -->

    <el-dropdown trigger="click" ref="sentimentFilter" placement="bottom-start" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.sentimentFilter)">
      <el-button :disabled="disabledSearchFilters" name="sentiment dropdown btn" class="other" :class="{'selected':transcriptFilters['sentiment'] && transcriptFilters['sentiment'].length>0}">
        <span class="sentiment reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.sentimentFilter, resetSentiment)"></span>
        <span class="text filterLabel">Sentiment</span>
        <span v-if="transcriptFilters['sentiment'] && transcriptFilters['sentiment'].length>0" class="applied-filter-number"></span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':transcriptFilters['sentiment'] && transcriptFilters['sentiment'].length>0}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu sentiment"
        slot="dropdown"
      >
        <div class="cus-msg-card">
          <div class="filter-header">Sentiment (Overall)

            <div class="btn-select-all" @click="handleCancel($refs.sentimentFilter)">
              <!-- <img src="../../assets/icons/icon_transcript_close.svg" @click="handleCancel($refs.sentimentFilter)"> -->
            </div>
          </div>
          <div class="horizontal-line-senti">
            <el-checkbox-group v-model="selectedSentiment">
              <el-checkbox
                v-for="(item, index) in sentimentList"
                :key="index"
                class="checkbox"
                :name="item.key"
                :label="item.key"
              >{{item.label}}</el-checkbox>
            </el-checkbox-group
            ><br />
          </div>
          <div class="card-bottom-part">
            <el-button v-if="transcriptFilters['sentiment'] && transcriptFilters['sentiment'].length>0" plain class="clear-btn" @click="resetSentiment()"><span class="clear-filter-text">Reset all</span></el-button>
            <span class="transcript-search-cancel-btn" @click="handleCancel($refs.sentimentFilter)">Cancel</span>
            <span class="transcript-search-apply-btn" @click="handleApply($refs.sentimentFilter)">Apply</span>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dropdown trigger="click" ref="feedbackFilter" placement="bottom-start" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.feedbackFilter)">
      <el-button :disabled="disabledSearchFilters" name="feedback dropdown btn" class="other" :class="{'selected':transcriptFilters['feedback'] && transcriptFilters['feedback'].length>0}">
        <span class="feedback reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.feedbackFilter, resetFeedback)"></span>
        <span class="text filterLabel">Feedback</span>
        <span v-if="transcriptFilters['feedback'] && transcriptFilters['feedback'].length>0" class="applied-filter-number"></span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':transcriptFilters['feedback'] && transcriptFilters['feedback'].length>0}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu feedback"
        slot="dropdown"
      >
        <div class="cus-msg-card">
          <div class="filter-header">Feedback

            <div class="btn-select-all" @click="handleCancel($refs.feedbackFilter)">
              <!-- <img src="../../assets/icons/icon_transcript_close.svg" @click="handleCancel($refs.feedbackFilter)"> -->
            </div>
          </div>
          <div class="horizontal-line-senti">
            <el-checkbox-group v-model="selectedFeedback">
              <el-checkbox
                v-for="(item, index) in feedbackList"
                :key="index"
                class="checkbox"
                :name="item.key"
                :label="item.key"
              >{{item.label}}</el-checkbox>
            </el-checkbox-group
            ><br />
          </div>
          <div class="card-bottom-part">
            <el-button v-if="transcriptFilters['feedback'] && transcriptFilters['feedback'].length>0" plain class="clear-btn" @click="resetFeedback()"><span class="clear-filter-text">Reset all</span></el-button>
            <span class="transcript-search-cancel-btn" @click="handleCancel($refs.feedbackFilter)">Cancel</span>
            <span class="transcript-search-apply-btn" @click="handleApply($refs.feedbackFilter)">Apply</span>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- hide for OC-1171
    <el-dropdown trigger="click" ref="handoffsFilter" placement="bottom-start" :show-timeout=0 :hide-timeout=0 @visible-change="handleChangeVisible($event, $refs.handoffsFilter)">
      <el-button :disabled="disabledSearchFilters" name="handoffs dropdown btn" class="other" :class="{'selected':localFilters.handOffs.updated}">
        <span class="hand-offs reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.handoffsFilter, resetHandoffs)"></span>
        <span class="text filterLabel">Handoffs</span>
        <span v-if="localFilters.handOffs.updated" class="applied-filter-number"></span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':localFilters.handOffs.updated}"></i>
      </el-button>
      <el-dropdown-menu
        class="wy-analytics-transcript-search-dropdown-menu handoffs"
        slot="dropdown"
      >
        <div class="cus-msg-card handoffs">
          <div class="filter-header">
            Handoffs

            <div class="btn-select-all">
              <img src="../../assets/icons/icon_transcript_close.svg" @click="handleCancel($refs.handoffsFilter)">
            </div>
            <div v-show="handOffsHasError" class="invalid-time-range">
              You have entered an invalid Handoffs range
            </div>
          </div>
          <div class="horizontal-line">
            <div><span class="min-handoffs-label">Min</span><span class="max-handoffs-label">Max</span></div>
            <div class="time">
              <el-input-number
                v-model="handOffsFilter.fromValue"
                :min=0
                :max=10000
                :step=1
                :class="[handOffsHasError ? 'has-error' : handOffsMin && 'is-focused']"
                @focus="handOffsFocusMin"
                @blur="handOffsFocusMin"
                width="40"
                size="mini"
                controls-position="right"
                >
                <el-icon><CaretTop /></el-icon>
              </el-input-number>
              <span class="dash">-</span>
              <el-input-number
                v-model="handOffsFilter.toValue"
                :min=0
                :max=10000
                :step=1
                :class="[handOffsHasError ? 'has-error' : handOffsMax && 'is-focused']"
                @focus="handOffsFocusMax"
                @blur="handOffsFocusMax"
                width="40"
                size="mini"
                controls-position="right">
              </el-input-number>
            </div>
            <div class="flex">
              <div class="min-hint">Min: {{localFilters.handOffs.minHandOffs}}</div>
              <div class="max-hint"> Max: {{localFilters.handOffs.maxHandOffs}}</div>
            </div>
          </div>
          <div class="card-bottom-part">
            <el-button v-if="localFilters.handOffs.updated" plain class="clear-btn" @click="resetHandoffs()"><span class="clear-filter-text">Reset all</span></el-button>
            <span class="transcript-search-cancel-btn" @click="handleCancel($refs.handoffsFilter)">Cancel</span>
            <span class="transcript-search-apply-btn" @click="handleApply($refs.handoffsFilter)">Apply</span>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
    -->
    <el-popover v-model="showAgentFilters" placement="bottom-start" popper-class="wy-analytics-transcript-search-dropdown-menu agents" trigger="click" ref="localAgentFilter"
      v-if="dataModel.filters && dataModel.filters.sources && (dataModel.filters.sources.value.includes('BotToLC') || dataModel.filters.sources.value.includes('LCOnly'))"
      @hide="handleHideAllFilters($refs.localAgentFilter,'Agent Filters')" @show="handleShowAllFilters($refs.localAgentFilter)" class="el-dropdown" :class="{'selected':(transcriptFilters['agentQueues'] && transcriptFilters['agentQueues'].length>0)||
      (transcriptFilters['agentGroups'] && transcriptFilters['agentGroups'].length>0)||(transcriptFilters['agentIds'] && transcriptFilters['agentIds'].length>0)}">
      <div class="cus-msg-card">
        <div class="agent-title">Agent Filters
          <div class="btn-select-all" @click="handleAgentCancel">
            <!-- <img src="../../assets/icons/icon_transcript_close.svg" @click="handleAgentCancel"> -->
          </div>
        </div>
        <div ref="agentFilterContent" class="horizontal-line" style="width: 99%">
          <div  class="filter-section mutiple-select-section agent-queues">
            <div class="agent-dropdown">
            <wy-filter-item-multi-select class="transcript-search" ref="localAgentQueuesDropdown" v-if="localAgentQueues
                && dataModel.filters && dataModel.filters.sources && (dataModel.filters.sources.value.includes('BotToLC') || dataModel.filters.sources.value.includes('LCOnly'))"
                :agent = "true" className="agent-popper"
                :filter="localAgentQueues" :dataSource="agentQueuesDataSource" :filterChangedCallback="agentQueuesChangedCallback" />
                </div>
          </div>
          <div class="filter-section mutiple-select-section agent-groups">
            <wy-filter-item-multi-select ref="localAgentGroupsDropdown" v-if="localAgentGroups
                && dataModel.filters && dataModel.filters.sources && (dataModel.filters.sources.value.includes('BotToLC') || dataModel.filters.sources.value.includes('LCOnly'))"
                :agent = "true" className="agent-popper"
                :filter="localAgentGroups" :dataSource="agentGroupsDataSource" :filterChangedCallback="agentGroupsChangedCallback" />
          </div>
          <div class="filter-section mutiple-select-section agent-ids">
                <wy-filter-item-multi-select ref="localAgentIdsDropdown" v-if="localAgentIds
                && dataModel.filters && dataModel.filters.sources && (dataModel.filters.sources.value.includes('BotToLC') || dataModel.filters.sources.value.includes('LCOnly'))"
                :agent = "true" className="agent-popper"
                :filter="localAgentIds" :dataSource="agentIdsDataSource" :filterChangedCallback="agentIdsChangedCallback" />
          </div>

          <div class="agent-time-filter">
            <div class="agent-time-title">
              Agent Handling Time:
              <div v-show="agentHandlingTimeHasError" class="invalid-time-range">
                You have entered an invalid time range
              </div>
            </div>
            <div class="time">
              <wy-time-picker
                ref="agentHandlingTimeFilter"
                v-model="agentHandlingTimeFilter.fromValue"
                format="hh:mm:ss"
                :timePickerInputHasError="agentHandlingTimeHasError"
                :componentType="'transcriptSearch'"
                end="200"
                manual-input
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
              <span class="dash">-</span>
              <wy-time-picker
                v-model="agentHandlingTimeFilter.toValue"
                format="hh:mm:ss"
                :timePickerInputHasError="agentHandlingTimeHasError"
                :componentType="'transcriptSearch'"
                manual-input
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
            </div>
            <div class="flex">
              <div v-if="localFilters.agentHandlingTime.minAgentHandlingTimeDisplay" class="min-hint">Min: {{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.hh}}:{{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.mm}}:{{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.ss}}</div>
              <div v-if="localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay" class="max-hint">Max: {{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.hh}}:{{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.mm}}:{{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.ss}}</div>
            </div>
          </div>  

          <div class="agent-time-filter">
            <div class="agent-time-title">
              Agent Response Time:
              <div v-show="agentResponseTimeHasError" class="invalid-time-range">
                You have entered an invalid time range
              </div>
            </div>
            <div class="time">
              <wy-time-picker
                ref="agentResponseTimeFilter"
                v-model="agentResponseTimeFilter.fromValue"
                format="hh:mm:ss"
                :timePickerInputHasError="agentResponseTimeHasError"
                :componentType="'transcriptSearch'"
                end="200"
                manual-input
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
              <span class="dash">-</span>
              <wy-time-picker
                v-model="agentResponseTimeFilter.toValue"
                format="hh:mm:ss"
                :timePickerInputHasError="agentResponseTimeHasError"
                :componentType="'transcriptSearch'"
                manual-input
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
            </div>
            <div class="flex">
              <div v-if="localFilters.agentResponseTime.minAgentResponseTimeDisplay" class="min-hint">Min: {{localFilters.agentResponseTime.minAgentResponseTimeDisplay.hh}}:{{localFilters.agentResponseTime.minAgentResponseTimeDisplay.mm}}:{{localFilters.agentResponseTime.minAgentResponseTimeDisplay.ss}}</div>
              <div v-if="localFilters.agentResponseTime.maxAgentResponseTimeDisplay" class="max-hint">Max: {{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.hh}}:{{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.mm}}:{{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.ss}}</div>
            </div>
          </div>

          <div class="agent-time-filter">
            <div class="agent-time-title">
              Agent Wait Time:
              <div v-show="agentWaitTimeHasError" class="invalid-time-range">
                You have entered an invalid time range
              </div>
            </div>
            <div class="time">
              <wy-time-picker
                ref="agentWaitTimeFilter"
                v-model="agentWaitTimeFilter.fromValue"
                format="hh:mm:ss"
                :timePickerInputHasError="agentWaitTimeHasError"
                :componentType="'transcriptSearch'"
                end="200"
                manual-input
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
              <span class="dash">-</span>
              <wy-time-picker
                v-model="agentWaitTimeFilter.toValue"
                format="hh:mm:ss"
                :timePickerInputHasError="agentWaitTimeHasError"
                :componentType="'transcriptSearch'"
                manual-input
                hide-dropdown
                input-width="130px"
              ></wy-time-picker>
            </div>
            <div class="flex">
              <div v-if="localFilters.agentWaitTime.minAgentWaitTimeDisplay" class="min-hint">Min: {{localFilters.agentWaitTime.minAgentWaitTimeDisplay.hh}}:{{localFilters.agentWaitTime.minAgentWaitTimeDisplay.mm}}:{{localFilters.agentWaitTime.minAgentWaitTimeDisplay.ss}}</div>
              <div v-if="localFilters.agentWaitTime.maxAgentWaitTimeDisplay" class="max-hint">Max: {{localFilters.agentWaitTime.maxAgentWaitTimeDisplay.hh}}:{{localFilters.agentWaitTime.maxAgentWaitTimeDisplay.mm}}:{{localFilters.agentWaitTime.maxAgentWaitTimeDisplay.ss}}</div>
            </div>
          </div>

        </div>
        
        <div class="card-bottom-part">
          <el-button v-if="(transcriptFilters['agentQueues'] && transcriptFilters['agentQueues'].length>0)||
            (transcriptFilters['agentGroups'] && transcriptFilters['agentGroups'].length>0)||
            (transcriptFilters['agentIds'] && transcriptFilters['agentIds'].length>0) ||
            (localFilters.agentHandlingTime.updated) ||
            (localFilters.agentResponseTime.updated) ||
            (localFilters.agentWaitTime.updated)"
            plain class="clear-btn" @click="resetAgents()">
              <span class="clear-filter-text">Reset all</span>
            </el-button>
          <span class="transcript-search-cancel-btn" @click="handleAgentCancel">Cancel</span>
          <span class="transcript-search-apply-btn" @click="handleHideAllFilters($refs.localAgentFilter, 'Agent Filters')">Apply</span>
        </div>
      </div>
      <el-button slot="reference" @click="showDropdownsAgentFilters" :disabled="disabledSearchFilters" name="containment dropdown btn" class="other" :class="{'selected':localFilters.agent.updated}">
          <span class="agent reset-btn-icon" style="display: none;" @click="resetAgentApply($event, $refs.localAgentFilter)"></span>
          <span class="text">Agent Filters</span>
          <span v-if="localFilters.agent.updated" class="applied-filter-number"></span>
          <i class="el-icon-arrow-down el-icon--right" :class="{'hide':localFilters.agent.updated}"></i>
      </el-button>
    </el-popover>

    <div class="last-verticalLine"/>

    <el-popover
      placement="bottom-start"
      width="160"
      ref="allFilters"
      v-model="showAllFilters"
      class="el-dropdown"
      popper-class = 'allFilters-popover contact-reason-transcript'
      @show="handleShowAllFilters($refs.allFilters)"
      @hide="handleHideAllFilters($refs.allFilters, 'All Filters')">
      <div ref="allFiltersCard" class="cus-msg-card all-filter-card">
        <div class="filter-header"> All Filters

        <div class="btn-select-all" @click="handleCancelAllfilters">
          <!-- <img src="../../assets/icons/icon_transcript_close.svg" @click="handleCancelAllfilters"> -->
        </div>
        </div>
        <div ref="contentEl" class="content">
          <div class="horizontal-line">

            <div class="contact-reasons" v-if="!contactReason">
              <div class="all-filter-top-two-title"> Conversation Topics </div>

              <el-dropdown ref="contactReasonFilterAllFilter" @visible-change="handleChangeVisible($event, $refs.contactReasonFilterAllFilter)" trigger="click" placement="bottom-start">
                <el-button @click="showDropdowns" plain class="contact-reasons-dropdown">
                  <span v-if="selectedContactReasons.length==0 || selectedContactReasons.length==this.contactReasonsList.length" class="contact-reason-dropdown-text-all">All selected</span>
                  <span v-else-if="selectedContactReasons.length==1" class="contact-reason-dropdown-text grey-shade">{{handleEllipsis(selectedContactReasons[0])}}</span>
                  <span v-else-if="selectedContactReasons.length>1" class="contact-reason-dropdown-text grey-shade">{{handleEllipsis(selectedContactReasons[0])}} + {{selectedContactReasons.length - 1}}</span>
                  <i :class="selectedContactReasons.length==0 || selectedContactReasons.length==this.contactReasonsList.length ? 'el-icon-arrow-down el-icon--right' : 'el-icon-arrow-down el-icon--right-selected'"></i>
                </el-button>
                <el-dropdown-menu ref="dropdownBtn" slot="dropdown" class="all-filters-contact-reasons">
                  <div class="cus-msg-card">
                    <div class="horizontal-line">
                      <input
                        ref="contactReasonSearchAllFilter"
                        name="filter"
                        type="text"
                        class="reg-inp"
                        :class="{'input-hight-light': contactReasonKeywords!=''}"
                        v-model="contactReasonKeywords"
                        placeholder="Search conversation topics"
                      />
                      <i v-if="contactReasonKeywords!=''" class="fas fa-times-circle circle-all-filter" @click="clearSearch($refs.contactReasonFilterAllFilter)"></i>
                      <!-- <div class="btn-select-all" v-if="filterdContactReasons.length>0&&filterdContactReasons.length == selectedContactReasons.length" @click="resetContactReasons">Remove all</div> -->
                      <!-- <div class="btn-select-all" v-else @click="selectAllContactReasons">Select all</div> -->
                      <br />
                      <div class="check-box-section" v-loading="topicFilterLoading">
                        <el-checkbox v-if="filterdContactReasons.length > 0" class="checkbox" v-model="isContactReasonSelectedAll" @change="selectAllContactReasons"
                          label="All"></el-checkbox>
                          <span class="no-matching-data-text" v-else>no matching data</span>
                        <el-checkbox-group v-model="selectedContactReasons">
                          <el-checkbox
                            v-for="(item, index) in filterdContactReasons"
                            :key="index"
                            class="checkbox"
                            :name="item.topicDisplayName"
                            :label="item.topicDisplayName"
                            :title="item.topicDisplayName"
                          >
                          <span class="display-topic-name">{{item.topicDisplayName}}</span>
                          <span class="topic-number"> ({{item.totalVolume}})</span></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <div class="contact-reasons">
              <div class="all-filter-top-two-title">Response Names</div>
              <el-dropdown ref="responseNameFilterAllFilter" @visible-change="handleChangeVisible($event, $refs.responseNameFilterAllFilter)" trigger="click" placement="bottom-start">
                <el-button @click="showDropdowns" plain class="contact-reasons-dropdown">
                  <span v-if="selectedResponseNames.length==0 || selectedResponseNames.length==this.responseNameList.length" class="contact-reason-dropdown-text-all">All selected</span>
                  <span v-else-if="selectedResponseNames.length==1" class="contact-reason-dropdown-text grey-shade">{{handleEllipsis(selectedResponseNames[0])}}</span>
                  <span v-else-if="selectedResponseNames.length>1" class="contact-reason-dropdown-text grey-shade">{{handleEllipsis(selectedResponseNames[0])}} + {{selectedResponseNames.length - 1}}</span>
                  <i :class="selectedResponseNames.length==0 || selectedResponseNames.length==this.responseNameList.length ? 'el-icon-arrow-down el-icon--right' : 'el-icon-arrow-down el-icon--right-selected'"></i>
                </el-button>
                <el-dropdown-menu ref="dropdownBtn" slot="dropdown" class="all-filters-contact-reasons">
                  <div class="cus-msg-card">
                    <div class="horizontal-line">
                      <input
                        name="filter"
                        type="text"
                        class="reg-inp"
                        :class="{'input-hight-light': responseNameKeywords!=''}"
                        v-model="responseNameKeywords"
                        placeholder="Search response names"
                      />
                      <i v-if="responseNameKeywords!=''" class="fas fa-times-circle circle-all-filter" @click="clearSearch($refs.responseNameFilterAllFilter)"></i>
                      <br />
                      <div class="check-box-section" v-loading="topicFilterLoading">
                        <el-checkbox v-if="filteredResponseNames.length > 0" class="checkbox" v-model="isResponseNameSelectedAll" @change="selectAllResponseNames"
                          label="All"></el-checkbox>
                          <span class="no-matching-data-text" v-else>no matching data</span>
                        <el-checkbox-group v-model="selectedResponseNames">
                          <el-checkbox
                            v-for="(item, index) in filteredResponseNames"
                            :key="index"
                            class="checkbox"
                            :name="item.responseName"
                            :label="item.responseName"
                            :title="item.responseName"
                          >
                          <span class="display-topic-name">{{item.responseName}}</span>
                          <span class="topic-number"> ({{item.totalVolume}})</span></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <div class="contact-reasons">
              <div class="all-filter-top-two-title"> Intent Names </div>
              <el-dropdown ref="intentNameFilterAllFilter" @visible-change="handleChangeVisible($event, $refs.intentNameFilterAllFilter)" trigger="click" placement="bottom-start">
                <el-button @click="showDropdowns" plain class="contact-reasons-dropdown">
                  <span v-if="selectedIntentNames.length==0 || selectedIntentNames.length==this.intentNameList.length" class="contact-reason-dropdown-text-all">All selected</span>
                  <span v-else-if="selectedIntentNames.length==1" class="contact-reason-dropdown-text grey-shade">{{handleEllipsis(selectedIntentNames[0])}}</span>
                  <span v-else-if="selectedIntentNames.length>1" class="contact-reason-dropdown-text grey-shade">{{handleEllipsis(selectedIntentNames[0])}} + {{selectedIntentNames.length - 1}}</span>
                  <i :class="selectedIntentNames.length==0 || selectedIntentNames.length==this.intentNameList.length ? 'el-icon-arrow-down el-icon--right' : 'el-icon-arrow-down el-icon--right-selected'"></i>
                </el-button>
                <el-dropdown-menu ref="dropdownBtn" slot="dropdown" class="all-filters-contact-reasons">
                  <div class="cus-msg-card">
                    <div class="horizontal-line">
                      <input
                        name="filter"
                        type="text"
                        class="reg-inp"
                        :class="{'input-hight-light': intentNameKeywords!=''}"
                        v-model="intentNameKeywords"
                        placeholder="Search intent names"
                      />
                      <i v-if="intentNameKeywords!=''" class="fas fa-times-circle circle-all-filter" @click="clearSearch($refs.intentNameFilterAllFilter)"></i>
                      <br />
                      <div class="check-box-section" v-loading="topicFilterLoading">
                        <el-checkbox v-if="filteredIntentNames.length > 0" class="checkbox" v-model="isIntentNameSelectedAll" @change="selectAllIntentNames"
                          label="All"></el-checkbox>
                          <span class="no-matching-data-text" v-else>no matching data</span>
                        <el-checkbox-group v-model="selectedIntentNames">
                          <el-checkbox
                            v-for="(item, index) in filteredIntentNames"
                            :key="index"
                            class="checkbox"
                            :name="item.intentName"
                            :label="item.intentName"
                            :title="item.intentName"
                          >
                          <span class="display-topic-name">{{item.intentName}}</span>
                          <span class="topic-number"> ({{item.totalVolume}})</span></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <div class="contact-reasons">
              <div class="all-filter-top-two-title"> Related Topics </div>
              <el-dropdown ref="relatedTopicFilterAllFilter" @visible-change="handleChangeVisible($event, $refs.relatedTopicFilterAllFilter)" trigger="click" placement="bottom-start">
                <el-button @click="showDropdowns" plain class="contact-reasons-dropdown">
                  <span v-if="selectedRelatedTopics.length==0 || selectedRelatedTopics.length==this.relatedTopicList.length" class="contact-reason-dropdown-text-all">All selected</span>
                  <span v-else-if="selectedRelatedTopics.length==1" class="contact-reason-dropdown-text grey-shade">{{handleEllipsis(selectedRelatedTopics[0])}}</span>
                  <span v-else-if="selectedRelatedTopics.length>1" class="contact-reason-dropdown-text grey-shade">{{handleEllipsis(selectedRelatedTopics[0])}} + {{selectedRelatedTopics.length - 1}}</span>
                  <i :class="selectedRelatedTopics.length === 0 || selectedRelatedTopics.length === relatedTopicList.length ? 'el-icon-arrow-down el-icon--right' : 'el-icon-arrow-down el-icon--right-selected'"></i>
                </el-button>
                <el-dropdown-menu ref="dropdownBtn" slot="dropdown" class="all-filters-contact-reasons">
                  <div class="cus-msg-card">
                    <div class="horizontal-line">
                      <input
                        name="filter"
                        type="text"
                        class="reg-inp"
                        :class="{'input-hight-light': relatedTopicKeywords!=''}"
                        v-model="relatedTopicKeywords"
                        placeholder="Search related topics"
                      />
                      <i v-if="relatedTopicKeywords!=''" class="fas fa-times-circle circle-all-filter" @click="clearSearch($refs.relatedTopicFilterAllFilter)"></i>
                      <br />
                      <div class="check-box-section" v-loading="topicFilterLoading">
                        <el-checkbox v-if="filteredRelatedTopics.length > 0" class="checkbox" v-model="isRelatedTopicsSelectedAll" @change="selectAllRelatedTopics"
                          label="All"></el-checkbox>
                          <span class="no-matching-data-text" v-else>no matching data</span>
                        <el-checkbox-group v-model="selectedRelatedTopics">
                          <el-checkbox
                            v-for="(item, index) in filteredRelatedTopics"
                            :key="index"
                            class="checkbox"
                            :name="item.topicName"
                            :label="item.topicName"
                            :title="item.topicName"
                          >
                          <span class="display-topic-name">{{item.topicName}}</span>
                          <span class="topic-number"> ({{item.totalVolume}})</span></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <div class="besbas_signals">
              <p class="all-filter-top-two-title"> BES Signals</p>
              <el-checkbox-group  v-model="selectedBesSignals">
                <el-checkbox
                  v-for="(item, index) in besSignalsList"
                  :key="index"
                  class="checkbox containment-checkbox"
                  :name="item.key"
                  :label="item.key"
                >
                  <div class="signal-flex">
                    {{item.label}}
                    <el-tooltip effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom" :content="item.tooltipContent">
                      <img class="signal-icon" src="../../assets/icons/icon_info.svg" />
                    </el-tooltip>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>

            <div class="besbas_signals">
              <p class="all-filter-top-two-title"> BAS Signals</p>
              <el-checkbox-group v-model="selectedBasSignals">
                <el-checkbox
                  v-for="(item, index) in basSignalsList"
                  :key="index"
                  class="checkbox containment-checkbox"
                  :name="item.key"
                  :label="item.key"
                >
                  <div class="signal-flex">
                    {{item.label}}
                    <el-tooltip effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom" :content="item.tooltipContent">
                      <img class="signal-icon" src="../../assets/icons/icon_info.svg" />
                    </el-tooltip>
                  </div>
                </el-checkbox>
              </el-checkbox-group>
            </div>

            <div class="containment" :class="{'with-border': dataModel.filters && dataModel.filters.sources && (dataModel.filters.sources.value.includes('BotToLC') || dataModel.filters.sources.value.includes('LCOnly'))}">
              <p class="all-filter-top-two-title"> Containment</p>
              <el-checkbox-group v-model="selectedContainment">
                <el-checkbox
                  v-for="(item, index) in containmentList"
                  :key="index"
                  class="checkbox containment-checkbox"
                  :name="item.key"
                  :label="item.key"
                  :disabled="isDisableItem(item)"
                >{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </div>

            <div class="top-part-flex">
              <div class="sentiment">
                <p class="all-filter-top-two-title"> Sentiment (Overall)</p>
                  <el-checkbox-group v-model="selectedSentiment">
                    <el-checkbox
                      v-for="(item, index) in sentimentList"
                      :key="index"
                      class="checkbox"
                      :name="item.key"
                      :label="item.key"
                    >{{item.label}}</el-checkbox>
                  </el-checkbox-group>
              </div>
            </div>
            <div class="top-part-flex">
              <div class="feedback">
                <p class="all-filter-top-two-title"> Feedback</p>
                  <el-checkbox-group v-model="selectedFeedback">
                    <el-checkbox
                      v-for="(item, index) in feedbackList"
                      :key="index"
                      class="checkbox"
                      :name="item.key"
                      :label="item.key"
                    >{{item.label}}</el-checkbox>
                  </el-checkbox-group>
              </div>
            </div>

            <div class="handle-time">
              <div class="all-filter-top-two-title">
                Total Handling Time
                <div v-show="handlingTimeHasError" class="invalid-time-range">
                  You have entered an invalid time range
                </div>
              </div>
              <div class="time">
                <wy-time-picker
                  v-model="handlingTimeFilter.fromValue"
                  format="hh:mm:ss"
                  :timePickerInputHasError="handlingTimeHasError"
                  :componentType="'transcriptSearch'"
                  manual-input
                  hide-dropdown
                  input-width="130px"
                ></wy-time-picker>
                <span class="dash">-</span>
                <wy-time-picker
                  v-model="handlingTimeFilter.toValue"
                  format="hh:mm:ss"
                  :timePickerInputHasError="handlingTimeHasError"
                  :componentType="'transcriptSearch'"
                  manual-input
                  hide-dropdown
                  input-width="130px"
                ></wy-time-picker>
              </div>
              <div class="flex">
                <div v-if="localFilters.handlingTime.minHandlingTimeDisplay" class="min-hint">Min: {{localFilters.handlingTime.minHandlingTimeDisplay.hh}}:{{localFilters.handlingTime.minHandlingTimeDisplay.mm}}:{{localFilters.handlingTime.minHandlingTimeDisplay.ss}}</div>
                <div v-if="localFilters.handlingTime.maxHandlingTimeDisplay" class="max-hint"> Max: {{localFilters.handlingTime.maxHandlingTimeDisplay.hh}}:{{localFilters.handlingTime.maxHandlingTimeDisplay.mm}}:{{localFilters.handlingTime.maxHandlingTimeDisplay.ss}}</div>
              </div>
            </div>

            <div class="agent-filters" v-if="dataModel.filters && dataModel.filters.sources && (dataModel.filters.sources.value.includes('BotToLC') || dataModel.filters.sources.value.includes('LCOnly'))">
              <div class="all-filter-top-two-title">
                Agent Filters
              </div>
              <div class="agent-container">
                <div class="filter-section mutiple-select-section agent-queues">
                  <wy-filter-item-multi-select className="agent-popper" ref="localAgentQueuesDropdownAllFilter" v-if="localAgentQueues
                      && dataModel.filters && dataModel.filters.sources && (dataModel.filters.sources.value.includes('BotToLC') || dataModel.filters.sources.value.includes('LCOnly'))"
                      :filter="localAgentQueues" :dataSource="agentQueuesDataSource" :filterChangedCallback="agentQueuesChangedCallback" />

                </div>
                <div class="filter-section mutiple-select-section agent-groups">
                  <wy-filter-item-multi-select className="agent-popper" ref="localAgentGroupsDropdownAllFilter" v-if="localAgentGroups
                      && dataModel.filters && dataModel.filters.sources && (dataModel.filters.sources.value.includes('BotToLC') || dataModel.filters.sources.value.includes('LCOnly'))"
                      :filter="localAgentGroups" :dataSource="agentGroupsDataSource" :filterChangedCallback="agentGroupsChangedCallback" />
                </div>
                <div class="filter-section mutiple-select-section agent-ids">
                      <wy-filter-item-multi-select className="agent-popper" ref="localAgentIdsDropdownAllFilter" v-if="localAgentIds
                      && dataModel.filters && dataModel.filters.sources && (dataModel.filters.sources.value.includes('BotToLC') || dataModel.filters.sources.value.includes('LCOnly'))"
                      :filter="localAgentIds" :dataSource="agentIdsDataSource" :filterChangedCallback="agentIdsChangedCallback" />
                </div>
              </div>

              <div class="agent-time-filter">
                <div class="agent-time-title">
                  Agent Handling Time:
                  <div v-show="agentHandlingTimeHasError" class="invalid-time-range">
                    You have entered an invalid time range
                  </div>
                </div>
                <div class="time">
                  <wy-time-picker
                    ref="agentHandlingTimeFilter"
                    v-model="agentHandlingTimeFilter.fromValue"
                    format="hh:mm:ss"
                    :timePickerInputHasError="agentHandlingTimeHasError"
                    :componentType="'transcriptSearch'"
                    end="200"
                    manual-input
                    hide-dropdown
                    input-width="130px"
                  ></wy-time-picker>
                  <span class="dash">-</span>
                  <wy-time-picker
                    v-model="agentHandlingTimeFilter.toValue"
                    format="hh:mm:ss"
                    :timePickerInputHasError="agentHandlingTimeHasError"
                    :componentType="'transcriptSearch'"
                    manual-input
                    hide-dropdown
                    input-width="130px"
                  ></wy-time-picker>
                </div>
                <div class="flex">
                  <div v-if="localFilters.agentHandlingTime.minAgentHandlingTimeDisplay" class="min-hint">Min: {{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.hh}}:{{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.mm}}:{{localFilters.agentHandlingTime.minAgentHandlingTimeDisplay.ss}}</div>
                  <div v-if="localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay" class="max-hint">Max: {{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.hh}}:{{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.mm}}:{{localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay.ss}}</div>
                </div>
              </div>  

              <div class="agent-time-filter">
                <div class="agent-time-title">
                  Agent Response Time:
                  <div v-show="agentResponseTimeHasError" class="invalid-time-range">
                    You have entered an invalid time range
                  </div>
                </div>
                <div class="time">
                  <wy-time-picker
                    ref="agentResponseTimeFilter"
                    v-model="agentResponseTimeFilter.fromValue"
                    format="hh:mm:ss"
                    :timePickerInputHasError="agentResponseTimeHasError"
                    :componentType="'transcriptSearch'"
                    end="200"
                    manual-input
                    hide-dropdown
                    input-width="130px"
                  ></wy-time-picker>
                  <span class="dash">-</span>
                  <wy-time-picker
                    v-model="agentResponseTimeFilter.toValue"
                    format="hh:mm:ss"
                    :timePickerInputHasError="agentResponseTimeHasError"
                    :componentType="'transcriptSearch'"
                    manual-input
                    hide-dropdown
                    input-width="130px"
                  ></wy-time-picker>
                </div>
                <div class="flex">
                  <div v-if="localFilters.agentResponseTime.minAgentResponseTimeDisplay" class="min-hint">Min: {{localFilters.agentResponseTime.minAgentResponseTimeDisplay.hh}}:{{localFilters.agentResponseTime.minAgentResponseTimeDisplay.mm}}:{{localFilters.agentResponseTime.minAgentResponseTimeDisplay.ss}}</div>
                  <div v-if="localFilters.agentResponseTime.maxAgentResponseTimeDisplay" class="max-hint">Max: {{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.hh}}:{{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.mm}}:{{localFilters.agentResponseTime.maxAgentResponseTimeDisplay.ss}}</div>
                </div>
              </div>

              <div class="agent-time-filter">
                <div class="agent-time-title">
                  Agent Wait Time:
                  <div v-show="agentWaitTimeHasError" class="invalid-time-range">
                    You have entered an invalid time range
                  </div>
                </div>
                <div class="time">
                  <wy-time-picker
                    ref="agentWaitTimeFilter"
                    v-model="agentWaitTimeFilter.fromValue"
                    format="hh:mm:ss"
                    :timePickerInputHasError="agentWaitTimeHasError"
                    :componentType="'transcriptSearch'"
                    end="200"
                    manual-input
                    hide-dropdown
                    input-width="130px"
                  ></wy-time-picker>
                  <span class="dash">-</span>
                  <wy-time-picker
                    v-model="agentWaitTimeFilter.toValue"
                    format="hh:mm:ss"
                    :timePickerInputHasError="agentWaitTimeHasError"
                    :componentType="'transcriptSearch'"
                    manual-input
                    hide-dropdown
                    input-width="130px"
                  ></wy-time-picker>
                </div>
                <div class="flex">
                  <div v-if="localFilters.agentWaitTime.minAgentWaitTimeDisplay" class="min-hint">Min: {{localFilters.agentWaitTime.minAgentWaitTimeDisplay.hh}}:{{localFilters.agentWaitTime.minAgentWaitTimeDisplay.mm}}:{{localFilters.agentWaitTime.minAgentWaitTimeDisplay.ss}}</div>
                  <div v-if="localFilters.agentWaitTime.maxAgentWaitTimeDisplay" class="max-hint">Max: {{localFilters.agentWaitTime.maxAgentWaitTimeDisplay.hh}}:{{localFilters.agentWaitTime.maxAgentWaitTimeDisplay.mm}}:{{localFilters.agentWaitTime.maxAgentWaitTimeDisplay.ss}}</div>
                </div>
              </div>
            </div>


            <!-- <div class="response-time">
              <div class="all-filter-top-two-title">
                Response Time
                <div v-show="responseTimeHasError" class="invalid-time-range">
                  You have entered an invalid time range
                </div>
              </div>
              <div class="time">
                <wy-time-picker
                  v-model="responseTimeFilter.fromValue"
                  format="hh:mm:ss"
                  :timePickerInputHasError="responseTimeHasError"
                  :componentType="'transcriptSearch'"
                  end="200"
                  manual-input
                  hide-dropdown
                  input-width="130px"
                ></wy-time-picker>
                <span class="dash">-</span>
                <wy-time-picker
                  v-model="responseTimeFilter.toValue"
                  format="hh:mm:ss"
                  :timePickerInputHasError="responseTimeHasError"
                  :componentType="'transcriptSearch'"
                  manual-input
                  hide-dropdown
                  input-width="130px"
                ></wy-time-picker>
              </div>
              <div class="flex">
                <div v-if="localFilters.responseTime.minResponseTimeDisplay" class="min-hint">Min: {{localFilters.responseTime.minResponseTimeDisplay.hh}}:{{localFilters.responseTime.minResponseTimeDisplay.mm}}:{{localFilters.responseTime.minResponseTimeDisplay.ss}}</div>
                <div v-if="localFilters.responseTime.maxResponseTimeDisplay" class="max-hint">Max: {{localFilters.responseTime.maxResponseTimeDisplay.hh}}:{{localFilters.responseTime.maxResponseTimeDisplay.mm}}:{{localFilters.responseTime.maxResponseTimeDisplay.ss}}</div>
              </div>
            </div> -->


            <!-- hide for OC-1171>
            <div class="handoffs">
              <div class="all-filter-top-two-title">
                Handoffs
                <div v-show="handOffsHasError" class="invalid-time-range">
                  You have entered an invalid Handoffs range
                </div>
              </div>
              <div class="time">
                <el-input-number
                  v-model="handOffsFilter.fromValue"
                  :min=0
                  :max=10000
                  :step=1
                  :class="[handOffsHasError ? 'has-error' : handOffsMin && 'is-focused']"
                  @focus="handOffsFocusMin"
                  @blur="handOffsFocusMin"
                  width="40"
                  size="mini"
                  controls-position="right">
                </el-input-number>
                <span class="dash">-</span>
                <el-input-number
                  v-model="handOffsFilter.toValue"
                  :min=0
                  :max=10000
                  :step=1
                  :class="[handOffsHasError ? 'has-error' : handOffsMax && 'is-focused']"
                  @focus="handOffsFocusMax"
                  @blur="handOffsFocusMax"
                  width="40"
                  size="mini"
                  controls-position="right">
                </el-input-number>
              </div>
              <div class="flex">
                <div class="min-hint">Min: {{localFilters.handOffs.minHandOffs}}</div>
                <div class="max-hint"> Max: {{localFilters.handOffs.maxHandOffs}}</div>
              </div>
            </div>
            -->

          </div>
        </div>
        <div class="card-bottom-part">
          <el-button plain class="clear-btn" @click="handleClearAllFilters"><span class="clear-filter-text">Reset all</span></el-button>
          <div class="all-filters-button-flex">
            <span class="transcript-search-cancel-btn" @click="handleCancelAllfilters">Cancel</span>
            <span class="transcript-search-apply-btn" @click="handleHideAllFilters($refs.allFilters, 'All Filters')">Apply</span>
          </div>
        </div>
      </div>
      <el-button @click="showDropdownsAllFilters" slot="reference" :disabled="disabledSearchFilters" name="all-filters-btn dropdown btn" class="other" :class="{'selected':appliedFilterCount>0}">
        <span class="all-filters reset-btn-icon" style="display: none;" @click="resetApply($event, $refs.allFilters, handleClearAllFilters)"></span>
        <span class="text">All Filters</span>
        <span v-if="appliedFilterCount>0" class="applied-filter-number"> ({{appliedFilterCount}})</span>
        <i class="el-icon-arrow-down el-icon--right" :class="{'hide':appliedFilterCount>0}"></i>
      </el-button>
    </el-popover>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import WyTimePicker from "../widgets/wy-time-picker";
import WyUtils from '../../library/wy-utils.js';
import WyFilterItemMultiSelect from '../widgets/wy-filters/wy-filter-item-multi-select';
import _ from 'lodash';

const CONTAINMENT_OPTIONS = Object.freeze({
  CONTAINED: "Contained",
  LIVE_AGENT_REQUESTED: "Live Agent Requested",
  NOT_CONNECTED: "Live Agent Requested but not Connected",
  LIVE_AGENT_CONNECTED: "Live Agent Connected",
});

export default Vue.extend({
  name: "wy-analytics-transcript-search-filters",
  components: {
    "wy-time-picker": WyTimePicker,
    'wy-filter-item-multi-select': WyFilterItemMultiSelect,
  },
  props: ['controller', 'contactReason'],

  data() {
    return {
      transcriptSearchResultsComponent: {},
      transcriptFilters: {},
      savedTranscriptResult: false,
      isSavedTranscriptResultSelected: false,

      topicFilterLoading: false,

      localFilters: {
        responseTime: {
          updated: false
        },
        handlingTime: {
          updated: false
        },
        handOffs: {
          updated: false
        },
        agent: {
          update: false
        },
        agentHandlingTime: {
          updated: false
        },
        agentResponseTime: {
          updated: false
        },
        agentWaitTime: {
          updated: false
        }
      },
      localFilterMap: {},
      defaultLocalFilterMap: {},

      searchKeyword: null,

      contactReasonKeywords: '',
      responseNameKeywords: '',
      intentNameKeywords: '',
      relatedTopicKeywords: '',

      containmentList: [
        { key: "BotOnlyContained", label: CONTAINMENT_OPTIONS.CONTAINED },
        { key: "BotOnlyEscalated", label: CONTAINMENT_OPTIONS.LIVE_AGENT_REQUESTED },
        { key: "BotOnlyEscalated", label: CONTAINMENT_OPTIONS.NOT_CONNECTED },
        { key: "BotToLC", label: CONTAINMENT_OPTIONS.LIVE_AGENT_CONNECTED },
      ],
      sentimentList: [{key: "pos", label: "Positive"}, {key: "neu", label: "Neutral"},{key: "neg", label: "Negative"}],
      feedbackList: [{key: "pos", label: "Positive"}, {key: "neg", label: "Negative"}],

      //OC-1805
      besSignalsList: [
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["Bot Repetition"], label: "Bot Repetition", tooltipContent: 'The virtual agent repeats itself within 3 consecutive messages during a conversation.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["User Abandoned"], label: "User Abandoned", tooltipContent: 'The customer drops off from a conversation without reaching a legitimate end response configured on the bot.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["Negative Sentiment"], label: "Negative Sentiment" , tooltipContent: 'AI-detected sentiment from the latter half of virtual agent conversations, where at least three user messages are received.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["Repeated Escalation Requests"], label: "Repeated Escalation Requests" , tooltipContent: 'The customer requests to be escalated multiple times within a conversation.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["Negative Feedback"], label: "Negative Feedback" , tooltipContent: 'The customer provides explicit negative feedback in a conversation.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["Profanity"], label: "Profanity" , tooltipContent: 'Profanity detected in customer messages within a conversation.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["experience"]["User Paraphrases"], label: "User Paraphrases" , tooltipContent: 'The customer uses a similar query twice or more within a conversation.' },
      ],

      selectedBesSignals: [],

      basSignalsList: [
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["automation"]["Escalation"], label: "Escalation" , tooltipContent: 'The customer is escalated or handed off to a live agent.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["automation"]["User Abandoned"], label: "User Abandoned" , tooltipContent: 'The customer drops off from a conversation without reaching a legitimate end response configured on the bot.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["automation"]["Escalation not Connected"], label: "Escalation not Connected" , tooltipContent: 'The customer requests to be connected to a live agent but the handoff from virtual to live agent does not take place.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["automation"]["False Positives"], label: "False Positives" , tooltipContent: 'The customer received an unrelated response to their query.' },
        { key: Vue.WyConstants.SIGNAL_PAYLOAD_MAPPER["automation"]["Negative Feedback"], label: "Negative Feedback" , tooltipContent: 'The virtual agent receives explicit negative feedback from the customer during a conversation.' },
      ],

      selectedBasSignals: [],
      //OC-1805

      //OC-1883 Advanced Search Filter
      showAdvancedSearchFilter: false,
      showAdvancedSearchFilterSticky: false,
      // Search By
      searchType: '1',
      searchTypeList: [
        {key: '1', label: 'Keyword/Phrase', disabled: false},
        {key: '2', label: 'Conversation ID', disabled: false}
      ],
      // Search For
      searchFor: null,
      searchForList: [
        {key: '1', label: 'Exact match', disabled: false},
        {key: '2', label: 'Contains', disabled: false},
      ],
      // Search In
      searchIn: [],
      searchInList: [
        {key: '1', label: 'Customer messages', apiField: 'Customer', disabled: false, checked: false},
        {key: '2', label: 'Virtual Agent messages', apiField: 'Bot', disabled: false, checked: false},
        {key: '3', label: 'Live Agent messages', apiField: 'Agent', disabled: false, checked: false},
      ],

      operatorsEnum: [
        {key: '1', label: 'AND', disabled: false},
        {key: '2', label: 'OR', disabled: false},
        {key: '3', label: 'NOT AND', disabled: false},
        {key: '4', label: 'NOT OR', disabled: false}
      ],
      operatorsEnumBetweenGroup: [
        {key: '1', label: 'AND', disabled: false},
        {key: '2', label: 'OR', disabled: false}
        
      ],

      contactReasonsList: [],
      selectedContactReasons: [],
      // selectedContactReasonsDisplay: [],
      selectedContainment: [],
      selectedSentiment: [],
      selectedFeedback: [],

      responseNameList: [],
      selectedResponseNames: [],

      relatedTopicList: [],
      selectedRelatedTopics: [],

      intentNameList: [],
      selectedIntentNames: [],

      isShowGroups: false,
      isSearchInputDisabled: false,
      // used to updating groupA.condition[0] when searchKeyword exists and enter pressed
      isInitialUpdateAdvancedFilter: false, 
      // used for copying behavior for clicking reset all and clicking outside of popover
      isAdvancedFilterReset: false,
      advancedFilterPayload: {
        groupOperators: {
          groupBOperator: null,
          groupCOperator: null
        },
        groupA: {
          operator: "1",
          conditions: [{ messageType: [], searchType: null, value: null }]
        },
      },
      isShowAdvancedFilterResultsTooltip: false,
      MAX_TOTAL_CONDITIONS: 15,
      allowed_groups: ['groupA', 'groupB', 'groupC'],

      handlingTimeFilter: {},
      showAppliedSearchCross: false,
      responseTimeFilter: {},
      handOffsFilter: {},
      appliedFilterCount: 0,
      appliedSearchKeyword: false,

      agentHandlingTimeFilter: {},
      agentResponseTimeFilter: {},
      agentWaitTimeFilter: {},

      isCanceled: false,
      showAllFilters: false,
      agentDropdownClosed: false,
      showAgentFilters: false,
      // isSelectedAll: false

      handlingTimeHasError: false,
      responseTimeHasError: false,
      handOffsHasError: false,

      agentHandlingTimeHasError: false,
      agentResponseTimeHasError: false,
      agentWaitTimeHasError: false,

      //agent related
      localAgentQueues: null,
      localAgentGroups: null,
      localAgentIds: null,
      agentQueuesDataSource: null,
      agentGroupsDataSource: null,
      agentIdsDataSource: null,

      isContactReasonSelectedAll: false,
      isResponseNameSelectedAll: false,
      isIntentNameSelectedAll: false,
      isRelatedTopicsSelectedAll: false,

      handOffsMin: false,
      handOffsMax: false,

      triggeredFromAllFiltersBtn: false,
      triggeredFromAgentFiltersBtn: false,

      showWarningMsgForKeywordSearch: false
    };
  },

  computed: {
    ...mapGetters(["dataModel", "isRoleAllow", 'localStorage', 'companyConfig']),

    companyHasLiveAgent() {
      const config = this.companyConfig && this.companyConfig.api && this.companyConfig.api.configs && this.companyConfig.api.configs.hasLiveAgent
      if (config === undefined || config === null) return true;

      return config
    },

    disabledSearchFilters() {
      return false;//this.transcriptSearchResultsComponent.totalMatchedConversations <= 1;
    },

    filterdContactReasons() {
      return this.getFilteredContactReasons();
    },

    filteredResponseNames() {
      return this.getFilteredResponseNames();
    },

    filteredIntentNames() {
      return this.getFilteredIntentNames();
    },

    filteredRelatedTopics() {
      return this.getFilteredRelatedTopics();
    },

    isAdvancedSearchApplyDisabled() {
      const isPayloadEmpty = this.checkAdvancedFilterIsEmpty()
      const isChanged = this.checkAdvancedFilterChanges();

      // if re-open after applySearch
      if (this.showAdvancedSearchFilter && !isPayloadEmpty && !isChanged) {
        return true;
      }
      // if reset all
      if (isPayloadEmpty && isChanged && !this.isShowGroups && this.searchType == '1') {
        return false;
      }

      for (const group in this.advancedFilterPayload) {
        if (group === 'groupOperators') {
          if ((this.advancedFilterPayload.groupB && !this.advancedFilterPayload.groupOperators.groupBOperator) || 
              (this.advancedFilterPayload.groupC && !this.advancedFilterPayload.groupOperators.groupCOperator)) {
            return true;
          }
        } else {
          const conditions = this.advancedFilterPayload[group] && this.advancedFilterPayload[group].conditions;
          if (conditions) {
            for (const condition of conditions) {
              if ((condition.messageType && condition.messageType.length === 0) || !condition.searchType || !condition.value) {
                return true;
              }
            }
          }
        }
      }
      return false;
    },

    isAdvancedSearchConditionsMaxed() {
      const groupAConditionsLength = this.advancedFilterPayload.groupA.conditions.length;
      const groupBConditionsLength = this.advancedFilterPayload.groupB && this.advancedFilterPayload.groupB.conditions.length;
      const groupCConditionsLength = this.advancedFilterPayload.groupC && this.advancedFilterPayload.groupC.conditions.length;

      const totalConditions = groupAConditionsLength + (groupBConditionsLength || 0) + (groupCConditionsLength || 0);
      return totalConditions >= this.MAX_TOTAL_CONDITIONS;
    },

    hasContactReason() {
      return !(!this.contactReason || this.contactReason == '')
    },

    isFilterApplied() {
      let changed = false;
      if(JSON.stringify(this.handlingTimeFilter) != JSON.stringify(this.defaultLocalFilterMap.handlingTimeFilter)
        || JSON.stringify(this.responseTimeFilter) != JSON.stringify(this.defaultLocalFilterMap.responseTimeFilter)
        || JSON.stringify(this.handOffsFilter) != JSON.stringify(this.defaultLocalFilterMap.handOffsFilter)
        || JSON.stringify(this.agentHandlingTimeFilter) != JSON.stringify(this.defaultLocalFilterMap.agentHandlingTimeFilter)
        || JSON.stringify(this.agentResponseTimeFilter) != JSON.stringify(this.defaultLocalFilterMap.agentResponseTimeFilter)
        || JSON.stringify(this.agentWaitTimeFilter) != JSON.stringify(this.defaultLocalFilterMap.agentWaitTimeFilter)
        || this.checkArrayEqual(this.selectedContactReasons, this.defaultLocalFilterMap.selectedContactReasons)
        || this.checkArrayEqual(this.selectedResponseNames, this.defaultLocalFilterMap.selectedResponseNames)
        || this.checkArrayEqual(this.selectedRelatedTopics, this.defaultLocalFilterMap.selectedRelatedTopics)
        || this.checkArrayEqual(this.selectedIntentNames, this.defaultLocalFilterMap.selectedIntentNames)
        || this.checkArrayEqual(this.selectedSentiment, this.defaultLocalFilterMap.selectedSentiment)
        || this.checkArrayEqual(this.selectedFeedback, this.defaultLocalFilterMap.selectedFeedback)
        || this.checkArrayEqual(this.selectedBesSignals, this.defaultLocalFilterMap.selectedBesSignals)
        || this.checkArrayEqual(this.selectedBasSignals, this.defaultLocalFilterMap.selectedBasSignals)
        || this.checkArrayEqual(this.selectedContainment, this.defaultLocalFilterMap.selectedContainment)
        || JSON.stringify(this.localAgentQueues) != JSON.stringify(this.defaultLocalFilterMap.localAgentQueues)
        || JSON.stringify(this.localAgentGroups) != JSON.stringify(this.defaultLocalFilterMap.localAgentGroups)
        || JSON.stringify(this.localAgentIds) != JSON.stringify(this.defaultLocalFilterMap.localAgentIds)) {
        changed = true;
      }
      return changed;
    },
  },

  watch: {
      searchKeyword: {
        handler: function(newVal) {
          if (newVal == '') {
            this.isInitialUpdateAdvancedFilter = false;
          }
        }
      },
      advancedFilterPayload : {
        handler: function(newVal) {
          const value = newVal.groupA.conditions[0].value;
          this.searchKeyword = value

          if (this.isInitialUpdateAdvancedFilter) return;
          
          if (value != '' && value != null && newVal.groupA.conditions[0].messageType.length == 0) {
            this.isInitialUpdateAdvancedFilter = true;
  
            this.advancedFilterPayload = {
              ...this.advancedFilterPayload,
              groupA: {
                ...this.advancedFilterPayload.groupA,
                conditions: this.advancedFilterPayload.groupA.conditions.map((condition, index) => {
                  if (index === 0) {
                    return { messageType: ['Customer', 'Bot', 'Agent'], searchType: "1", value: value }
                  }
                  return condition;
                })
              }
            }
          }
        },
        deep: true
      },
      isShowGroups: {
        handler: function() {
          this.handleAdvancedFilterHeightSizing();
        },
        deep: true
      },
      searchType: {
        handler: function(newVal) {
          this.handleAdvancedFilterHeightSizing();
          if (newVal == '2') {
            this.isSearchInputDisabled = false;
            let filterTagWrapper = this.$refs.searchInput.$el.querySelector('.advanced-search-filter-tag-wrapper');
            if(filterTagWrapper) {
              let tag = filterTagWrapper.querySelector('.advanced-search-filter-tag-advanced')
              if(tag && tag.textContent != 'Conversation ID search applied') {
                this.showWarningMsgForKeywordSearch = true;
              }
            }
            else {
              if(this.searchKeyword == null || this.searchKeyword == '') {
                this.showWarningMsgForKeywordSearch = false;
              }
              else {
                this.showWarningMsgForKeywordSearch = true;
              }
            }
          }
        },
        deep: true
      },
      handlingTimeFilter: {
          handler: function(newValue) {
              this.handlingTimeHasError = this.checkError(newValue.fromValue, newValue.toValue);
          },
          deep: true
      },
      responseTimeFilter: {
          handler: function(newValue) {
              this.responseTimeHasError = this.checkError(newValue.fromValue, newValue.toValue);
          },
          deep: true
      },
      handOffsFilter: {
          handler: function(newValue) {
              this.handOffsHasError = newValue.fromValue > newValue.toValue;
          },
          deep: true
      },
      agentHandlingTimeFilter: {
          handler: function(newValue) {
              this.agentHandlingTimeHasError = this.checkError(newValue.fromValue, newValue.toValue);
          },
          deep: true
      },
      agentResponseTimeFilter: {
          handler: function(newValue) {
              this.agentResponseTimeHasError = this.checkError(newValue.fromValue, newValue.toValue);
          },
          deep: true
      },
      agentWaitTimeFilter: {
          handler: function(newValue) {
              this.agentWaitTimeHasError = this.checkError(newValue.fromValue, newValue.toValue);
          },
          deep: true
      },
      selectedContactReasons: {
        handler: function(newValue) {
          this.isContactReasonSelectedAll = true;
          // this.selectedContactReasonsDisplay = [];
          this.filterdContactReasons.forEach(filteredItem => {
            if (newValue.includes(filteredItem.topicDisplayName)) {
              // this.selectedContactReasonsDisplay.push(filteredItem.topicDisplayName);
            }
            else {
              this.isContactReasonSelectedAll = false;
            }
          })
        },
        deep: true
      },
      selectedResponseNames: {
        handler: function(newValue) {
          this.isResponseNameSelectedAll = true;
          this.filteredResponseNames.forEach(filteredItem => {
            if (!newValue.includes(filteredItem.responseName)) {
              this.isResponseNameSelectedAll = false;
            }
          })
        },
        deep: true
      },
      selectedRelatedTopics: {
        handler: function(newValue) {
          this.isRelatedTopicsSelectedAll = true;
          this.filteredRelatedTopics.forEach(filteredItem => {
            if (!newValue.includes(filteredItem.topicName)) {
              this.isRelatedTopicsSelectedAll = false;
            }
          })
        },
        deep: true
      },
      selectedIntentNames: {
        handler: function(newValue) {
          this.isIntentNameSelectedAll = true;
          this.filteredIntentNames.forEach(filteredItem => {
            if (!newValue.includes(filteredItem.intentName)) {
              this.isIntentNameSelectedAll = false;
            }
          })
        },
        deep: true
      },
  },

  methods: {
    getFilteredContactReasons() {
      let filteredList = this.contactReasonsList ? this.contactReasonsList.filter(item => {
        return item.topicDisplayName.toLowerCase().includes(this.contactReasonKeywords.trim().toLowerCase())
      }) : [];

      if (this.selectedContactReasons.length === 0 || filteredList.length > this.selectedContactReasons.length) {
        this.isContactReasonSelectedAll = false;
      }
      else {
        this.isContactReasonSelectedAll = true;
        filteredList.forEach(item => {
          if (!this.selectedContactReasons.includes(item.topicDisplayName)) {
            this.isContactReasonSelectedAll = false;
          }
        })
      }
      return filteredList;
    },

    getFilteredResponseNames() {
      let filteredList = this.responseNameList ? this.responseNameList.filter(item => {
        return item.responseName.toLowerCase().includes(this.responseNameKeywords.trim().toLowerCase())
      }) : [];

      if (this.selectedResponseNames.length === 0 || filteredList.length > this.selectedResponseNames.length) {
        this.isResponseNameSelectedAll = false;
      }
      else {
        this.isResponseNameSelectedAll = true;
        filteredList.forEach(item => {
          if (!this.selectedResponseNames.includes(item.responseName)) {
            this.isResponseNameSelectedAll = false;
          }
        })
      }
      return filteredList;
    },

    getFilteredIntentNames() {
      let filteredList = this.intentNameList ? this.intentNameList.filter(item => {
        return item.intentName.toLowerCase().includes(this.intentNameKeywords.trim().toLowerCase())
      }) : [];

      if (this.selectedIntentNames.length === 0 || filteredList.length > this.selectedIntentNames.length) {
        this.isIntentNameSelectedAll = false;
      }
      else {
        this.isIntentNameSelectedAll = true;
        filteredList.forEach(item => {
          if (!this.selectedIntentNames.includes(item.intentName)) {
            this.isIntentNameSelectedAll = false;
          }
        })
      }
      return filteredList;
    },

    getFilteredRelatedTopics() {
      let filteredList = this.relatedTopicList ? this.relatedTopicList.filter(item => {
        return item.topicName.toLowerCase().includes(this.relatedTopicKeywords.trim().toLowerCase())
      }) : [];

      if (this.selectedRelatedTopics.length === 0 || filteredList.length > this.selectedRelatedTopics.length) {
        this.isRelatedTopicsSelectedAll = false;
      }
      else {
        this.isRelatedTopicsSelectedAll = true;
        filteredList.forEach(item => {
          if (!this.selectedRelatedTopics.includes(item.topicName)) {
            this.isRelatedTopicsSelectedAll = false;
          }
        })
      }
      return filteredList;
    },

    handOffsFocusMin() {
      this.handOffsMin = !this.handOffsMin
    },
    handOffsFocusMax() {
      this.handOffsMax = !this.handOffsMax
    },
    async handleFilterChange() {
      //scoped by when global filter has selected agentQueue or agentGroups or agentGroups
      const agentQueuesValue = this.dataModel.filters.agentQueues.value || [];
      const agentGroupsValue = this.dataModel.filters.agentGroups.value || [];
      const agentIdsValue = this.dataModel.filters.agentIds.value || [];

      let agentGroups = _.groupBy(this.localStorage.agentData.filter(item => (item.ag != null && (agentQueuesValue.length==0 || agentQueuesValue.includes('all') || agentQueuesValue.includes(item.aq)) && (agentIdsValue.length==0 || agentIdsValue.includes('all') || agentIdsValue.includes(item.ai)))), "ag");
      let agentGroupsDS = Object.keys(agentGroups).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentGroups[key]} });
      this.agentGroupsDataSource.splice(1, this.agentGroupsDataSource.length);
      this.agentGroupsDataSource.push(...agentGroupsDS);

      let agentIds = _.groupBy(this.localStorage.agentData.filter(item => (item.ai != null && (agentQueuesValue.length==0 || agentQueuesValue.includes('all') || agentQueuesValue.includes(item.aq)) && (agentGroupsValue.length==0 || agentGroupsValue.includes('all') || agentGroupsValue.includes(item.ag)))), "ai");
      let agentIdsDS = Object.keys(agentIds).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentIds[key]} });
      this.agentIdsDataSource.splice(1, this.agentIdsDataSource.length);
      this.agentIdsDataSource.push(...agentIdsDS);

      let agentQueues = _.groupBy(this.localStorage.agentData.filter(item => (item.aq != null && (agentGroupsValue.length==0 || agentGroupsValue.includes('all') || agentGroupsValue.includes(item.ag)) && (agentIdsValue.length==0 || agentIdsValue.includes('all') || agentIdsValue.includes(item.ai)))), "aq");
      let agentQueuesDS = Object.keys(agentQueues).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentQueues[key]} });
      this.agentQueuesDataSource.splice(1, this.agentQueuesDataSource.length);
      this.agentQueuesDataSource.push(...agentQueuesDS);

      this.localAgentQueues = JSON.parse(JSON.stringify(this.dataModel.filters.agentQueues));
      this.localFilterMap.localAgentQueues = JSON.parse(JSON.stringify(this.dataModel.filters.agentQueues));
      this.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
      this.localFilterMap.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
      this.localAgentIds = JSON.parse(JSON.stringify(this.dataModel.filters.agentIds));
      this.localFilterMap.localAgentIds = JSON.parse(JSON.stringify(this.dataModel.filters.agentIds));
      //agent queue, agent group, agent id
      if(this.transcriptFilters['agentQueues'] && this.transcriptFilters['agentQueues'].length>0 && this.appliedFilterCount >= 1) {
          this.appliedFilterCount  = this.appliedFilterCount - 1;
          if(this.localAgentQueues != null) {
            let agentQueuesFilter = JSON.parse(JSON.stringify(this.localAgentQueues.value)) || [];
            this.transcriptFilters['agentQueues'] = agentQueuesFilter;
          }
      }
      if(this.transcriptFilters['agentGroups'] && this.transcriptFilters['agentGroups'].length>0 && this.appliedFilterCount >= 1) {
          this.appliedFilterCount  = this.appliedFilterCount - 1;
          if(this.localAgentGroups != null) {
            let agentGroupsFilter = JSON.parse(JSON.stringify(this.localAgentGroups.value)) || [];
            this.transcriptFilters['agentGroups'] = agentGroupsFilter;
          }
      }
      if(this.transcriptFilters['agentIds'] && this.transcriptFilters['agentIds'].length>0 && this.appliedFilterCount >= 1) {
          this.appliedFilterCount  = this.appliedFilterCount - 1;
          if(this.localAgentIds != null) {
            let agentIdsFilter = JSON.parse(JSON.stringify(this.localAgentIds.value)) || [];
            this.transcriptFilters['agentIds'] = agentIdsFilter;
          }
      }

      const agentHandleTimeCondition = 
        this.localFilters.agentHandlingTime.minAgentHandlingTime * 1000 !== 0 
        && this.transcriptFilters.agentHandleTimeMillisMin 
        && this.transcriptFilters.agentHandleTimeMillisMin !== this.localFilters.agentHandlingTime.minAgentHandlingTime * 1000 
        && this.transcriptFilters.agentHandleTimeMillisMax !== this.localFilters.agentHandlingTime.maxAgentHandlingTime * 1000

      const agentResponseTimeCondition =
        this.localFilters.agentResponseTime.minAgentResponseTime * 1000 !== 0 
        && this.transcriptFilters.agentResponseTimeMillisMin 
        && this.transcriptFilters.agentResponseTimeMillisMin !== this.localFilters.agentResponseTime.minAgentResponseTime * 1000 
        && this.transcriptFilters.agentResponseTimeMillisMax !== this.localFilters.agentResponseTime.maxAgentResponseTime * 1000

      const agentWaitTimeCondition =
        this.localFilters.agentWaitTime.minAgentWaitTime * 1000 !== 0 
        && this.transcriptFilters.agentWaitTimeMillisMin 
        && this.transcriptFilters.agentWaitTimeMillisMin !== this.localFilters.agentWaitTime.minAgentWaitTime * 1000 
        && this.transcriptFilters.agentWaitTimeMillisMax !== this.localFilters.agentWaitTime.maxAgentWaitTime * 1000


      if((!this.transcriptFilters['agentQueues'] ||  (this.transcriptFilters['agentQueues'] && this.transcriptFilters['agentQueues'].length == 0))
        && (!this.transcriptFilters['agentGroups'] || (this.transcriptFilters['agentGroups'] && this.transcriptFilters['agentGroups'].length == 0))
        && (!this.transcriptFilters['agentIds'] || (this.transcriptFilters['agentIds'] && this.transcriptFilters['agentIds'].length == 0))
        && !agentHandleTimeCondition
        && !agentResponseTimeCondition
        && !agentWaitTimeCondition
        ){
          this.localFilters.agent.updated = false;
      }
    },

    //handle Agent related.......
    agentQueuesChangedCallback() {
      const agentQueuesValue = this.localAgentQueues.value || [];
      const agentGroupsValue = this.localAgentGroups.value || [];
      const agentIdsValue = this.localAgentIds.value || [];

      if(!this.localAgentGroups.isDisabled){
        let agentGroups = _.groupBy(this.localStorage.agentData.filter(item => (item.ag != null && (agentQueuesValue.length==0 || agentQueuesValue.includes('all') || agentQueuesValue.includes(item.aq)) && (agentIdsValue.length==0 || agentIdsValue.includes('all') || agentIdsValue.includes(item.ai)))), "ag");
        let agentGroupsDS = Object.keys(agentGroups).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentGroups[key]} });
        let agentGroupsValues = agentGroupsDS.map(item => item.key);
        this.agentGroupsDataSource.splice(1, this.agentGroupsDataSource.length);
        this.agentGroupsDataSource.push(...agentGroupsDS);
        this.localAgentQueues.isDisabled = (this.dataModel.filters.agentQueues.value.length !== 0);
        this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
        this.localAgentGroups.value = this.localAgentGroups.value.filter(val => agentGroupsValues.includes(val));
        this.localAgentGroups.isEmpty = (this.agentGroupsDataSource.length == 1 && this.agentGroupsDataSource[0].key == 'all');
      }

      if(!this.localAgentIds.isDisabled){
        let agentIds = _.groupBy(this.localStorage.agentData.filter(item => (item.ai != null && (agentQueuesValue.length==0 || agentQueuesValue.includes('all') || agentQueuesValue.includes(item.aq)) && (agentGroupsValue.length==0 || agentGroupsValue.includes('all') || agentGroupsValue.includes(item.ag)))), "ai");
        let agentIdsDS = Object.keys(agentIds).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentIds[key]} });
        let agentIdsValues = agentIdsDS.map(item => item.key);
        this.agentIdsDataSource.splice(1, this.agentIdsDataSource.length);
        this.agentIdsDataSource.push(...agentIdsDS);
        this.localAgentIds.isDisabled = (this.dataModel.filters.agentIds.value.length !== 0);
        this.localAgentIds.value = this.localAgentIds.value.filter(val => agentIdsValues.includes(val));
        this.localAgentIds.isEmpty = (this.agentIdsDataSource.length == 1 && this.agentIdsDataSource[0].key == 'all');
      }

    },

    showDropdowns(){
      setTimeout(() => {
        document.querySelectorAll('.el-select-dropdown__wrap').forEach(el => {
        el.style.display = "block";
        })
      }, 100);
    },

    showDropdownsAgentFilters() {
      this.triggeredFromAgentFiltersBtn = true;
      this.showDropdowns()
    },

    showDropdownsAllFilters () {
      this.triggeredFromAllFiltersBtn = true;
      this.showDropdowns()
    },

    pageChanged(pageNo) {
      this.transcriptFilters['action'] = 'search';
      this.transcriptFilters['searchBy'] = this.searchType;
      if (!this.checkAdvancedFilterIsEmpty()) {
        const advancedFilter = this.getAdvancedFilterPayload();
        this.transcriptFilters['advancedFilter'] = advancedFilter;
      }

      this.loadTopicConversations(pageNo, false, "Page Scroll");
    },
    handleAgentCancel(){
      this.isCanceled = true;
      this.agentCancel();

    },
    agentCancel() {
      this.showAgentFilters = false;

      this.localAgentQueues = JSON.parse(JSON.stringify(this.localFilterMap.localAgentQueues));
      this.localAgentGroups = JSON.parse(JSON.stringify(this.localFilterMap.localAgentGroups));
      this.localAgentIds = JSON.parse(JSON.stringify(this.localFilterMap.localAgentIds));
    },

    agentGroupsChangedCallback() {
      const agentQueuesValue = this.localAgentQueues.value || [];
      const agentGroupsValue = this.localAgentGroups.value || [];
      const agentIdsValue = this.localAgentIds.value || [];

      if(!this.localAgentQueues.isDisabled){
        let agentQueues = _.groupBy(this.localStorage.agentData.filter(item => (item.aq != null && (agentGroupsValue.length==0 || agentGroupsValue.includes('all') || agentGroupsValue.includes(item.ag)) && (agentIdsValue.length==0 || agentIdsValue.includes('all') || agentIdsValue.includes(item.ai)))), "aq");
        let agentQueuesDS = Object.keys(agentQueues).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentQueues[key]} });
        let agentQueuesValues = agentQueuesDS.map(item => item.key);
        this.agentQueuesDataSource.splice(1, this.agentQueuesDataSource.length);
        this.agentQueuesDataSource.push(...agentQueuesDS);
        this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
        this.localAgentQueues.isDisabled = (this.dataModel.filters.agentQueues.value.length !== 0);
        this.localAgentQueues.value = this.localAgentQueues.value.filter(val => agentQueuesValues.includes(val));
        this.localAgentQueues.isEmpty = (this.agentQueuesDataSource.length == 1 && this.agentQueuesDataSource[0].key == 'all');
      }

      if(!this.localAgentIds.isDisabled){
        let agentIds = _.groupBy(this.localStorage.agentData.filter(item => (item.ai != null && (agentQueuesValue.length==0 || agentQueuesValue.includes('all') || agentQueuesValue.includes(item.aq)) && (agentGroupsValue.length==0 || agentGroupsValue.includes('all') || agentGroupsValue.includes(item.ag)))), "ai");
        let agentIdsDS = Object.keys(agentIds).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentIds[key]} });
        let agentIdsValues = agentIdsDS.map(item => item.key);
        this.agentIdsDataSource.splice(1, this.agentIdsDataSource.length);
        this.agentIdsDataSource.push(...agentIdsDS);
        this.localAgentIds.isDisabled = (this.dataModel.filters.agentIds.value.length !== 0);
        this.localAgentIds.value = this.localAgentIds.value.filter(val => agentIdsValues.includes(val));
        this.localAgentIds.isEmpty = (this.agentIdsDataSource.length == 1 && this.agentIdsDataSource[0].key == 'all');
      }

    },

    agentIdsChangedCallback() {
      const agentQueuesValue = this.localAgentQueues.value || [];
      const agentGroupsValue = this.localAgentGroups.value || [];
      const agentIdsValue = this.localAgentIds.value || [];

      if(!this.localAgentQueues.isDisabled){
        let agentQueues = _.groupBy(this.localStorage.agentData.filter(item => (item.aq != null && (agentGroupsValue.length==0 || agentGroupsValue.includes('all') || agentGroupsValue.includes(item.ag)) && (agentIdsValue.length==0 || agentIdsValue.includes('all') || agentIdsValue.includes(item.ai)))), "aq");
        let agentQueuesDS = Object.keys(agentQueues).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentQueues[key]} });
        let agentQueuesValues = agentQueuesDS.map(item => item.key);
        this.agentQueuesDataSource.splice(1, this.agentQueuesDataSource.length);
        this.agentQueuesDataSource.push(...agentQueuesDS);
        this.localAgentIds.isDisabled = (this.dataModel.filters.agentIds.value.length !== 0);
        this.localAgentQueues.isDisabled = (this.dataModel.filters.agentQueues.value.length !== 0);
        this.localAgentQueues.value = this.localAgentQueues.value.filter(val => agentQueuesValues.includes(val));
        this.localAgentQueues.isEmpty = (this.agentQueuesDataSource.length == 1 && this.agentQueuesDataSource[0].key == 'all');
      }

      if(!this.localAgentGroups.isDisabled){
        let agentGroups = _.groupBy(this.localStorage.agentData.filter(item => (item.ag != null && (agentQueuesValue.length==0 || agentQueuesValue.includes('all') || agentQueuesValue.includes(item.aq)) && (agentIdsValue.length==0 || agentIdsValue.includes('all') || agentIdsValue.includes(item.ai)))), "ag");
        let agentGroupsDS = Object.keys(agentGroups).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentGroups[key]} });
        let agentGroupsValues = agentGroupsDS.map(item => item.key);
        this.agentGroupsDataSource.splice(1, this.agentGroupsDataSource.length);
        this.agentGroupsDataSource.push(...agentGroupsDS);
        this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
        this.localAgentGroups.value = this.localAgentGroups.value.filter(val => agentGroupsValues.includes(val));
        this.localAgentGroups.isEmpty = (this.agentGroupsDataSource.length == 1 && this.agentGroupsDataSource[0].key == 'all');
      }
    },

    clearSearch(ref) {
      if (ref == this.$refs.contactReasonFilter || ref == this.$refs.contactReasonFilterAllFilter) {
        this.contactReasonKeywords = '';
      }
      else if (ref == this.$refs.responseNameFilter || ref == this.$refs.responseNameFilterAllFilter) {
        this.responseNameKeywords = '';
      }
      else if (ref == this.$refs.relatedTopicsFilter || ref == this.$refs.relatedTopicFilterAllFilter) {
        this.relatedTopicKeywords = '';
      }
      else if (ref == this.$refs.intentNameFilter || ref == this.$refs.intentNameFilterAllFilter) {
        this.intentNameKeywords = '';
      }
    },

    clearSearchInput() {
      this.isInitialUpdateAdvancedFilter = false;
      this.isSearchInputDisabled = false;
      this.searchType = '1'
      this.handleResetAllAdvancedSearch();

      if (this.isAdvancedFilterApplied()) {
        this.applySearch();
      } else {
        this.handleCloseAdvancedSearch();
      }
      // this.applySearch(); //handled by handlePopoverHideEvent
    },

    isDisableItem(item) {
      if(this.dataModel.filters && this.dataModel.filters.sources && this.dataModel.filters.sources.value && this.dataModel.filters.sources.value.length > 0) {
        return !this.dataModel.filters.sources.value.includes(item.key);
      }
    },

    checkError(from, to) {
      if(from && to) {
        let fromValue = parseInt(from.hh*3600) + parseInt(from.mm*60) + parseInt(from.ss)
        let toValue = parseInt(to.hh*3600) + parseInt(to.mm*60) + parseInt(to.ss)
        return fromValue > toValue
      }
      else {
        return false
      }
    },

    handleShowAllFilters(el) {
      setTimeout(()=>{
        this.agentDropdownClosed = false;
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.add('el-icon-arrow-up')
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.remove('el-icon-arrow-down')
        el.$el.firstElementChild.classList.add("with-border")

        if(this.isCanceled) {
          this.isCanceled = false;
        }
        else {
          if(this.localAgentQueues.value.length !== 0){
            this.$refs.localAgentQueuesDropdown.isChanged(true);
            this.$refs.localAgentQueuesDropdownAllFilter.isChanged(true);
          }
          if(this.localAgentGroups.value.length !== 0){
            this.$refs.localAgentGroupsDropdown.isChanged(true);
            this.$refs.localAgentGroupsDropdownAllFilter.isChanged(true);
          }
          if(this.localAgentIds.value.length !== 0){
            this.$refs.localAgentIdsDropdown.isChanged(true);
            this.$refs.localAgentIdsDropdownAllFilter.isChanged(true);
          }
          this.localAgentQueues.isDisabled = (this.dataModel.filters.agentQueues.value.length !== 0);
          this.localFilterMap.localAgentQueues = JSON.parse(JSON.stringify(this.localAgentQueues));
          this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
          this.localFilterMap.localAgentGroups = JSON.parse(JSON.stringify(this.localAgentGroups))
          this.localAgentIds.isDisabled = (this.dataModel.filters.agentIds.value.length !== 0);
          this.localFilterMap.localAgentIds = JSON.parse(JSON.stringify(this.localAgentIds));
        }
      }, 200)


        /*
        // fire global click overlay event to show the modal
        setTimeout(() => {
          this.$root.$emit(`fire-app-clickOverlayModal-events`, {handleApply: () => {
            if(this.checkFilterChanges()) {
              this.applySearch();
            }
            this.showAllFilters = false;
          }, active: true});
        }, 100);
        */
    },

    handleHideAllFilters(el, applySearchfilterName) {
      this.agentDropdownClosed = true;
      document.querySelectorAll(".el-dropdown-menu.el-popper.all-filters-contact-reasons").forEach(el => {
        el.style.display = "none";
      })
      if(el && el.$el) {
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.add('el-icon-arrow-down')
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.remove('el-icon-arrow-up')
        el.$el.firstElementChild.classList.remove("with-border")
      }
      if(this.isCanceled) {
        this.isCanceled = false;
      }
      else {

      if(this.$refs.localAgentIdsDropdown) this.$refs.localAgentIdsDropdown.closeDropdown();
      if(this.$refs.localAgentQueuesDropdown) this.$refs.localAgentQueuesDropdown.closeDropdown();
      if(this.$refs.localAgentGroupsDropdown) this.$refs.localAgentGroupsDropdown.closeDropdown();
      if(this.$refs.localAgentIdsDropdownAllFilter) this.$refs.localAgentIdsDropdownAllFilter.closeDropdown();
      if(this.$refs.localAgentQueuesDropdownAllFilter) this.$refs.localAgentQueuesDropdownAllFilter.closeDropdown();
      if(this.$refs.localAgentGroupsDropdownAllFilter) this.$refs.localAgentGroupsDropdownAllFilter.closeDropdown();
        if(this.checkFilterChanges()) {
          this.applySearch(null, applySearchfilterName);
          this.showAppliedSearchCross = true;
        } else {
          this.showAppliedSearchCross = false;
        }
      }
      if(el == this.$refs.localAgentFilter) {
        this.agentCancel();
      }
      if(el == this.$refs.allFilters) {
        this.cancelAllfilters();
      }
    },

    arrayMove(arr, old_index, new_index) {
      if (new_index >= arr.length) {
          var k = new_index - arr.length + 1;
          while (k--) {
              arr.push(undefined);
          }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
    },

    handleChangeVisible(isShowing, el) {
      const filterLabelEl = el.$el.querySelector(".filterLabel");
      const filterLabelText = filterLabelEl ? filterLabelEl.innerText.trim() : null;

      if(isShowing) {
        if(el == this.$refs.contactReasonFilter && this.selectedContactReasons.length > 0) {
          // let selectedArray = [];
          // let restArray = [];
          let newIndex = 0
          this.contactReasonsList.forEach((item, index) => {
            this.selectedContactReasons.forEach(selectedTopicName => {
              if(item.topicDisplayName == selectedTopicName) {
                // selectedArray.push(item)
                this.contactReasonsList = this.arrayMove(this.contactReasonsList, index, newIndex);
                newIndex ++;
              }
              else {
                // restArray.push(item)
              }
            })
          })
          // this.contactReasonsList = [];
          // this.contactReasonsList = selectedArray.concat(restArray)
        }
        // Response Name Filter
        if(el == this.$refs.responseNameFilter && this.selectedResponseNames.length > 0) {
          let newIndex = 0
          this.responseNameList.forEach((item, index) => {
            this.selectedResponseNames.forEach(selectedResponseName => {
              if(item.responseName == selectedResponseName) {
                this.responseNameList = this.arrayMove(this.responseNameList, index, newIndex);
                newIndex ++;
              }
            })
          })
        }
        // Related Topic Filter
        if(el == this.$refs.relatedTopicsFilter && this.selectedRelatedTopics.length > 0) {
          let newIndex = 0
          this.relatedTopicList.forEach((item, index) => {
            this.selectedRelatedTopics.forEach(selectedRelatedTopic => {
              if(item.topicName == selectedRelatedTopic) {
                this.relatedTopicList = this.arrayMove(this.relatedTopicList, index, newIndex);
                newIndex ++;
              }
            })
          })
        }
        // Intent Name Filter
        if(el == this.$refs.intentNameFilter && this.selectedIntentNames.length > 0) {
          let newIndex = 0
          this.intentNameList.forEach((item, index) => {
            this.selectedIntentNames.forEach(selectedIntentName => {
              if(item.intentName == selectedIntentName) {
                this.intentNameList = this.arrayMove(this.intentNameList, index, newIndex);
                newIndex ++;
              }
            })
          })
        }

        el.show();
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.add('el-icon-arrow-up')
        el.$el.firstElementChild.firstElementChild.lastElementChild.classList.remove('el-icon-arrow-down')
        el.$el.firstElementChild.classList.add("with-border");
      }
      else {
        if(el) {
          el.$el.firstElementChild.firstElementChild.lastElementChild.classList.add('el-icon-arrow-down')
          el.$el.firstElementChild.firstElementChild.lastElementChild.classList.remove('el-icon-arrow-up')
          el.$el.firstElementChild.classList.remove("with-border");
          if(el.hide) {
            el.hide();
          }
          else {
            this.handleHideAllFilters(el, 'All Filters');
            // this.cancelAllfilters();
          }
        }
        if(this.isCanceled) {
          this.isCanceled = false;
        }
        else {
          const isListFilter = 
            el == this.$refs.contactReasonFilterAllFilter
            || el == this.$refs.responseNameFilterAllFilter 
            || el == this.$refs.relatedTopicFilterAllFilter 
            || el == this.$refs.intentNameFilterAllFilter;

          if(isListFilter){
            if(this.checkFilterChanges() && this.agentDropdownClosed) {
              this.applySearch(null, filterLabelText);
            }
          }
          else {
            if(this.checkFilterChanges()) {
              this.applySearch(null, filterLabelText);
            }
          }
        }
      }
    },

    checkAdvancedFilterIsEmpty() {
      return this.advancedFilterPayload.groupA.conditions.length == 1 && 
        !this.advancedFilterPayload.groupA.conditions[0].searchType &&
        !this.advancedFilterPayload.groupA.conditions[0].messageType.length &&
        !this.advancedFilterPayload.groupA.conditions[0].value && 
        !this.advancedFilterPayload.groupB && 
        !this.advancedFilterPayload.groupC
    },

    checkAdvancedFilterChanges() {
      let changed = false;
      if (
        this.searchKeyword != this.localFilterMap.searchKeyword || 
        this.searchType != this.localFilterMap.searchType ||
        this.isShowGroups != this.localFilterMap.isShowGroups ||
        JSON.stringify(this.advancedFilterPayload) != JSON.stringify(this.localFilterMap.advancedFilterPayload)
      ) {
        changed = true
      }
      return changed
    },

    checkFilterChanges() {
      let changed = false;
      if(JSON.stringify(this.handlingTimeFilter) != JSON.stringify(this.localFilterMap.handlingTimeFilter)
        || JSON.stringify(this.responseTimeFilter) != JSON.stringify(this.localFilterMap.responseTimeFilter)
        || JSON.stringify(this.handOffsFilter) != JSON.stringify(this.localFilterMap.handOffsFilter)
        || JSON.stringify(this.agentHandlingTimeFilter) != JSON.stringify(this.localFilterMap.agentHandlingTimeFilter)
        || JSON.stringify(this.agentResponseTimeFilter) != JSON.stringify(this.localFilterMap.agentResponseTimeFilter)
        || JSON.stringify(this.agentWaitTimeFilter) != JSON.stringify(this.localFilterMap.agentWaitTimeFilter)
        || this.checkArrayEqual(this.selectedContactReasons, this.localFilterMap.selectedContactReasons)
        || this.checkArrayEqual(this.selectedResponseNames, this.localFilterMap.selectedResponseNames)
        || this.checkArrayEqual(this.selectedRelatedTopics, this.localFilterMap.selectedRelatedTopics)
        || this.checkArrayEqual(this.selectedIntentNames, this.localFilterMap.selectedIntentNames)
        || this.checkArrayEqual(this.selectedSentiment, this.localFilterMap.selectedSentiment)
        || this.checkArrayEqual(this.selectedFeedback, this.localFilterMap.selectedFeedback)
        || this.checkArrayEqual(this.selectedContainment, this.localFilterMap.selectedContainment)
        || this.checkArrayEqual(this.selectedBesSignals, this.localFilterMap.selectedBesSignals)
        || this.checkArrayEqual(this.selectedBasSignals, this.localFilterMap.selectedBasSignals)
        || JSON.stringify(this.localAgentQueues) != JSON.stringify(this.localFilterMap.localAgentQueues)
        || JSON.stringify(this.localAgentGroups) != JSON.stringify(this.localFilterMap.localAgentGroups)
        || JSON.stringify(this.localAgentIds) != JSON.stringify(this.localFilterMap.localAgentIds)) {
        changed = true;
      }
      return changed;
    },

    checkArrayEqual(array1, array2) {
      let changed = false;
      if(!array1) {
        array1 = []
      }
      if(!array2) {
        array2 = []
      }
      array1.forEach(item=>{
        if(!array2.includes(item)) {
          changed = true
        }
      })
      array2.forEach(item=>{
        if(!array1.includes(item)) {
          changed = true
        }
      })
      return changed;
    },

    handleClearAllFilters(){
      this.resetResponseTimeRange();
      this.resetHandlingTimeRange();
      this.resetHandoffs();

      if(this.contactReason && this.contactReason != "") {
        // this.transcriptFilters['topicDisplayNames'] = [this.contactReason];
        this.selectedContactReasons = [this.contactReason];
      }
      else {
        this.resetContactReasons();
      }
      this.resetContainment();
      this.resetResponseName();
      this.resetRelatedTopics();
      this.resetIntentNames();

      this.resetSentiment();
      this.resetFeedback();
      this.resetAgents();
      this.resetBesSignals();
      this.resetBasSignals();
      
    },

    handleClearLocalAgentFilters(){
      this.localAgentQueues = JSON.parse(JSON.stringify(this.dataModel.filters.agentQueues));
      this.localAgentQueues.label = this.localAgentQueues.label;
      this.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
      this.localAgentGroups.label = this.localAgentGroups.label;
      this.localAgentIds = JSON.parse(JSON.stringify(this.dataModel.filters.agentIds));
      this.localAgentIds.label = this.localAgentIds.label;
    },

    resetAgentApply(e, el) {
      e.stopPropagation();
      this.resetAgents();
      this.isCanceled = false;
      this.handleHideAllFilters(el, 'Agent Filters');
      // this.handleAgentCancel()
    },

    resetContactReasonApply(e, el) {
      e.stopPropagation();
      this.selectedContactReasons = [];
      this.isCanceled = false;
      this.handleChangeVisible(false, el);
    },

    resetContainmentApply(e, el) {
      e.stopPropagation();
      this.selectedContainment = [];
      this.isCanceled = false;
      this.handleChangeVisible(false, el);
    },

    resetHandlingTimeApply(e, el) {
      e.stopPropagation();
      // this.selectedContainment = [];
      this.isCanceled = false;
      this.handleChangeVisible(false, el);
    },
    resetApply(e, el, resetCallback) {
      e.stopPropagation();
      // this.selectedContainment = [];
      resetCallback()
      this.isCanceled = false;
      this.handleChangeVisible(false, el);
    },

    handleApply(el) {
      this.isCanceled = false;
      el.hide();
    },

    handleCancel(el) {
      this.isCanceled = true;
      el.hide();
      this.selectedContactReasons = JSON.parse(JSON.stringify(this.localFilterMap.selectedContactReasons));
      this.selectedResponseNames = JSON.parse(JSON.stringify(this.localFilterMap.selectedResponseNames));
      this.selectedRelatedTopics = JSON.parse(JSON.stringify(this.localFilterMap.selectedRelatedTopics));
      this.selectedIntentNames = JSON.parse(JSON.stringify(this.localFilterMap.selectedIntentNames));
      this.selectedContainment = this.localFilterMap.selectedContainment;
      this.selectedSentiment = this.localFilterMap.selectedSentiment;
      this.selectedFeedback = this.localFilterMap.selectedFeedback;
      this.selectedBesSignals = this.localFilterMap.selectedBesSignals;
      this.selectedBasSignals = this.localFilterMap.selectedBasSignals;
      this.handlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.handlingTimeFilter));
      this.responseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.responseTimeFilter));
      this.handOffsFilter = JSON.parse(JSON.stringify(this.localFilterMap.handOffsFilter));
      this.agentHandlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentHandlingTimeFilter));
      this.agentResponseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentResponseTimeFilter));
      this.agentWaitTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentWaitTimeFilter));
      this.localAgentQueues = JSON.parse(JSON.stringify(this.localFilterMap.localAgentQueues));
      this.localAgentGroups = JSON.parse(JSON.stringify(this.localFilterMap.localAgentGroups));
      this.localAgentIds = JSON.parse(JSON.stringify(this.localFilterMap.localAgentIds));
    },

    handleCancelAllfilters() {
      this.isCanceled = true;
      this.showAdvancedSearchFilter = false;
      this.showAgentFilters = false;
      this.cancelAllfilters();
    },

    cancelAllfilters() {
      this.showAllFilters = false;
      if(this.localFilterMap && this.localFilterMap.selectedContactReasons) {
        this.selectedContactReasons = JSON.parse(JSON.stringify(this.localFilterMap.selectedContactReasons));
        this.selectedResponseNames = JSON.parse(JSON.stringify(this.localFilterMap.selectedResponseNames));
        this.selectedRelatedTopics = JSON.parse(JSON.stringify(this.localFilterMap.selectedRelatedTopics));
        this.selectedIntentNames = JSON.parse(JSON.stringify(this.localFilterMap.selectedIntentNames));
        this.selectedContainment = this.localFilterMap.selectedContainment;
        this.selectedSentiment = this.localFilterMap.selectedSentiment;
        this.selectedFeedback = this.localFilterMap.selectedFeedback;
        this.selectedBesSignals = this.localFilterMap.selectedBesSignals;
        this.selectedBasSignals = this.localFilterMap.selectedBasSignals;
        this.handlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.handlingTimeFilter));
        this.responseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.responseTimeFilter));
        this.handOffsFilter = JSON.parse(JSON.stringify(this.localFilterMap.handOffsFilter));
        this.agentHandlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentHandlingTimeFilter));
        this.agentResponseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentResponseTimeFilter)); 
        this.agentWaitTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentWaitTimeFilter));
        this.localAgentQueues = JSON.parse(JSON.stringify(this.localFilterMap.localAgentQueues));
        this.localAgentGroups = JSON.parse(JSON.stringify(this.localFilterMap.localAgentGroups));
        this.localAgentIds = JSON.parse(JSON.stringify(this.localFilterMap.localAgentIds));
      }
      
    },

    toggleSavedTranscriptFilter() {
      this.savedTranscriptResult = !this.savedTranscriptResult
      this.applySearch(null, "Saved Transcripts");
    },

    prepareFilters() {
      this.transcriptFilters = {};

      this.transcriptFilters['savedTranscripts'] = this.savedTranscriptResult;
      this.transcriptFilters['searchBy'] = this.searchType;
      if (!this.checkAdvancedFilterIsEmpty()) {
        const advancedFilter = this.getAdvancedFilterPayload();
        this.transcriptFilters['advancedFilter'] = advancedFilter;
      }
      if (this.searchKeyword && this.searchKeyword != "") {
        this.transcriptFilters['searchKeyword'] = this.searchKeyword;
      }
      if(this.contactReason && this.contactReason != "") {
        this.transcriptFilters['topicDisplayNames'] = [this.contactReason];
      }

      if(this.selectedContactReasons.length > 0) {
        this.transcriptFilters['topicDisplayNames'] = this.selectedContactReasons;
      }
      if(this.selectedResponseNames.length > 0) {
        this.transcriptFilters['responseNames'] = this.selectedResponseNames;
      }
      if(this.selectedRelatedTopics.length > 0) {
        this.transcriptFilters['relatedTopics'] = this.selectedRelatedTopics;
      }
      if(this.selectedIntentNames.length > 0) {
        this.transcriptFilters['intentNames'] = this.selectedIntentNames;
      }
      
      if(this.selectedContainment.length > 0) {
        // If global filter 'source' removed the value, also remove from the selectedContainment
        const globalFilterSource = this.dataModel.filters && this.dataModel.filters.sources && this.dataModel.filters.sources.value
        this.selectedContainment = this.selectedContainment.filter(value => {
          return globalFilterSource.includes(value);
        });

        this.transcriptFilters['conversationTypes'] = this.selectedContainment;
      }
      if(this.selectedSentiment.length > 0) {
        this.transcriptFilters['sentiment'] = this.selectedSentiment;
      }
      if(this.selectedFeedback.length > 0) {
        this.transcriptFilters['feedback'] = this.selectedFeedback;
      }

      //agent queue, agent group, agent id
      if(this.localAgentQueues != null) {
        let agentQueuesFilter = JSON.parse(JSON.stringify(this.localAgentQueues.value)) || [];
        if(agentQueuesFilter.length > 0) {
          if(agentQueuesFilter.includes('all')) {
            agentQueuesFilter = agentQueuesFilter.filter(e => e !== 'all');
          }else if(agentQueuesFilter.includes('')) {
            agentQueuesFilter.push(null);
          }
          this.transcriptFilters['agentQueues'] = agentQueuesFilter;
        }
      }
      if(this.localAgentGroups != null) {
        let agentGroupsFilter = JSON.parse(JSON.stringify(this.localAgentGroups.value)) || [];
        if(agentGroupsFilter.length > 0) {
          if(agentGroupsFilter.includes('all')) {
            agentGroupsFilter = agentGroupsFilter.filter(e => e !== 'all');
          }else if(agentGroupsFilter.includes('')) {
            agentGroupsFilter.push(null);
          }
          this.transcriptFilters['agentGroups'] = agentGroupsFilter;
        }
      }
      if(this.localAgentIds != null) {
        let agentIdsFilter = JSON.parse(JSON.stringify(this.localAgentIds.value)) || [];
        if(agentIdsFilter.length > 0) {
          if(agentIdsFilter.includes('all')) {
            agentIdsFilter = agentIdsFilter.filter(e => e !== 'all');
          }else if(agentIdsFilter.includes('')) {
            agentIdsFilter.push(null);
          }
          this.transcriptFilters['agentIds'] = agentIdsFilter;
        }
      }
      if(Object.keys(this.handlingTimeFilter).length > 0) {
        let timeRangeFilter = this.handleTimeRangeFilter(this.handlingTimeFilter);
        if(this.handlingTimeHasError) {
          let fromValue = this.handlingTimeFilter.fromValue;
          let toValue = this.handlingTimeFilter.toValue;
          this.handlingTimeFilter.fromValue = toValue;
          this.handlingTimeFilter.toValue = fromValue;
        }

        if(timeRangeFilter.fromValue  || timeRangeFilter.fromValue === 0) {
          this.transcriptFilters['handleTimeMillisMin'] = timeRangeFilter.fromValue;
        }
        else {
          // this.transcriptFilters['handleTimeMillisMin'] = 0;
          delete this.transcriptFilters['handleTimeMillisMin']
        }
        if(timeRangeFilter.toValue || timeRangeFilter.toValue === 0) {
          this.transcriptFilters['handleTimeMillisMax'] = timeRangeFilter.toValue;
        }
        else {
          // this.transcriptFilters['handleTimeMillisMax'] = 0;
          delete this.transcriptFilters['handleTimeMillisMax']
        }
      }
      // if(Object.keys(this.responseTimeFilter).length > 0) {
      //   let timeRangeFilter = this.handleTimeRangeFilter(this.responseTimeFilter);
      //   if(this.responseTimeHasError) {
      //     let fromValue = this.responseTimeFilter.fromValue;
      //     let toValue = this.responseTimeFilter.toValue;
      //     this.responseTimeFilter.fromValue = toValue;
      //     this.responseTimeFilter.toValue = fromValue;
      //   }

      //   if(timeRangeFilter.fromValue  || timeRangeFilter.fromValue===0) {
      //     this.transcriptFilters['responseTimeMillisMin'] = timeRangeFilter.fromValue;
      //   }
      //   else {
      //     // this.transcriptFilters['responseTimeMillisMin'] = 0;
      //     delete this.transcriptFilters['responseTimeMillisMin']
      //   }
      //   if(timeRangeFilter.toValue || timeRangeFilter.toValue===0) {
      //     this.transcriptFilters['responseTimeMillisMax'] = timeRangeFilter.toValue;
      //   }
      //   else {
      //     // this.transcriptFilters['responseTimeMillisMax'] = 0;
      //     delete this.transcriptFilters['responseTimeMillisMax']
      //   }
      // }
      
      if(Object.keys(this.agentHandlingTimeFilter).length > 0) {
        let timeRangeFilter = this.handleTimeRangeFilter(this.agentHandlingTimeFilter);
        if(this.agentHandlingTimeHasError) {
          let fromValue = this.agentHandlingTimeFilter.fromValue;
          let toValue = this.agentHandlingTimeFilter.toValue;
          this.agentHandlingTimeFilter.fromValue = toValue;
          this.agentHandlingTimeFilter.toValue = fromValue;
        }

        if(timeRangeFilter.fromValue  || timeRangeFilter.fromValue === 0) {
          this.transcriptFilters['agentHandleTimeMillisMin'] = timeRangeFilter.fromValue;
        }
        else {
          delete this.transcriptFilters['agentHandleTimeMillisMin']
        }
        if(timeRangeFilter.toValue || timeRangeFilter.toValue === 0) {
          this.transcriptFilters['agentHandleTimeMillisMax'] = timeRangeFilter.toValue;
        }
        else {
          delete this.transcriptFilters['agentHandleTimeMillisMax']
        }
      }
      if(Object.keys(this.agentResponseTimeFilter).length > 0) {
        let timeRangeFilter = this.handleTimeRangeFilter(this.agentResponseTimeFilter);
        if(this.agentResponseTimeHasError) {
          let fromValue = this.agentResponseTimeFilter.fromValue;
          let toValue = this.agentResponseTimeFilter.toValue;
          this.agentResponseTimeFilter.fromValue = toValue;
          this.agentResponseTimeFilter.toValue = fromValue;
        }

        if(timeRangeFilter.fromValue  || timeRangeFilter.fromValue === 0) {
          this.transcriptFilters['agentResponseTimeMillisMin'] = timeRangeFilter.fromValue;
        }
        else {
          delete this.transcriptFilters['agentResponseTimeMillisMin']
        }
        if(timeRangeFilter.toValue || timeRangeFilter.toValue === 0) {
          this.transcriptFilters['agentResponseTimeMillisMax'] = timeRangeFilter.toValue;
        }
        else {
          delete this.transcriptFilters['agentResponseTimeMillisMax']
        }
      }
      if(Object.keys(this.agentWaitTimeFilter).length > 0) {
        let timeRangeFilter = this.handleTimeRangeFilter(this.agentWaitTimeFilter);
        if(this.agentWaitTimeHasError) {
          let fromValue = this.agentWaitTimeFilter.fromValue;
          let toValue = this.agentWaitTimeFilter.toValue;
          this.agentWaitTimeFilter.fromValue = toValue;
          this.agentWaitTimeFilter.toValue = fromValue;
        }

        if(timeRangeFilter.fromValue  || timeRangeFilter.fromValue === 0) {
          this.transcriptFilters['agentWaitTimeMillisMin'] = timeRangeFilter.fromValue;
        }
        else {
          delete this.transcriptFilters['agentWaitTimeMillisMin']
        }
        if(timeRangeFilter.toValue || timeRangeFilter.toValue === 0) {
          this.transcriptFilters['agentWaitTimeMillisMax'] = timeRangeFilter.toValue;
        }
        else {
          delete this.transcriptFilters['agentWaitTimeMillisMax']
        }
      }

      if(Object.keys(this.handOffsFilter).length > 0) {
        if((this.handOffsFilter.fromValue || this.handOffsFilter.fromValue === 0) && (this.handOffsFilter.toValue || this.handOffsFilter.toValue === 0)) {
          if(this.handOffsHasError) {
            let fromValue = this.handOffsFilter.fromValue;
            let toValue = this.handOffsFilter.toValue;
            this.handOffsFilter.fromValue = toValue;
            this.handOffsFilter.toValue = fromValue;
          }
          this.transcriptFilters['handOffsMin'] = (this.handOffsFilter.fromValue < this.handOffsFilter.toValue) ? this.handOffsFilter.fromValue : this.handOffsFilter.toValue;
          this.transcriptFilters['handOffsMax'] = (this.handOffsFilter.fromValue < this.handOffsFilter.toValue) ? this.handOffsFilter.toValue : this.handOffsFilter.fromValue;
        }
        else
        {
          if(this.handOffsFilter.fromValue || this.handOffsFilter.fromValue === 0) {
            this.transcriptFilters['handOffsMin'] = this.handOffsFilter.fromValue;
          }
          else {
            // this.transcriptFilters['handOffsMin'] = 0;
            delete this.transcriptFilters['handOffsMin']
          }
          if(this.handOffsFilter.toValue || this.handOffsFilter.toValue === 0) {
            this.transcriptFilters['handOffsMax'] = this.handOffsFilter.toValue;
          }
          else {
            // this.transcriptFilters['handOffsMax'] = 0;
            delete this.transcriptFilters['handOffsMax']
          }
        }

        //OC-1805
        //check if abandoned, negativefeedback get added/removed from the filter
        let abandonedRemoved = false;
        let abandonedAdded = false;
        let negativeFeedbackRemoved = false;
        let negativeFeedbackAdded = false;
        // //OC-1855
        // //check if BAS escalation (hasLiveAgentEscalationSignal) get added/removed from the filter
        // let escalationRemoved = false;
        // let escalationAdded = false;

        if((this.localFilterMap.selectedBesSignals && this.localFilterMap.selectedBesSignals.includes('hasAbandonedByUserSignal') && !this.selectedBesSignals.includes('hasAbandonedByUserSignal'))
        || (this.localFilterMap.selectedBasSignals && this.localFilterMap.selectedBasSignals.includes('hasAbandonedByUserSignal') && !this.selectedBasSignals.includes('hasAbandonedByUserSignal'))  
        ){
          abandonedRemoved = true;
        }
        if((this.localFilterMap.selectedBesSignals && !this.localFilterMap.selectedBesSignals.includes("hasAbandonedByUserSignal") && this.selectedBesSignals.includes('hasAbandonedByUserSignal'))
        || (this.localFilterMap.selectedBasSignals && !this.localFilterMap.selectedBasSignals.includes("hasAbandonedByUserSignal") && this.selectedBasSignals.includes('hasAbandonedByUserSignal'))  
        ){
          abandonedAdded = true;
        }

        if((this.localFilterMap.selectedBesSignals && this.localFilterMap.selectedBesSignals.includes('hasNegativeFeedbackSignal') && !this.selectedBesSignals.includes('hasNegativeFeedbackSignal'))
        || (this.localFilterMap.selectedBasSignals && this.localFilterMap.selectedBasSignals.includes('hasNegativeFeedbackSignal') && !this.selectedBasSignals.includes('hasNegativeFeedbackSignal'))  
        // || (this.localFilterMap.selectedFeedback && this.localFilterMap.selectedFeedback.includes('neg') && !this.selectedFeedback.includes('neg'))
        ){
          negativeFeedbackRemoved = true;
        }
        if((this.localFilterMap.selectedBesSignals && !this.localFilterMap.selectedBesSignals.includes('hasNegativeFeedbackSignal') && this.selectedBesSignals.includes('hasNegativeFeedbackSignal'))
        || (this.localFilterMap.selectedBasSignals && !this.localFilterMap.selectedBasSignals.includes('hasNegativeFeedbackSignal') && this.selectedBasSignals.includes('hasNegativeFeedbackSignal'))  
        // || (this.localFilterMap.selectedFeedback && !this.localFilterMap.selectedFeedback.includes('neg') && this.selectedFeedback.includes('neg'))
        ){
          negativeFeedbackAdded = true;
        }

        // if((this.localFilterMap.selectedBasSignals && this.localFilterMap.selectedBasSignals.includes('hasLiveAgentEscalationSignal') && !this.selectedBasSignals.includes('hasLiveAgentEscalationSignal'))
        // || (this.localFilterMap.selectedContainment && ['BotOnlyEscalated', 'BotToLC'].every(containment => this.localFilterMap.selectedContainment.includes(containment)) && !['BotOnlyEscalated', 'BotToLC'].every(containment => this.selectedContainment.includes(containment))) 
        // ){
        //   escalationRemoved = true;
        // }
        // if((this.localFilterMap.selectedBasSignals && !this.localFilterMap.selectedBasSignals.includes('hasLiveAgentEscalationSignal') && this.selectedBasSignals.includes('hasLiveAgentEscalationSignal'))
        // || (this.localFilterMap.selectedContainment && !['BotOnlyEscalated', 'BotToLC'].every(containment => this.localFilterMap.selectedContainment.includes(containment)) && ['BotOnlyEscalated', 'BotToLC'].every(containment => this.selectedContainment.includes(containment)))
        // ){
        //   escalationAdded = true;
        // }

        if(this.selectedBesSignals.length > 0 || this.selectedBasSignals.length > 0) { 
          //|| this.selectedFeedback.length > 0) {
          //if add, then push
          if(abandonedAdded) {
            if(!this.selectedBesSignals.includes('hasAbandonedByUserSignal')){
              this.selectedBesSignals.push('hasAbandonedByUserSignal');
            }
            if(!this.selectedBasSignals.includes('hasAbandonedByUserSignal')){
              this.selectedBasSignals.push('hasAbandonedByUserSignal');
            }
          }
          if(negativeFeedbackAdded) {
            if(!this.selectedBesSignals.includes('hasNegativeFeedbackSignal')){
              this.selectedBesSignals.push('hasNegativeFeedbackSignal');
            }
            if(!this.selectedBasSignals.includes('hasNegativeFeedbackSignal')){
              this.selectedBasSignals.push('hasNegativeFeedbackSignal');
            }
            // if(!this.selectedFeedback.includes('neg')){
            //   this.selectedFeedback.push('neg');
            // }
          }
          //if remove, then pop
          if(abandonedRemoved) {
            if(this.selectedBesSignals.includes('hasAbandonedByUserSignal')){
              this.selectedBesSignals = this.selectedBesSignals.filter(x => x !== 'hasAbandonedByUserSignal')
            }
            if(this.selectedBasSignals.includes('hasAbandonedByUserSignal')){
              this.selectedBasSignals = this.selectedBasSignals.filter(x => x !== 'hasAbandonedByUserSignal')
            }
          }
          if(negativeFeedbackRemoved) {
            if(this.selectedBesSignals.includes('hasNegativeFeedbackSignal')){
              this.selectedBesSignals = this.selectedBesSignals.filter(x => x !== 'hasNegativeFeedbackSignal')
            }
            if(this.selectedBasSignals.includes('hasNegativeFeedbackSignal')){
              this.selectedBasSignals = this.selectedBasSignals.filter(x => x !== 'hasNegativeFeedbackSignal')
            }
            // if(this.selectedFeedback.includes('neg')){
            //   this.selectedFeedback = this.selectedFeedback.filter(x => x !== 'neg')
            // }
          }
          this.transcriptFilters['besSignals'] = this.selectedBesSignals;
          this.transcriptFilters['basSignals'] = this.selectedBasSignals;
          // this.transcriptFilters['feedback'] = this.selectedFeedback;
        } //OC-1805

        // if(this.selectedBasSignals.length > 0 || this.selectedContainment.length > 0) {
        //   //if add, then push
        //   if(escalationAdded) {
        //     if(!this.selectedBasSignals.includes('hasLiveAgentEscalationSignal')){
        //       this.selectedBasSignals.push('hasLiveAgentEscalationSignal');
        //     }
        //     if(!['BotOnlyEscalated', 'BotToLC'].every(containment => this.selectedContainment.includes(containment))){
        //       ['BotOnlyEscalated', 'BotToLC'].forEach(containment => {
        //         if(!this.selectedContainment.includes(containment)){
        //           this.selectedContainment.push(containment);
        //         }
        //       });
        //     }
        //   }
        //   //if remove, then pop
        //   if(escalationRemoved) {
        //     if(this.selectedBasSignals.includes('hasLiveAgentEscalationSignal')){
        //       this.selectedBasSignals = this.selectedBasSignals.filter(x => x !== 'hasLiveAgentEscalationSignal')
        //     }
        //     if(['BotOnlyEscalated', 'BotToLC'].every(containment => this.selectedContainment.includes(containment))){
        //       this.selectedContainment = this.selectedContainment.filter(x => !['BotOnlyEscalated', 'BotToLC'].includes(x))
        //     }
        //   }

        //   this.transcriptFilters['basSignals'] = this.selectedBasSignals;
        //   this.transcriptFilters['conversationTypes'] = this.selectedContainment;
        // } //OC-1855
      }
      this.localFilterMap.selectedContactReasons = JSON.parse(JSON.stringify(this.selectedContactReasons));
      this.localFilterMap.selectedResponseNames = JSON.parse(JSON.stringify(this.selectedResponseNames));
      this.localFilterMap.selectedRelatedTopics = JSON.parse(JSON.stringify(this.selectedRelatedTopics));
      this.localFilterMap.selectedIntentNames = JSON.parse(JSON.stringify(this.selectedIntentNames));

      this.localFilterMap.selectedContainment = this.selectedContainment;
      this.localFilterMap.selectedSentiment = this.selectedSentiment;
      this.localFilterMap.selectedFeedback = this.selectedFeedback;
      this.localFilterMap.selectedBesSignals = this.selectedBesSignals;
      this.localFilterMap.selectedBasSignals = this.selectedBasSignals;
      this.localFilterMap.handlingTimeFilter = JSON.parse(JSON.stringify(this.handlingTimeFilter));
      this.localFilterMap.responseTimeFilter = JSON.parse(JSON.stringify(this.responseTimeFilter));
      this.localFilterMap.handOffsFilter = JSON.parse(JSON.stringify(this.handOffsFilter));
      this.localFilterMap.agentHandlingTimeFilter = JSON.parse(JSON.stringify(this.agentHandlingTimeFilter));
      this.localFilterMap.agentResponseTimeFilter = JSON.parse(JSON.stringify(this.agentResponseTimeFilter));
      this.localFilterMap.agentWaitTimeFilter = JSON.parse(JSON.stringify(this.agentWaitTimeFilter));
      this.localFilterMap.localAgentQueues = JSON.parse(JSON.stringify(this.localAgentQueues));
      this.localFilterMap.localAgentGroups = JSON.parse(JSON.stringify(this.localAgentGroups));
      this.localFilterMap.localAgentIds = JSON.parse(JSON.stringify(this.localAgentIds));

      this.handlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.handlingTimeFilter));
      this.responseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.responseTimeFilter));
      this.handOffsFilter = JSON.parse(JSON.stringify(this.localFilterMap.handOffsFilter));
      this.agentHandlingTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentHandlingTimeFilter));
      this.agentResponseTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentResponseTimeFilter));
      this.agentWaitTimeFilter = JSON.parse(JSON.stringify(this.localFilterMap.agentWaitTimeFilter));
      this.localAgentQueues = JSON.parse(JSON.stringify(this.localFilterMap.localAgentQueues));
      this.localAgentGroups = JSON.parse(JSON.stringify(this.localFilterMap.localAgentGroups));
      this.localAgentIds = JSON.parse(JSON.stringify(this.localFilterMap.localAgentIds));

      this.localFilterMap.searchType = this.searchType;
      this.localFilterMap.searchKeyword = this.searchKeyword;
      this.localFilterMap.isShowGroups = this.isShowGroups;
      this.localFilterMap.advancedFilterPayload = JSON.parse(JSON.stringify(this.advancedFilterPayload));

    },

    handleTimeRangeFilter(timeRangeFilter) {
      let fromValue = this.timeToMilliSecond(timeRangeFilter.fromValue);
      let toValue = this.timeToMilliSecond(timeRangeFilter.toValue);
      if((fromValue || fromValue === 0) && (toValue || toValue === 0)) {
        return (fromValue < toValue) ? {'fromValue': fromValue, 'toValue': toValue} : {'fromValue': toValue, 'toValue': fromValue};
      }
      else {
        return {'fromValue': fromValue, 'toValue': toValue}
      }
    },

    milliSecondToTimeFormat(obj, seconds) {
      obj.hh = '00';
      obj.mm = '00';
      obj.ss = '00';
      let hours = parseInt(seconds / 3600);
      hours = (hours > 99) ? 99 : hours; // set max hours as 99, ned to remove it after
      let formatedHours = (hours>9)?""+hours:"0"+hours;
      seconds = seconds % 3600;
      let minutes = parseInt( seconds / 60);
      let formatedMinutes = (minutes>9)?""+minutes:"0"+minutes;
      seconds = parseInt(seconds % 60);
      let formatedSeconds = (seconds>9)?""+seconds:"0"+seconds;
      obj.hh = formatedHours;
      obj.mm = formatedMinutes;
      obj.ss = formatedSeconds;
    },

    timeToMilliSecond(timeObj) {
      let milliSecond = null;

      if(timeObj && timeObj.hh == "" && timeObj.mm == "" && timeObj.ss == "") {
        return null;
      }
      else if(timeObj) {
        milliSecond = ((WyUtils.toInt(timeObj.hh, 0) * 60 * 60) + (WyUtils.toInt(timeObj.mm, 0) * 60) + WyUtils.toInt(timeObj.ss, 0)) * 1000;
      }
      return milliSecond;
    },

    applySearch(el, filterName="Direct Search Activation") {
      setTimeout(() => {
        document.querySelectorAll('.global-filter-picker-multiple-popper').forEach(el => {
          el.style.display = "none";
        })
        if(this.$refs.localAgentFilter && this.$refs.localAgentFilter.showPopper) {
          this.agentCancel();
        }
        if(this.$refs.allFilters && this.$refs.allFilters.showPopper) {
          this.cancelAllfilters();
        }
        if(this.$refs.contactReasonFilter && this.$refs.contactReasonFilter.visible) {
          this.$refs.contactReasonFilter.hide()
        }
        if(this.$refs.containmentFilter && this.$refs.containmentFilter.visible) {
          this.$refs.containmentFilter.hide()
        }
        if(this.$refs.responseNameFilter && this.$refs.responseNameFilter.visible) {
          this.$refs.responseNameFilter.hide()
        }
        if(this.$refs.relatedTopicsFilter && this.$refs.relatedTopicsFilter.visible) {
          this.$refs.relatedTopicsFilter.hide()
        }
        if(this.$refs.intentNameFilter && this.$refs.intentNameFilter.visible) {
          this.$refs.intentNameFilter.hide()
        }
        if(this.$refs.responseTimeFilter && this.$refs.responseTimeFilter.visible) {
          this.$refs.responseTimeFilter.hide()
        }
        if(this.$refs.handlingTimeFilter && this.$refs.handlingTimeFilter.visible) {
          this.$refs.handlingTimeFilter.hide()
        }
        if(this.$refs.sentimentFilter && this.$refs.sentimentFilter.visible) {
          this.$refs.sentimentFilter.hide()
        }
        if(this.$refs.feedbackFilter && this.$refs.feedbackFilter.visible) {
          this.$refs.feedbackFilter.hide()
        }
        if(this.$refs.handoffsFilter && this.$refs.handoffsFilter.visible) {
          this.$refs.handoffsFilter.hide()
        }
        //OC-1805
        if(this.$refs.besSignalsFilter && this.$refs.besSignalsFilter.visible) {
          this.$refs.besSignalsFilter.hide()
        }
        if(this.$refs.basSignalsFilter && this.$refs.basSignalsFilter.visible) {
          this.$refs.basSignalsFilter.hide()
        }
        //OC-1805
      }, 0);

      this.prepareFilters();
      this.transcriptFilters['action'] = 'search';
      if(el && el.hide) {
        el.hide();
      }

      if(this.$refs.localAgentQueuesDropdown) this.$refs.localAgentQueuesDropdown.closeDropdown();
      if(this.$refs.localAgentGroupsDropdown) this.$refs.localAgentGroupsDropdown.closeDropdown();
      if(this.$refs.localAgentIdsDropdown) this.$refs.localAgentIdsDropdown.closeDropdown();
      if(this.$refs.localAgentQueuesDropdownAllFilter) this.$refs.localAgentQueuesDropdown.closeDropdown();
      if(this.$refs.localAgentGroupsDropdownAllFilter) this.$refs.localAgentGroupsDropdown.closeDropdown();
      if(this.$refs.localAgentIdsDropdownAllFilter) this.$refs.localAgentIdsDropdown.closeDropdown();

      setTimeout(()=>{
        this.transcriptSearchResultsComponent.loadTopicConversations(1, false, filterName);
        this.appliedFilterCount = 0
        this.appliedSearchKeyword = this.searchKeyword!="";
        this.localFilterMap.searchKeyword = this.searchKeyword;
        this.localFilterMap.searchType = this.searchType;
        this.localFilterMap.isShowGroups = this.isShowGroups;
        this.isSavedTranscriptResultSelected = this.savedTranscriptResult;
        // if(this.transcriptFilters.responseTimeMillisMin !== this.localFilters.responseTime.minResponsetime * 1000
        // || this.transcriptFilters.responseTimeMillisMax !== this.localFilters.responseTime.maxResponseTime * 1000)
        // if((typeof this.transcriptFilters.responseTimeMillisMin != 'undefined' && this.transcriptFilters.responseTimeMillisMin !== this.localFilters.responseTime.minResponsetime * 1000
        //   || typeof this.transcriptFilters.responseTimeMillisMin == 'undefined' && this.localFilters.responseTime.minResponsetime * 1000 !== 0)
        //   || this.transcriptFilters.responseTimeMillisMax !== this.localFilters.responseTime.maxResponseTime * 1000)
        // {
        //   this.localFilters.responseTime.updated = true;
        //   this.appliedFilterCount  = this.appliedFilterCount + 1
        // } else {
        //   this.localFilters.responseTime.updated = false;
        // }
        // if(this.transcriptFilters.handleTimeMillisMin !== this.localFilters.handlingTime.minHandlingTime * 1000
        // || this.transcriptFilters.handleTimeMillisMax !== this.localFilters.handlingTime.maxHandlingTime * 1000)
        if((typeof this.transcriptFilters.handleTimeMillisMin != 'undefined' && this.transcriptFilters.handleTimeMillisMin !== this.localFilters.handlingTime.minHandlingTime * 1000
          || typeof this.transcriptFilters.handleTimeMillisMin == 'undefined' && this.localFilters.handlingTime.minHandlingTime * 1000 !== 0)
          || this.transcriptFilters.handleTimeMillisMax !== this.localFilters.handlingTime.maxHandlingTime * 1000)
        {
          this.localFilters.handlingTime.updated = true;
          this.appliedFilterCount  = this.appliedFilterCount + 1
        } else {
          this.localFilters.handlingTime.updated = false;
        }
        // if(this.transcriptFilters.handOffsMin !== this.localFilters.handOffs.minHandOffs
        // || this.transcriptFilters.handOffsMax !== this.localFilters.handOffs.maxHandOffs) {
        if((typeof this.transcriptFilters.handOffsMin != 'undefined' && this.transcriptFilters.handOffsMin !== this.localFilters.handOffs.minHandOffs
          || typeof this.transcriptFilters.handOffsMin == 'undefined' && this.localFilters.handOffs.minHandOffs !== 0)
          || this.transcriptFilters.handOffsMax !== this.localFilters.handOffs.maxHandOffs) {
          this.localFilters.handOffs.updated = true;
          this.appliedFilterCount  = this.appliedFilterCount + 1
        }
        else {
          this.localFilters.handOffs.updated = false;
        }

        // agent time filter

        const agentHandleTimeCondition = (typeof this.transcriptFilters.agentHandleTimeMillisMin != 'undefined' && this.transcriptFilters.agentHandleTimeMillisMin !== this.localFilters.agentHandlingTime.minAgentHandlingTime * 1000
          || typeof this.transcriptFilters.agentHandleTimeMillisMin == 'undefined' && this.localFilters.agentHandlingTime.minAgentHandlingTime * 1000 !== 0)
          || this.transcriptFilters.agentHandleTimeMillisMax !== this.localFilters.agentHandlingTime.maxAgentHandlingTime * 1000

        const agentResponseTimeCondition = (typeof this.transcriptFilters.agentResponseTimeMillisMin != 'undefined' && this.transcriptFilters.agentResponseTimeMillisMin !== this.localFilters.agentResponseTime.minAgentResponseTime * 1000
          || typeof this.transcriptFilters.agentResponseTimeMillisMin == 'undefined' && this.localFilters.agentResponseTime.minAgentResponseTime * 1000 !== 0)
          || this.transcriptFilters.agentResponseTimeMillisMax !== this.localFilters.agentResponseTime.maxAgentResponseTime * 1000

        const agentWaitTimeCondition = (typeof this.transcriptFilters.agentWaitTimeMillisMin != 'undefined' && this.transcriptFilters.agentWaitTimeMillisMin !== this.localFilters.agentWaitTime.minAgentWaitTime * 1000
          || typeof this.transcriptFilters.agentWaitTimeMillisMin == 'undefined' && this.localFilters.agentWaitTime.minAgentWaitTime * 1000 !== 0)
          || this.transcriptFilters.agentWaitTimeMillisMax !== this.localFilters.agentWaitTime.maxAgentWaitTime * 1000

        if(this.transcriptFilters['agentQueues'] && this.transcriptFilters['agentQueues'].length>0) {
          this.appliedFilterCount  = this.appliedFilterCount + 1;
          this.localFilters.agent.updated = true;
        }
        if(this.transcriptFilters['agentGroups'] && this.transcriptFilters['agentGroups'].length>0) {
          this.appliedFilterCount  = this.appliedFilterCount + 1
          this.localFilters.agent.updated = true;
        }
        if(this.transcriptFilters['agentIds'] && this.transcriptFilters['agentIds'].length>0) {
          this.appliedFilterCount  = this.appliedFilterCount + 1;
          this.localFilters.agent.updated = true;
        }

        if((!this.transcriptFilters['agentQueues'] || (this.transcriptFilters['agentQueues'] && this.transcriptFilters['agentQueues'].length == 0))
        && (!this.transcriptFilters['agentGroups'] || (this.transcriptFilters['agentGroups'] && this.transcriptFilters['agentGroups'].length == 0))
        && (!this.transcriptFilters['agentIds']    || (this.transcriptFilters['agentIds']    && this.transcriptFilters['agentIds'].length == 0))
        && !agentHandleTimeCondition 
        && !agentResponseTimeCondition 
        && !agentWaitTimeCondition
        ){
          this.localFilters.agent.updated = false;
        }

        // agent handle time
        if (agentHandleTimeCondition) {
          this.localFilters.agent.updated = true;
          this.localFilters.agentHandlingTime.updated = true;
          this.appliedFilterCount  = this.appliedFilterCount + 1
        } else {
          this.localFilters.agentHandlingTime.updated = false;
        }
        // agent response time
        if (agentResponseTimeCondition) {
          this.localFilters.agent.updated = true;
          this.localFilters.agentResponseTime.updated = true;
          this.appliedFilterCount  = this.appliedFilterCount + 1
        } else {
          this.localFilters.agentResponseTime.updated = false;
        }
        // agent wait time
        if (agentWaitTimeCondition) {
          this.localFilters.agent.updated = true;
          this.localFilters.agentWaitTime.updated = true;
          this.appliedFilterCount  = this.appliedFilterCount + 1
        } else {
          this.localFilters.agentWaitTime.updated = false;
        }
        // end of agent time filter

        if(this.transcriptFilters['conversationTypes'] && this.transcriptFilters['conversationTypes'].length>0) {
          this.appliedFilterCount  = this.appliedFilterCount + 1
        }
        if(!this.contactReason || this.contactReason == "") {
          if(this.transcriptFilters['topicDisplayNames'] && this.transcriptFilters['topicDisplayNames'].length>0) {
            this.appliedFilterCount  = this.appliedFilterCount + 1
          }
        }
        if(this.transcriptFilters['responseNames'] && this.transcriptFilters['responseNames'].length>0) {
          this.appliedFilterCount  = this.appliedFilterCount + 1
        }
        if(this.transcriptFilters['relatedTopics'] && this.transcriptFilters['relatedTopics'].length>0) {
          this.appliedFilterCount  = this.appliedFilterCount + 1
        }
        if(this.transcriptFilters['intentNames'] && this.transcriptFilters['intentNames'].length>0) {
          this.appliedFilterCount  = this.appliedFilterCount + 1
        }

        if(this.transcriptFilters['sentiment'] && this.transcriptFilters['sentiment'].length>0) {
          this.appliedFilterCount  = this.appliedFilterCount + 1
        }
        if(this.transcriptFilters['feedback'] && this.transcriptFilters['feedback'].length>0) {
          this.appliedFilterCount  = this.appliedFilterCount + 1
        }
        if(this.transcriptFilters['besSignals'] && this.transcriptFilters['besSignals'].length>0) {
          this.appliedFilterCount  = this.appliedFilterCount + 1
        }
        if(this.transcriptFilters['basSignals'] && this.transcriptFilters['basSignals'].length>0) {
          this.appliedFilterCount  = this.appliedFilterCount + 1
        }

        const isNotEmptySearch = this.advancedFilterPayload.groupA.conditions.every(condition => condition.value && condition.value != '');
        if (isNotEmptySearch) {
          this.isSearchInputDisabled = true;
          this.handleCreateTags();
        }

      }, 200)

      // close advanced filter (in case it's open)
      this.handleCloseAdvancedSearch();
    },

    applyExport() {
      if(this.transcriptSearchResultsComponent && this.transcriptSearchResultsComponent.applyExport) {
        if (!this.checkAdvancedFilterIsEmpty()) {
          const advancedFilter = this.getAdvancedFilterPayload();
          this.transcriptFilters['advancedFilter'] = advancedFilter;
        }
        this.transcriptSearchResultsComponent.applyExport();
      }
    },

    selectAllContactReasons() {
      if(this.isContactReasonSelectedAll) {
        this.filterdContactReasons.forEach(item => {
          if(!this.selectedContactReasons.includes(item.topicDisplayName)) {
            this.selectedContactReasons.push(item.topicDisplayName);
          }
        })
      }
      else {
        this.filterdContactReasons.forEach(item => {
          this.selectedContactReasons = this.selectedContactReasons.filter(f => f !== item.topicDisplayName)
        })
      }
      // this.isSelectedAll = true;
    },

    selectAllResponseNames() {
      if(this.isResponseNameSelectedAll) {
        this.filteredResponseNames.forEach(item => {
          if(!this.selectedResponseNames.includes(item.responseName)) {
            this.selectedResponseNames.push(item.responseName);
          }
        })
      }
      else {
        this.filteredResponseNames.forEach(item => {
          this.selectedResponseNames = this.selectedResponseNames.filter(f => f !== item.responseName)
        })
      }
    },

    selectAllRelatedTopics() {
      if(this.isRelatedTopicsSelectedAll) {
        this.filteredRelatedTopics.forEach(item => {
          if(!this.selectedRelatedTopics.includes(item.topicName)) {
            this.selectedRelatedTopics.push(item.topicName);
          }
        })
      }
      else {
        this.filteredRelatedTopics.forEach(item => {
          this.selectedRelatedTopics = this.selectedRelatedTopics.filter(f => f !== item.topicName)
        })
      }
    },

    selectAllIntentNames() {
      if(this.isIntentNameSelectedAll) {
        this.filteredIntentNames.forEach(item => {
          if(!this.selectedIntentNames.includes(item.intentName)) {
            this.selectedIntentNames.push(item.intentName);
          }
        })
      }
      else {
        this.filteredIntentNames.forEach(item => {
          this.selectedIntentNames = this.selectedIntentNames.filter(f => f !== item.intentName)
        })
      }
    },

    resetContactReasons() {
      // this.isSelectedAll = false;
      this.selectedContactReasons = [];
    },

    resetResponseName() {
      this.selectedResponseNames = [];
    },

    resetIntentNames() {
      this.selectedIntentNames = [];
    },

    resetRelatedTopics() {
      this.selectedRelatedTopics = [];
    },

    resetSentiment() {
      this.selectedSentiment = [];
    },

    resetFeedback() {
      // if(this.selectedFeedback.length > 0) {
      //   this.selectedBesSignals = this.selectedFeedback.includes('neg') ? this.selectedBesSignals.filter(x => x !== 'hasNegativeFeedbackSignal') : this.selectedBesSignals;
      //   this.selectedBasSignals = this.selectedFeedback.includes('neg') ? this.selectedBasSignals.filter(x => x !== 'hasNegativeFeedbackSignal') : this.selectedBasSignals;
      // }
      this.selectedFeedback = [];
    },

    resetContainment() {
      // if(this.selectedContainment.length > 0) {
      //   this.selectedBasSignals = this.selectedContainment.includes(['BotOnlyEscalated', 'BotToLC']) ? this.selectedBasSignals.filter(x => x !== 'hasLiveAgentEscalationSignal') : this.selectedBasSignals;
      // }
      this.selectedContainment = [];
    },

    resetBesSignals() {
      if(this.selectedBesSignals.length > 0) {
        this.selectedBasSignals = this.selectedBesSignals.includes('hasAbandonedByUserSignal') ? this.selectedBasSignals.filter(x => x !== 'hasAbandonedByUserSignal') : this.selectedBasSignals;
        this.selectedBasSignals = this.selectedBesSignals.includes('hasNegativeFeedbackSignal') ? this.selectedBasSignals.filter(x => x !== 'hasNegativeFeedbackSignal') : this.selectedBasSignals;
        // this.selectedFeedback = this.selectedBesSignals.includes('hasNegativeFeedbackSignal') ? this.selectedFeedback.filter(x => x !== 'neg') : this.selectedFeedback;
      }
      this.selectedBesSignals = [];
    },

    resetBasSignals() {
      if(this.selectedBasSignals.length > 0) {
        this.selectedBesSignals = this.selectedBasSignals.includes('hasAbandonedByUserSignal') ? this.selectedBesSignals.filter(x => x !== 'hasAbandonedByUserSignal') : this.selectedBesSignals;
        this.selectedBesSignals = this.selectedBasSignals.includes('hasNegativeFeedbackSignal') ? this.selectedBesSignals.filter(x => x !== 'hasNegativeFeedbackSignal') : this.selectedBesSignals;
        // this.selectedFeedback = this.selectedBasSignals.includes('hasNegativeFeedbackSignal') ? this.selectedFeedback.filter(x => x !== 'neg') : this.selectedFeedback;
        // this.selectedContainment = this.selectedBasSignals.includes('hasLiveAgentEscalationSignal') ? this.selectedContainment.filter(x => !['BotOnlyEscalated', 'BotToLC'].includes(x)) : this.selectedContainment;
      }
      this.selectedBasSignals = [];
    },

    resetResponseTimeRange() {
      this.responseTimeFilter = {}
      this.responseTimeFilter.fromValue = {};
      this.responseTimeFilter.toValue = {};
      this.milliSecondToTimeFormat(this.responseTimeFilter.fromValue, this.localFilters.responseTime.minResponsetime);
      this.milliSecondToTimeFormat(this.responseTimeFilter.toValue, this.localFilters.responseTime.maxResponseTime);
    },

    resetHandlingTimeRange() {
      this.handlingTimeFilter = {}
      this.handlingTimeFilter.fromValue = {};
      this.handlingTimeFilter.toValue = {};
      this.milliSecondToTimeFormat(this.handlingTimeFilter.fromValue, this.localFilters.handlingTime.minHandlingTime);
      this.milliSecondToTimeFormat(this.handlingTimeFilter.toValue, this.localFilters.handlingTime.maxHandlingTime);
    },

    resetHandoffs() {
      this.handOffsFilter.fromValue = this.localFilters.handOffs.minHandOffs;
      this.handOffsFilter.toValue = this.localFilters.handOffs.maxHandOffs;
    },

    resetAgentHandlingTimeRange() {
      this.agentHandlingTimeFilter = {}
      this.agentHandlingTimeFilter.fromValue = {};
      this.agentHandlingTimeFilter.toValue = {};
      this.milliSecondToTimeFormat(this.agentHandlingTimeFilter.fromValue, this.localFilters.agentHandlingTime.minAgentHandlingTime);
      this.milliSecondToTimeFormat(this.agentHandlingTimeFilter.toValue, this.localFilters.agentHandlingTime.maxAgentHandlingTime);
    },

    resetAgentResponseTimeRange() {
      this.agentResponseTimeFilter = {}
      this.agentResponseTimeFilter.fromValue = {};
      this.agentResponseTimeFilter.toValue = {};
      this.milliSecondToTimeFormat(this.agentResponseTimeFilter.fromValue, this.localFilters.agentResponseTime.minAgentResponseTime);
      this.milliSecondToTimeFormat(this.agentResponseTimeFilter.toValue, this.localFilters.agentResponseTime.maxAgentResponseTime);
    },

    resetAgentWaitTimeRange() {
      this.agentWaitTimeFilter = {}
      this.agentWaitTimeFilter.fromValue = {};
      this.agentWaitTimeFilter.toValue = {};
      this.milliSecondToTimeFormat(this.agentWaitTimeFilter.fromValue, this.localFilters.agentWaitTime.minAgentWaitTime);
      this.milliSecondToTimeFormat(this.agentWaitTimeFilter.toValue, this.localFilters.agentWaitTime.maxAgentWaitTime);
    },

    resetAgents() {
      this.resetAgentHandlingTimeRange();
      this.resetAgentResponseTimeRange();
      this.resetAgentWaitTimeRange();
      if((this.dataModel.filters.agentQueues.value.length == 0) && (this.dataModel.filters.agentGroups.value.length == 0)
      && (this.dataModel.filters.agentIds.value.length == 0)) {
        this.localAgentQueues = JSON.parse(JSON.stringify(this.dataModel.filters.agentQueues));
        this.localAgentQueues.label = this.localAgentQueues.label;
        this.localAgentQueues.isDisabled = (this.dataModel.filters.agentQueues.value.length !== 0);
        this.agentQueuesDataSource = JSON.parse(JSON.stringify(this.localAgentQueues.dataSource));
        this.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
        this.localAgentGroups.label = this.localAgentGroups.label;
        this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
        this.agentGroupsDataSource = JSON.parse(JSON.stringify(this.localAgentGroups.dataSource));
        this.localAgentIds = JSON.parse(JSON.stringify(this.dataModel.filters.agentIds));
        this.localAgentIds.label = this.localAgentIds.label;
        this.localAgentIds.isDisabled = (this.dataModel.filters.agentIds.value.length !== 0);
        this.agentIdsDataSource = JSON.parse(JSON.stringify(this.localAgentIds.dataSource));
      }else {
        if(this.dataModel.filters.agentQueues.value.length !== 0) {
          this.localAgentQueues = JSON.parse(JSON.stringify(this.dataModel.filters.agentQueues));
          this.localAgentQueues.label = this.localAgentQueues.label;
          this.localAgentQueues.isDisabled = (this.dataModel.filters.agentQueues.value.length !== 0);
          this.agentQueuesDataSource = JSON.parse(JSON.stringify(this.localAgentQueues.dataSource));
          this.dataModel.filters.agentQueues.isEmpty = (this.agentQueuesDataSource.length == 1 && this.agentQueuesDataSource[0].key == 'all');
          this.localFilterMap.localAgentQueues = JSON.parse(JSON.stringify(this.localAgentQueues));
          this.refreshAgentQueues();
        }
        if(this.dataModel.filters.agentGroups.value.length !== 0) {
          this.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
          this.localAgentGroups.label = this.localAgentGroups.label;
          this.localAgentGroups.isDisabled = (this.dataModel.filters.agentGroups.value.length !== 0);
          this.agentGroupsDataSource = JSON.parse(JSON.stringify(this.localAgentGroups.dataSource));
          this.dataModel.filters.agentGroups.isEmpty = (this.agentGroupsDataSource.length == 1 && this.agentGroupsDataSource[0].key == 'all');
          this.localFilterMap.localAgentGroups = JSON.parse(JSON.stringify(this.localAgentGroups));
          this.refreshAgentGroups();
        }
        if(this.dataModel.filters.agentIds.value.length !== 0) {
          this.localAgentIds = JSON.parse(JSON.stringify(this.dataModel.filters.agentIds));
          this.localAgentIds.label = this.localAgentIds.label;
          this.localAgentIds.isDisabled = (this.dataModel.filters.agentIds.value.length !== 0);
          this.agentIdsDataSource = JSON.parse(JSON.stringify(this.localAgentIds.dataSource));
          this.dataModel.filters.agentIds.isEmpty = (this.agentIdsDataSource.length == 1 && this.agentIdsDataSource[0].key == 'all');
          this.localFilterMap.localAgentIds = JSON.parse(JSON.stringify(this.localAgentIds));
          this.refreshAgentIds();
        }
      }
    },

    refreshAgentQueues() {
      const agentQueuesValue = this.localAgentQueues.value || [];
      const agentGroupsValue = this.localAgentGroups.value || [];
      const agentIdsValue = this.localAgentIds.value || [];
      let agentGroups = _.groupBy(this.localStorage.agentData.filter(item => (item.ag != null && (agentQueuesValue.length==0 || agentQueuesValue.includes('all') || agentQueuesValue.includes(item.aq)) && (agentIdsValue.length==0 || agentIdsValue.includes('all') || agentIdsValue.includes(item.ai)))), "ag");
      let agentGroupsDS = Object.keys(agentGroups).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentGroups[key]} });
      let agentGroupsValues = agentGroupsDS.map(item => item.key);
      this.agentGroupsDataSource.splice(1, this.agentGroupsDataSource.length);
      this.agentGroupsDataSource.push(...agentGroupsDS);
      this.localAgentGroups.value = this.localAgentGroups.value.filter(val => agentGroupsValues.includes(val));
      this.localAgentGroups.isEmpty = (this.agentGroupsDataSource.length == 1 && this.agentGroupsDataSource[0].key == 'all');
      let agentIds = _.groupBy(this.localStorage.agentData.filter(item => (item.ai != null && (agentQueuesValue.length==0 || agentQueuesValue.includes('all') || agentQueuesValue.includes(item.aq)) && (agentGroupsValue.length==0 || agentGroupsValue.includes('all') || agentGroupsValue.includes(item.ag)))), "ai");
      let agentIdsDS = Object.keys(agentIds).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentIds[key]} });
      let agentIdsValues = agentIdsDS.map(item => item.key);
      this.agentIdsDataSource.splice(1, this.agentIdsDataSource.length);
      this.agentIdsDataSource.push(...agentIdsDS);
      this.localAgentIds.value = this.localAgentIds.value.filter(val => agentIdsValues.includes(val));
      this.localAgentIds.isEmpty = (this.agentIdsDataSource.length == 1 && this.agentIdsDataSource[0].key == 'all');
    },

    refreshAgentGroups() {
      const agentQueuesValue = this.localAgentQueues.value || [];
      const agentGroupsValue = this.localAgentGroups.value || [];
      const agentIdsValue = this.localAgentIds.value || [];
      let agentQueues = _.groupBy(this.localStorage.agentData.filter(item => (item.aq != null && (agentGroupsValue.length==0 || agentGroupsValue.includes('all') || agentGroupsValue.includes(item.ag)) && (agentIdsValue.length==0 || agentIdsValue.includes('all') || agentIdsValue.includes(item.ai)))), "aq");
      let agentQueuesDS = Object.keys(agentQueues).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentQueues[key]} });
      let agentQueuesValues = agentQueuesDS.map(item => item.key);
      this.agentQueuesDataSource.splice(1, this.agentQueuesDataSource.length);
      this.agentQueuesDataSource.push(...agentQueuesDS);
      this.localAgentQueues.value = this.localAgentQueues.value.filter(val => agentQueuesValues.includes(val));
      this.localAgentQueues.isEmpty = (this.agentQueuesDataSource.length == 1 && this.agentQueuesDataSource[0].key == 'all');
      let agentIds = _.groupBy(this.localStorage.agentData.filter(item => (item.ai != null && (agentQueuesValue.length==0 || agentQueuesValue.includes('all') || agentQueuesValue.includes(item.aq)) && (agentGroupsValue.length==0 || agentGroupsValue.includes('all') || agentGroupsValue.includes(item.ag)))), "ai");
      let agentIdsDS = Object.keys(agentIds).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentIds[key]} });
      let agentIdsValues = agentIdsDS.map(item => item.key);
      this.agentIdsDataSource.splice(1, this.agentIdsDataSource.length);
      this.agentIdsDataSource.push(...agentIdsDS);
      this.localAgentIds.value = this.localAgentIds.value.filter(val => agentIdsValues.includes(val));
      this.localAgentIds.isEmpty = (this.agentIdsDataSource.length == 1 && this.agentIdsDataSource[0].key == 'all');
    },

    refreshAgentIds() {
      const agentQueuesValue = this.localAgentQueues.value || [];
      const agentGroupsValue = this.localAgentGroups.value || [];
      const agentIdsValue = this.localAgentIds.value || [];
      let agentQueues = _.groupBy(this.localStorage.agentData.filter(item => (item.aq != null && (agentGroupsValue.length==0 || agentGroupsValue.includes('all') || agentGroupsValue.includes(item.ag)) && (agentIdsValue.length==0 || agentIdsValue.includes('all') || agentIdsValue.includes(item.ai)))), "aq");
      let agentQueuesDS = Object.keys(agentQueues).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentQueues[key]} });
      let agentQueuesValues = agentQueuesDS.map(item => item.key);
      this.agentQueuesDataSource.splice(1, this.agentQueuesDataSource.length);
      this.agentQueuesDataSource.push(...agentQueuesDS);
      this.localAgentQueues.value = this.localAgentQueues.value.filter(val => agentQueuesValues.includes(val));
      this.localAgentQueues.isEmpty = (this.agentQueuesDataSource.length == 1 && this.agentQueuesDataSource[0].key == 'all');
      let agentGroups = _.groupBy(this.localStorage.agentData.filter(item => (item.ag != null && (agentQueuesValue.length==0 || agentQueuesValue.includes('all') || agentQueuesValue.includes(item.aq)) && (agentIdsValue.length==0 || agentIdsValue.includes('all') || agentIdsValue.includes(item.ai)))), "ag");
      let agentGroupsDS = Object.keys(agentGroups).map(key => { return {key:  key, label: key == "--" ? Vue.WyConstants.BLANK_LABEL: key, filters: agentGroups[key]} });
      let agentGroupsValues = agentGroupsDS.map(item => item.key);
      this.agentGroupsDataSource.splice(1, this.agentGroupsDataSource.length);
      this.agentGroupsDataSource.push(...agentGroupsDS);
      this.localAgentGroups.value = this.localAgentGroups.value.filter(val => agentGroupsValues.includes(val));
      this.localAgentGroups.isEmpty = (this.agentGroupsDataSource.length == 1 && this.agentGroupsDataSource[0].key == 'all');
    },

    onSearchFocus() {
      document.querySelector(".search").style.border = '1px solid #106FBC';
    },

    onSearchBlur() {
      if(document.activeElement == this.$refs.searchInput.$el.children[0]) {
        document.querySelector(".search").style.border = '1px #106FBC solid';
      }
      else {
        document.querySelector(".search").style.border = '1px transparent solid';
      }
    },

    onSearchForFocus() {
      const ref = this.$refs.advancedSearchFor
      if (ref) {
        ref.$el.style.border = '1px solid #106FBC';
      }
    },

    onSearchForBlur() {
      const ref = this.$refs.advancedSearchFor
      if (ref && document.activeElement != ref.$el.children[0]) {
        ref.$el.style.border = '1px solid #CAD2DA';
      }
    },

    onSearchHover() {
      const elInput = document.querySelector('.search .div-search-input input.el-input__inner');
      const elInputLeft = document.querySelector('.search .div-search-input .el-input');
      elInput.style.backgroundColor = '#f5f7fa';
      elInputLeft.style.backgroundColor = '#f5f7fa';
    },

    onSearchLeave() {
      const elInput = document.querySelector('.search .div-search-input input.el-input__inner');
      const elInputLeft = document.querySelector('.search .div-search-input .el-input');
      elInput.style.backgroundColor = '#fff';
      elInputLeft.style.backgroundColor = '#fff';
    },
        
    handleHideAdvancedFilterIconTooltip() {
      if (this.$refs.advancedSearchTooltip) {
        this.$refs.advancedSearchTooltip.hide();
      }
    },
    handleCloseAdvancedSearch() {
      this.showAdvancedSearchFilterSticky = false;
      this.showAdvancedSearchFilter = false;
    },

    handleCancelAdvancedSearch() {
      this.isAdvancedFilterReset = false;

      this.searchType = this.localFilterMap.searchType;
      this.searchKeyword = this.localFilterMap.searchKeyword;
      this.advancedFilterPayload = JSON.parse(JSON.stringify(this.localFilterMap.advancedFilterPayload)); // create a deep + defensive copy
      this.isShowGroups = this.localFilterMap.isShowGroups;

      const filterPreviouslyApplied = !this.isAdvancedSearchApplyDisabled
      if (filterPreviouslyApplied) {
        this.handleCreateTags();
        this.isSearchInputDisabled = true;
      }

      if(!this.searchKeyword || this.searchKeyword == '') {
        this.isInitialUpdateAdvancedFilter = false;
      }
      this.handleCloseAdvancedSearch();
    },

    handleSetElInputWidth(widthSizePx) {
      const elInput = document.querySelector('.search .div-search-input input.el-input__inner');
      elInput.style.paddingLeft = `${widthSizePx}px`;

    },
    handleApplyAdvancedSearch() {
      const isNotEmptySearch = this.advancedFilterPayload.groupA.conditions.every(condition => condition.value && condition.value != '');
      if (isNotEmptySearch) {
        this.isSearchInputDisabled = true;
        this.handleCreateTags();
      }

      if (this.searchType == '2') {
        // if searchType is "Conversation ID", we reset the payload.
        // Reason: If groups are created, we want to keep the groups even if searchType changes 
        // until the user for sure searches with conversation ID
        this.isSearchInputDisabled = true;
        this.initializeAdvancedFilterPayload();
      }

      if(!this.showAdvancedSearchFilter) {
        this.applySearch();
      }
      else {
        this.handleCloseAdvancedSearch();
      }
    },
    handleCreateTags() {
      // Check if filter wrapper exists
      let filterTagWrapper = this.$refs.searchInput.$el.querySelector('.advanced-search-filter-tag-wrapper');

      if (!filterTagWrapper) {
        filterTagWrapper  = document.createElement('div');
        filterTagWrapper.classList.add('advanced-search-filter-tag-wrapper');
        this.handleSetElInputWidth(8)
      }

      const advancedSearchTag = this.handleCreateAdvancedSearchTag(filterTagWrapper);

      if (advancedSearchTag) filterTagWrapper.appendChild(advancedSearchTag);
      const searchInputRefEl = this.$refs.searchInput.$el;
      searchInputRefEl.insertBefore(filterTagWrapper, searchInputRefEl.firstChild);
    },

    handleCreateAdvancedSearchTag(filterTagWrapper) {
      let advancedSearchTag = filterTagWrapper.querySelector('.advanced-search-filter-tag-advanced');
      if (advancedSearchTag) {
        filterTagWrapper.removeChild(advancedSearchTag); // remove the existing tag
      }
      advancedSearchTag = document.createElement('div');
      advancedSearchTag.classList.add('advanced-search-filter-tag-advanced');

      if (this.searchType == '1') advancedSearchTag.textContent = 'Keyword/Phrase search applied'
      else if (this.searchType == '2')  advancedSearchTag.textContent = 'Conversation ID search applied';

      this.showWarningMsgForKeywordSearch = false;
      this.createAdvancedSearchHoverText()

      return advancedSearchTag
    },

    createAdvancedSearchHoverText() {
      let hoverText = '';

      if (this.searchType == '1') {
        this.allowed_groups.forEach((key, index) => {
          const group = this.advancedFilterPayload[key];
  
          if (group) {
            if (index > 0) {
              hoverText += '<br/>';
              hoverText += `${this.operatorsEnumBetweenGroup.find(en => en.key == this.advancedFilterPayload.groupOperators[index === 1 ? 'groupBOperator' : 'groupCOperator']).label}<br/><br/>`;
            }
  
            group.conditions.forEach((condition, conditionIndex) => {
              const notAndNotOrCondition = this.operatorsEnum.find(en => en.key == group.operator).key == '3' || this.operatorsEnum.find(en => en.key == group.operator).key == '4'
              const operatorLabel = notAndNotOrCondition|| conditionIndex > 0 
                    ? `${this.operatorsEnum.find(en => en.key == group.operator).label} ` 
                    : '';
              const searchForLabel = condition.searchType ? this.searchForList.find(item => item.key === condition.searchType).label : '';
              const messageTypeLabels = condition.messageType.length == 3 ? 'all messages' : condition.messageType.map(item => this.searchInList.find(searchInItem => searchInItem.apiField == item).label).join(', ');
  
              hoverText += `${operatorLabel}${notAndNotOrCondition || conditionIndex > 0 ? searchForLabel.toLowerCase() : searchForLabel} in ${messageTypeLabels} for <b>${condition.value}</b><br/>`;
            });
          }
        });
      } else if (this.searchType == '2') {
        hoverText = this.searchKeyword;
      }

      this.isShowAdvancedFilterResultsTooltip = true;
      this.$refs.advancedFilterHoverSlot.innerHTML = hoverText
    },

    handleResetAllAdvancedSearch() {
      this.searchType = '1'
      this.searchKeyword = null;
      this.isAdvancedFilterReset = true;
      this.handleSetElInputWidth(37)
    
      this.isShowGroups = false;
      this.isSearchInputDisabled = false;

      this.advancedFilterPayload = {
        groupOperators: { groupBOperator: null, groupCOperator: null},
        groupA: {
          operator: "1",
          conditions: [{ messageType: [], searchType: null, value: null }]
        }
      };
      this.isInitialUpdateAdvancedFilter = false;
      this.isShowAdvancedFilterResultsTooltip = false;

      this.removeAllSearchTags();
    },

    removeAllSearchTags() {
      this.handleSetElInputWidth(37)
      const filterTagWrapper = this.$refs.searchInput.$el.querySelector('.advanced-search-filter-tag-wrapper');
      if (filterTagWrapper) {
        filterTagWrapper.remove();
      }
    },

    // triggered everytime this popover @hide is triggered
    handlePopoverHideEvent() {
      this.hideInnerDropdowns();

      if (this.showAdvancedSearchFilterSticky) {
        this.showAdvancedSearchFilter = true
      } else {

        if (this.isAdvancedFilterReset && !this.isAdvancedSearchApplyDisabled) {
          this.isAdvancedFilterReset = false;
          this.applySearch();
          return;
        }

        if (this.isAdvancedSearchApplyDisabled) {
          // case: not all conditions are filled, so we remove the unfilled conditions
          this.handleCancelAdvancedSearch();
          return;
        }

        const filterChanged = this.checkAdvancedFilterChanges()

        if (filterChanged) {
          this.showAdvancedSearchFilter = false
          this.handleApplyAdvancedSearch();
        } else {
          this.handleCancelAdvancedSearch()
        }
      }
    },
    handleEllipsis(selectedItem) {
      if (!selectedItem) return ""
      
      const character_limit = 34;
      if (selectedItem.length > character_limit) {
        return selectedItem.substring(0, character_limit) + '...';
      }
      return selectedItem;
    },

    // ---- //
    handleAddMainCondition() {
      this.isShowGroups = true;
      
      this.advancedFilterPayload = {
        ...this.advancedFilterPayload,
        groupOperators: {
          groupBOperator: null
        },
        groupA: {
          ...this.advancedFilterPayload.groupA,
          conditions: [...this.advancedFilterPayload.groupA.conditions]
        },
        groupB: {
          operator: "1",
          conditions: [{ messageType: [], searchType: null, value: null }],
        },
      }
    },
    
    handleAddMainGroup() {
      const firstTimeAdding = !this.isShowGroups
      if (firstTimeAdding) {
        this.isShowGroups = true;
        this.advancedFilterPayload = {
          ...this.advancedFilterPayload,
          groupA: {
            ...this.advancedFilterPayload.groupA,
            conditions: [...this.advancedFilterPayload.groupA.conditions]
          }
        };
        return;
      }

      const newGroup = this.advancedFilterPayload.groupB ? 'groupC' : 'groupB';

      this.advancedFilterPayload = {
        ...this.advancedFilterPayload,
        groupOperators: {
          groupBOperator: this.advancedFilterPayload.groupB ? this.advancedFilterPayload.groupOperators.groupBOperator : null, 
          groupCOperator: null
        },
        [newGroup]: {
          operator: "1",
          conditions: [{ messageType: [], searchType: null, value: null }]
        }
      };
    },

    handleDeleteGroup(group) {
      if (group === 'groupA') {
        if(this.advancedFilterPayload.groupB && this.advancedFilterPayload.groupC) {
          this.advancedFilterPayload = {
            ...this.advancedFilterPayload,
            groupOperators: { 
              groupBOperator: this.advancedFilterPayload.groupOperators.groupCOperator, 
              groupCOperator: null
            },
            groupA: this.advancedFilterPayload.groupB,
            groupB: this.advancedFilterPayload.groupC,
            groupC: null
          };
          return;
        } else if (this.advancedFilterPayload.groupB) {
          this.advancedFilterPayload = {
            ...this.advancedFilterPayload,
            groupOperators: { 
              groupBOperator: null, 
              groupCOperator: null
            },
            groupA: this.advancedFilterPayload.groupB,
            groupB: null
          };
          return;
        } else if (this.advancedFilterPayload.groupC) {
          this.advancedFilterPayload = {
            ...this.advancedFilterPayload,
            groupOperators: { 
              groupBOperator: null, 
              groupCOperator: null
            },
            groupA: this.advancedFilterPayload.groupC,
            groupC: null
          };
          return;
        } else {
          this.handleResetAllAdvancedSearch();
          return;
        }
      } else if (group === 'groupB') {
        if (this.advancedFilterPayload.groupC) {
          this.advancedFilterPayload = {
            ...this.advancedFilterPayload,
            groupOperators: {
              // groupCOperator (B-C) takes priority over groupBOperator (A-B)
              groupBOperator: this.advancedFilterPayload.groupOperators.groupCOperator,
              groupCOperator: null
            },
            groupB: this.advancedFilterPayload.groupC,
            groupC: null
          };
          return;
        } else {
          this.advancedFilterPayload = {
            ...this.advancedFilterPayload,
            groupOperators: {
              groupBOperator: null,
              groupCOperator: null
            },
            groupB: null
          };
          return;
        }
      } else if (group === 'groupC') {
        this.advancedFilterPayload = {
          ...this.advancedFilterPayload,
          groupOperators: {
            groupBOperator: this.advancedFilterPayload.groupOperators.groupBOperator,
            groupCOperator: null
          },
          groupC: null
        };
        return;
      }
    },


    handleAddCondition(group) {
      const filterGroup = this.advancedFilterPayload[group];

      const newCondition ={ 
        searchType: null,
        messageType: [], 
        value: null
      }

      this.advancedFilterPayload = {
        ...this.advancedFilterPayload,
        [group]: {
          ...filterGroup,
          conditions: [...filterGroup.conditions, newCondition]
        }
      }
    },

    handleDeleteCondition(group, condition) {
      const filterGroup = this.advancedFilterPayload[group];

      if (!filterGroup) {
        return; // Group doesn't exist, nothing to delete
      }

      const updatedConditions = filterGroup.conditions.filter(cond => cond !== condition);

      this.advancedFilterPayload = {
        ...this.advancedFilterPayload,
        [group]: {
          ...filterGroup,
          conditions: updatedConditions
        }
      };
    },

    handleMessageTypeText(condition) {
      const messageType = condition.messageType;

      if (messageType.length === 0) return 'In: Message type';

      let firstSelectedMessageType = this.searchInList.find(item => item.apiField === messageType[0]).label;

      const max_render_length = 12;
      if (firstSelectedMessageType.length >= max_render_length) {
        firstSelectedMessageType = firstSelectedMessageType.substring(0, max_render_length) + '...';
      }

      const moreThanOneSelected = messageType.length > 1;
      const remainingSelected = moreThanOneSelected ? messageType.length - 1 : 0;

      return `${firstSelectedMessageType}${moreThanOneSelected ? ` + ${remainingSelected}` : ''}`;

    },

    handleDefaultMessageTypeDropdownVisibleChange(val) {
      if (val) {
      const iconPlacement = document.querySelector('.placement');
      if (iconPlacement) {
        iconPlacement.classList.add('icon-placement-rotate');
        iconPlacement.classList.remove('icon-placement-rotate-back');
      }

      } else {
        const iconPlacement = document.querySelector('.placement');
        if (iconPlacement) {
          iconPlacement.classList.remove('icon-placement-rotate');
          iconPlacement.classList.add('icon-placement-rotate-back');
        }
      }
    },

    handleGroupMessageTypeDropdownVisibleChange(val, index) {
      const iconPlacement = document.querySelector(`.group-placement-${index}`)
      const classList = iconPlacement && iconPlacement.classList ? iconPlacement.classList : [];

      if (!classList || !classList.length || !iconPlacement) return;

      if (!val && iconPlacement && Array.from(classList).includes('icon-placement-rotate')) {
        classList.remove('icon-placement-rotate');
        classList.add('icon-placement-rotate-back');
      } else {
        classList.add('icon-placement-rotate');
        classList.remove('icon-placement-rotate-back');
      }
    },

    handleAdvancedFilterHeightSizing() {
      this.$nextTick(() => {
        let height = 'min-content';

        if ((this.searchType == '1' && this.isShowGroups)) {
          if (this.controller.$el.classList.contains('wy-contact-reason-transcripts-section')) {
            height = '280px';
          } else {
            height = '400px';}
        }

        this.$refs.advancedFilterBody.style.height = height;
      });
      // this.$refs.advancedFilterBody.scrollTop = this.$refs.advancedFilterBody.scrollHeight;
    },

    handleSearchInputClick() {
      if (!this.isAdvancedSearchApplyDisabled && this.isSearchInputDisabled) {
        this.showAdvancedSearchFilter = true;
      }
    },

    getAdvancedFilterPayload() {
      let groupOperators = {};

      if (this.searchType == '2') {
        return groupOperators;
      }
      if (this.advancedFilterPayload.groupOperators.groupBOperator) {
        groupOperators.groupBOperator = this.advancedFilterPayload.groupOperators.groupBOperator;
      }
      if (this.advancedFilterPayload.groupOperators.groupCOperator) {
        groupOperators.groupCOperator = this.advancedFilterPayload.groupOperators.groupCOperator;
      }

      let advancedFilter = {};
      advancedFilter.groupOperators = groupOperators;

      if (this.advancedFilterPayload.groupA) {
        advancedFilter.groupA = this.advancedFilterPayload.groupA;
      }
      if (this.advancedFilterPayload.groupB) {
        advancedFilter.groupB = this.advancedFilterPayload.groupB;
      }
      if (this.advancedFilterPayload.groupC) {
        advancedFilter.groupC = this.advancedFilterPayload.groupC;
      }

      return advancedFilter;
    },

    handleEnterSearch() {
      if (this.searchKeyword == '' || this.searchKeyword == null) return; 

      this.initializeAdvancedFilterPayload()
      this.handleApplyAdvancedSearch();
    },

    initializeAdvancedFilterPayload() {
      this.advancedFilterPayload = {
        groupOperators: {},
        groupA: {
          operator: "1",
          conditions: [{ messageType: ['Customer', 'Bot', 'Agent'], searchType: "1", value: this.searchKeyword }]
        },
      }
    },

    hideInnerDropdowns() {
      const searchByDropdown = this.$refs.searchByDropdown
      if (searchByDropdown && searchByDropdown.blur) {
        searchByDropdown.blur()
      }

      // hide all inner dropdowns in advanced search when scroll
      const innerGroupOperatorDropdowns = Object.keys(this.$refs).filter(ref => ref.includes('innerGroupOperatorDropdown-')) 
      if (innerGroupOperatorDropdowns && innerGroupOperatorDropdowns.length) {
        innerGroupOperatorDropdowns.forEach(ref => {
          const refInstance = this.$refs[ref] && this.$refs[ref].length ? this.$refs[ref][0] : this.$refs[ref]
          if (refInstance && refInstance.blur) {
            refInstance.blur()
          }
        })
      }

      const searchTypeDropdowns = Object.keys(this.$refs).filter(ref => ref.includes('searchTypeDropdown-'))
      if (searchTypeDropdowns && searchTypeDropdowns.length) {
        searchTypeDropdowns.forEach(ref => {
          const refInstance = this.$refs[ref] && this.$refs[ref].length ? this.$refs[ref][0] : this.$refs[ref]
          if (refInstance && refInstance.blur) {
            refInstance.blur()
          }
        })
      }

      const messageTypeDropdowns = Object.keys(this.$refs).filter(ref => ref.includes('messageTypeDropdown-'))
      if (messageTypeDropdowns && messageTypeDropdowns.length) {
        messageTypeDropdowns.forEach(ref => {
          const refInstance = this.$refs[ref] && this.$refs[ref].length ? this.$refs[ref][0] : this.$refs[ref]
          if (refInstance && refInstance.hide) {
            refInstance.hide()
          }
        })
      }

      const outerGroupOperatorDropdowns = Object.keys(this.$refs).filter(ref => ref.includes('outerGroupOperatorDropdown-'))
      if (outerGroupOperatorDropdowns && outerGroupOperatorDropdowns.length) {
        outerGroupOperatorDropdowns.forEach(ref => {
          const refInstance = this.$refs[ref] && this.$refs[ref].length ? this.$refs[ref][0] : this.$refs[ref]
          if (refInstance && refInstance.blur) {
            refInstance.blur()
          }
        })
      }
    },
    mouseover(e, tooltips, type, scaleX) {
      e.stopPropagation();
      // let ignoreClassName = e.target.className != 'assigned-intent' && e.target.className != 'el-select-dropdown__item' && e.target.className != 'el-select-dropdown__item hover' 
      // && e.target.className != 'ignore-wrap-div' && e.target.className != 'existing-intent-popover-item' && e.target.className != 'el-select__caret el-input__icon el-icon-arrow-up' 
      // && e.target.className != 'el-select el-select--mini'
      if(tooltips && tooltips.trim() != '') {
        this.mouseoverHandler = e;
        let tooltipsEl = document.querySelector(".site-tooltips");
        if(tooltipsEl) {
          tooltipsEl.innerHTML = tooltips
          tooltipsEl.style.display = 'block';
          tooltipsEl.style.left = `${e.target.getBoundingClientRect().x + 10}px`;
          if(!scaleX) {
            scaleX = 10
          }
          if(type == "right") {
            tooltipsEl.style.right = "10px";
            tooltipsEl.style.left = "unset";
          }
          if(type == "left") {
            tooltipsEl.style.left = "10px";
            tooltipsEl.style.right = "unset";
          }
          if(!type || type == "normal") {
            tooltipsEl.style.left = `${e.target.getBoundingClientRect().x - tooltipsEl.getBoundingClientRect().width/2 + scaleX}px`;
          }
          tooltipsEl.style.top = `${e.target.getBoundingClientRect().top + e.target.getBoundingClientRect().height + 5}px`;
        }
      }
      else {
        e.preventDefault();
      }
    },
    mouseout(e) {
      if(e) {
        e.stopPropagation();
      }
      this.mouseoverHandler = null;
      let tooltipsEl = document.querySelector(".site-tooltips");
      if(tooltipsEl) {
        tooltipsEl.style.display = 'none';
      }
    },
    isAdvancedFilterApplied() {
      return (
        this.localFilterMap.searchKeyword || 
        (
          this.localFilterMap.advancedFilterPayload.groupA.conditions[0].value != null &&
          this.localFilterMap.advancedFilterPayload.groupA.conditions[0].value != ''
        ) ||
        this.localFilterMap.advancedFilterPayload.groupB
      )
    }
  },

  mounted(){
    this.transcriptSearchResultsComponent = this.controller.$refs.transcriptSearchResults;
    if(this.$refs.contentEl) {
      this.$refs.contentEl.addEventListener("scroll", () => {
        if(this.$refs.localAgentIdsDropdown) this.$refs.localAgentIdsDropdown.closeDropdown();
        if(this.$refs.localAgentQueuesDropdown) this.$refs.localAgentQueuesDropdown.closeDropdown();
        if(this.$refs.localAgentGroupsDropdown) this.$refs.localAgentGroupsDropdown.closeDropdown();
        if(this.$refs.localAgentIdsDropdownAllFilter) this.$refs.localAgentIdsDropdownAllFilter.closeDropdown();
        if(this.$refs.localAgentQueuesDropdownAllFilter) this.$refs.localAgentQueuesDropdownAllFilter.closeDropdown();
        if(this.$refs.localAgentGroupsDropdownAllFilter) this.$refs.localAgentGroupsDropdownAllFilter.closeDropdown();
        if(this.$refs.contactReasonFilterAllFilter)  this.handleChangeVisible(false, this.$refs.contactReasonFilterAllFilter);
        if(this.$refs.responseNameFilterAllFilter) this.handleChangeVisible(false, this.$refs.responseNameFilterAllFilter);
        if(this.$refs.relatedTopicFilterAllFilter) this.handleChangeVisible(false, this.$refs.relatedTopicFilterAllFilter);
        if(this.$refs.intentNameFilterAllFilter) this.handleChangeVisible(false, this.$refs.intentNameFilterAllFilter);
      });
    }
    if(this.$refs.agentFilterContent) {
      this.$refs.agentFilterContent.addEventListener("scroll", () => {
        if(this.$refs.localAgentIdsDropdown) this.$refs.localAgentIdsDropdown.closeDropdown();
        if(this.$refs.localAgentQueuesDropdown) this.$refs.localAgentQueuesDropdown.closeDropdown();
        if(this.$refs.localAgentGroupsDropdown) this.$refs.localAgentGroupsDropdown.closeDropdown();
      });
    }

    if((!this.contactReason || this.contactReason == '') && this.$refs.allFiltersCard) {
      this.$refs.allFiltersCard.parentElement.classList.remove('contact-reason-transcript')
    }

    if (this.companyHasLiveAgent) {
      this.containmentList = this.containmentList.filter(
        (list) => list.label !== CONTAINMENT_OPTIONS.LIVE_AGENT_REQUESTED
      );
    } else {
      this.containmentList = this.containmentList.filter(
        (list) =>
          list.label !== CONTAINMENT_OPTIONS.NOT_CONNECTED &&
          list.label !== CONTAINMENT_OPTIONS.LIVE_AGENT_CONNECTED
      );
    }

    const searchInputRef = this.$refs.searchInput
    if (searchInputRef) {
      searchInputRef.$el.addEventListener('click', this.handleSearchInputClick)
    }

    // hide all inner dropdowns in advanced search when scroll
    document.querySelector('.wy-analytics-transcript-search-dropdown-menu.search-input .body').addEventListener('scroll', () => {
      this.hideInnerDropdowns();
    });

    // hide tooltip on tab switch
    document.addEventListener('visibilitychange', () => {
      const isAdvancedSearchIconFocused = document.activeElement.classList.contains('advanced-search-icon');
      if (isAdvancedSearchIconFocused) {
        document.activeElement.blur();
      }
    });

    /**
     * This logic allows el-popover to conditionally open and close on specific element.
     * Since we need the popover to stay open on $refs.searchInput click, 
     * and close on click everywhere else, we need to listen to this event.
     */
    this.$root.$on('fire-app-hide-popover-events', (e) => {
      const targetClassList = e && e.target && e.target.classList
      const isSearchInput = ['search-inp', 'el-input', 'el-input__inner', 'advanced-search-filter-tag-advanced'].some((className) => targetClassList.contains(className));
      if (isSearchInput) {
        this.showAdvancedSearchFilterSticky = true;
      } else {
        this.showAdvancedSearchFilterSticky = false;
      }
    });
  },
  created() {
     // listen events from other components
    this.$root.registerPageEvent(this.$route.name, (event) => {
      if(this[event.name]) this[event.name]();
    })

    try {

      this.localFilterMap.advancedFilterPayload = JSON.parse(JSON.stringify(this.advancedFilterPayload));
      this.localFilterMap.searchKeyword = this.searchKeyword;
      this.localFilterMap.searchType = this.searchType;
      this.localFilterMap.isShowGroups = this.isShowGroups;

      if(!this.localAgentQueues || (this.dataModel.filters.agentQueues.value.length !== 0)) {
        this.localAgentQueues = JSON.parse(JSON.stringify(this.dataModel.filters.agentQueues));
        this.localAgentQueues.label = this.localAgentQueues.label;
        this.agentQueuesDataSource = JSON.parse(JSON.stringify(this.localAgentQueues.dataSource));
        this.dataModel.filters.agentQueues.isEmpty = (this.agentQueuesDataSource.length == 1 && this.agentQueuesDataSource[0].key == 'all');
        this.localFilterMap.localAgentQueues = JSON.parse(JSON.stringify(this.localAgentQueues));
      }
      if(!this.localAgentGroups || (this.dataModel.filters.agentGroups.value.length !== 0)) {
        this.localAgentGroups = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups));
        this.localAgentGroups.label = this.localAgentGroups.label;
        this.agentGroupsDataSource = JSON.parse(JSON.stringify(this.localAgentGroups.dataSource));
        this.dataModel.filters.agentGroups.isEmpty = (this.agentGroupsDataSource.length == 1 && this.agentGroupsDataSource[0].key == 'all');
        this.localFilterMap.localAgentGroups = JSON.parse(JSON.stringify(this.localAgentGroups));
      }
      if(!this.localAgentIds || (this.dataModel.filters.agentIds.value.length !== 0)) {
        this.localAgentIds = JSON.parse(JSON.stringify(this.dataModel.filters.agentIds));
        this.localAgentIds.label = this.localAgentIds.label;
        this.agentIdsDataSource = JSON.parse(JSON.stringify(this.localAgentIds.dataSource));
        this.dataModel.filters.agentIds.isEmpty = (this.agentIdsDataSource.length == 1 && this.agentIdsDataSource[0].key == 'all');
        this.localFilterMap.localAgentIds = JSON.parse(JSON.stringify(this.localAgentIds));
      }
    }
    catch(e) {
      console.log(e);
    }
  },

  beforeDestroy(){
    if(this.$refs.allFilters && this.$refs.allFilters.$el.firstChild) {
      this.$refs.allFilters.$el.firstChild.removeEventListener("scroll", () => {
        if(this.$refs.localAgentIdsDropdownAllFilter) this.$refs.localAgentIdsDropdownAllFilter.closeDropdown();
        if(this.$refs.localAgentQueuesDropdownAllFilter) this.$refs.localAgentQueuesDropdownAllFilter.closeDropdown();
        if(this.$refs.localAgentGroupsDropdownAllFilter) this.$refs.localAgentGroupsDropdownAllFilter.closeDropdown();
        if(this.$refs.contactReasonFilterAllFilter)  this.handleChangeVisible(false, this.$refs.contactReasonFilterAllFilter)
        if(this.$refs.responseNameFilterAllFilter) this.handleChangeVisible(false, this.$refs.responseNameFilterAllFilter)
        if(this.$refs.relatedTopicFilterAllFilter) this.handleChangeVisible(false, this.$refs.relatedTopicFilterAllFilter)
        if(this.$refs.intentNameFilterAllFilter) this.handleChangeVisible(false, this.$refs.intentNameFilterAllFilter)
      });
    }
  }
});
</script>

<style lang="scss">
// required for the advanced search filter (disabled click)
input[disabled] {pointer-events:none}

.message-type-dropdown {
  display: flex; 
  flex-direction: column;
  max-height: 200px; 
  width: 180px; 
  overflow-y: auto; 
  gap: 20px; 
  padding: 5px 10px;


  span.el-checkbox__label {
    color: black;
  }
  .el-checkbox {
    margin: 0px !important;
    margin-right: 4px !important;
    .el-checkbox__inner {
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
      border: 2px solid var(--primary-checkbox-button-border-color) !important;
      width: 16px;
      height: 16px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: var(--primary-checkbox-button-check-color) !important;
      border-color: var(--primary-checkbox-button-checked-border-color) !important;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner::after {
      left: 5px;
      top: 2px;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner {
      background-color: var(--primary-checkbox-button-disabled-background-color) !important;
      border-color: var(--primary-checkbox-button-disabled-border-color) !important;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: black !important;
    }
  }
}
.transcript-search-advanced-search-dropdown {
  .el-select__tags {
    flex-wrap: nowrap !important;
  }
  .el-select-dropdown__item {
    font-size: 14px;
  }
  .el-select-dropdown__wrap.el-scrollbar__wrap {
    display: block !important;
  }

  .el-tag.el-tag--info {
    overflow: hidden
  }


  .el-select-dropdown__list {
    padding: 0px !important;
    // height: 80px !important;
    .el-select-dropdown__item {
      height: 40px;
      color: var(--site-font-tertiary-color) !important;
      font-weight: 400;
      font-size: 14.22px;
      border-radius: 4px;
      display: flex;
      align-items: center;
    }
    .el-select-dropdown__item.selected {
      color: var(--site-font-tertiary-color) !important; // use #1A55AD?
      font-weight: 500 !important;
      background: #E8F1FF;
    }
  }

}
.wy-analytics-transcript-search-filters {
  .advanced-search-filter-tag-wrapper {
    margin-left: 36px;
    display: flex;
    align-items: center;
    gap: 6px;

    .advanced-search-filter-tag-advanced {
      padding: 0px 14px;
      background-color: #E8F1FF;
      color: rgb(16, 111, 188);
      font-size: 14px;
      line-height: 40px;
      font-weight: 500;
      border-radius: 5px;
      height: 22px;
      display: flex;
      align-items: center;
      min-width: max-content;
      width: 210px;
      cursor: pointer;
    }
    
    // .advanced-search-filter-tag-for {
    //   padding: 0px 14px;
    //   background-color: #E8F1FF;
    //   color: rgb(16, 111, 188);
    //   font-size: 14px;
    //   line-height: 40px;
    //   font-weight: 500;
    //   border-radius: 5px;
    //   height: 22px;
    //   display: flex;
    //   align-items: center;
    //   min-width: max-content;
    // }

    // .advanced-search-filter-tag-in {
    //   padding: 0px 14px;
    //   background-color: #E8F1FF;
    //   color: rgb(16, 111, 188);
    //   font-size: 14px;
    //   line-height: 40px;
    //   font-weight: 500;
    //   border-radius: 5px;
    //   height: 22px;
    //   display: flex;
    //   align-items: center;
    //   min-width: max-content;
    // }
    
  }
  .transcript-detail-export-btn {
    // background: transparent;
    box-sizing: border-box;
    border-radius: 5px;
    // border: 1px solid #CAD2DA !important;
    padding: 6px 15px 9px 11px !important;
    width: 90px;
    font-size: 16px !important;
    height: 39px;
    font-weight: 500 !important;
    // color: var(--site-font-tertiary-color) !important;
    background: var(--site-button-secondary-btn-background-primary-color);
    color: var(--site-button-secondary-btn-text-primary-color);
    border: 1px solid var(--site-button-secondary-btn-hover-border-primary-color);
    float: right;
    &:hover{
      background-color: #F4F6F8;
    }
  }
  .transcript-detail-export-btn:hover {
    border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
    background-color: var(--site-button-secondary-btn-hover-background-primary-color) !important;
    border-radius: 5px;
    color: var(--site-button-secondary-btn-text-primary-color) !important;
  }
  .transcript-detail-export-btn:active {
    background-color: var(--site-button-secondary-btn-pressed-background-primary-color) !important;
  }
  .transcript-detail-export-btn:focus {
    border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
    border-radius: 5px;
    color: var(--site-button-secondary-btn-text-primary-color) !important;
  }
  .search-button {
    background-color: white;
    border-radius: 8px;
    width: 38px;
    height: 23px;
    text-align: center;
    margin-top: 2px;
    margin-left: 3px;
    padding: 3px 0px 0px 0px;
    font-size: 22px;
    position: absolute;
    z-index: 100;
    background: transparent;
    color: #5C5F62;
    cursor: pointer;
  }
  .search-section {
    display: flex;
    .search {
      display: flex;
      align-items: center;
      // margin-top: 10px;
      /* padding-top: 15px; */
      height: 30px;
      // width: 463px;
      width: 550px;
      border-radius: 32px;

      border-radius: 32px;
      margin-bottom: 5px;
      border: 1px transparent solid;



      .search-inp {
        // width: 315px !important;
        width: 100%;
        height: 30px;
        padding-bottom: 0px;
        input.el-input__inner {
          height: 30px;
          font-size: 14px;
          width: 100%;
          padding-right: 40px;

          &:hover{
            background-color: #F4F6F8;
          }
        }
      }
      .el-input:focus-within {
        outline-width: 0 !important;
      }
      .el-input__inner::placeholder {
        color: #828E9A !important;
        font-size: 14.22px;
      }
      .el-input__inner:hover{
        background: #F4F6F8;

      }

      .div-search-input {
        width: 548px;
        height: 30px;
        display: inline-block;
        position: relative;
        margin-right: 1px;
        input.el-input__inner {
          border-width: 0px 0px 0px 0px !important;
          height: 30px;
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
          font-size: 15px;
          padding-left: 37px;
          padding-right: 60px;
          border-right: 0px;
          padding-bottom: 2px;
        }
        .el-input__icon {
          line-height: 25px;
          font-weight: bolder;
          background-image: url('../../assets/icons/icon_search.svg');
          background-repeat: no-repeat;
          background-size: 16px 16px;
          background-position-y: 8px;
          background-position-x: 5px;
        }
        .el-input__icon:before {
          content: '';
        }
        .el-input{
          border: 35px;
          // height: 30px;
          font-size: 14px;
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
          border-bottom-left-radius: 20px;
          border-top-left-radius: 20px;
          width: inherit;
          height: 28px;
          padding-left: 0px;
          padding-bottom: 0px;
        }
        .fa-times-circle {
          position: relative;
          left: 493px;
          bottom: 28px;
          color: #606060;
          font-size: 16px;
          cursor: pointer;
          height: 20px;
          width: 24px;
          padding: 5px 3px 0px 6px;
        }
      }
      .advanced-search-icon {
        position: relative;
        margin-left: -26px;
        cursor: pointer;
        background-image: url('../../assets/icons/icon_transcripts_advanced_search.svg');
        background-size: 68%;
        width: 24px;
        height: 18px;
        border-radius: 4px;
        background-repeat: no-repeat;
      }
    }
    .export-div {
      margin-left: auto;
      .export-text {
        padding-right: 5px;
      }
      .export-icon {
        background: var(--icon_action_export);
        height: 17px;
        width: 13px;
        position: relative;
        top: 2px;
        height: 17px;
        width: 13px;
        display: inline-block;
        background-repeat: no-repeat;
      }
      .el-button {
        margin-right: 0px !important;
        height: 35px;
        margin-top: 11px;
        padding-top: 7px;
        font-size: 15px;
        background: var(--site-button-secondary-btn-background-primary-color);
        color: var(--site-button-secondary-btn-text-primary-color);
        border: 1px solid var(--site-button-secondary-btn-hover-border-primary-color);
      }
    }
  }
  .last-verticalLine{
    border-right: 1px solid rgb(189, 185, 185);
    border-right: 1px solid #CAD2DA;

    font-size: 24px;
    display: inline;
    margin-right: 10px;
    position: relative;
    top: 3px;
  }
  .verticalLine {
    border-right: 1px solid rgb(189, 185, 185);
    border-right: 1px solid #CAD2DA;

    font-size: 24px;
    display: inline;
    margin-right: 10px;
    position: relative;
    top: 3px;
  }
  .save-transcript-btn {
    // margin-top: 6px;
    margin-right: 10px;
    float: left;
    background-image: url('../../assets/icons/icon_golden_star.svg');
    background-size: 20%;
    background-repeat: no-repeat;
    background-position-x: 10px;
    background-position-y: 6px;
    span.text {
      padding-left: 20px;
      font-size: 15px;
      font-weight: 400 !important;
      color: #202223;
    }
  }
  .save-transcript-btn:hover {
    // background-color: #FFF;
    background-color: #F4F6F8;
    //color: #214586;
    color: var(--site-font-tertiary-color);
  }
  .save-transcript-btn:focus {
    background-color: #FFF;
    color: #214586;
  }

  .save-transcript-btn.saved-transcript-filter {
    //background-color: #214586;
    background-color: #E8F1FF;
    //color: #FFF;
    color: var(--site-font-tertiary-color);
    border: 1px solid #106FBC;
  }
  .save-transcript-btn.saved-transcript-filter:hover {
    // background-color: #214586;
    // color: #FFF;
    background-color: #F4F6F8;
    color: var(--site-font-tertiary-color);
  }
  .save-transcript-btn.saved-transcript-filter:focus {
    background-color: var(--site-button-save-button-background-primary-color);
    color: var(--site-font-tertiary-color);
  }

  .fa-times-circle {
    position: relative;
    left: 523px;
    bottom: 28px;
    color: #000000;
    font-size: 18px;
    cursor: pointer;
  }

  .el-button .el-icon--right {
    font-weight: 600;
    pointer-events: none;
  }
  .el-button .el-icon--right.hide {
    color: #E8F1FF;
  }

  // .el-input:focus-within {
  //   border: 1px solid #106FBC !important;
  // }
  .el-input {
    border: 1px solid #C9CCCF !important;
    font-size: 20px;
    overflow: hidden;
    border-top-right-radius: 35px;
    border-bottom-right-radius: 35px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    width: 146px;
    height: 28px;
    padding-left: 0;
    display: flex;
    padding-bottom: 0;
    align-items: center;
    .el-input__icon {
      line-height: 29px !important;
      color: #606060;
    }
    .el-input__inner {
      padding-right: 30px;
      border-width: 0 0 0 0!important;
      border-bottom-right-radius: 20px;
      border-top-right-radius: 20px;
      height: 30px;
      font-size: 14px;
      padding: 10px;
      color: var(--site-font-tertiary-color);
      font-weight: 400;
      padding-bottom: 10px !important;
    }
  }

  .el-button {
    margin-top: 12px;
    margin-right: 5px;
    border: 1px solid #CAD2DA;
    font-size: 15px;
    font-weight: 400 !important;
    color: #202223;
    height: 30px;
    padding: 5px 12px 5px 12px;
  }
  .el-button.with-border {
    border: 1px solid #106FBC;
  }
  .el-button:focus,.el-button:active {
    // background-color: #214586;
    // color: #FFF;
    // background-color: #E8F1FF;
    background-color: #FFF;
    color: #202223;
    // border: 1px solid #106FBC;
  }
  .el-button:focus {
    background-color: #FFF;
    // color: #202223;
    // border: 1px solid #106FBC;
  }
  .el-button:hover, .el-button.is-disabled:hover{
    // background-color: #F4F6F8;
    background-color: #F4F6F8;
    color: #202223;
  }
  .el-dropdown .el-button:focus{
    // background-color: #FFF;
    // color: #214586;
    // background-color: #E8F1FF;
    background-color: #FFF;
    color: var(--site-font-tertiary-color);
  }
  .el-dropdown .other.el-button--default.selected:hover {
    // background-color: #F4F6F8;
    background-color: #E8F1FF;
    color: var(--site-font-tertiary-color);
  }
  .dropdown .other.el-button--default.selected {
    background-color: #E8F1FF;
    border: 1px solid #106FBC;
    color: var(--site-font-tertiary-color);
  }
  button.el-button.other.el-button--default.selected {
    background-color: #E8F1FF;
    border: 1px solid #106FBC;
    color: var(--site-font-tertiary-color);
    .reset-btn-icon {
      display: block !important;
      width: 25px;
      height: 25px;
      left: 60px;
      top: 7px;
      float: left;
      background-image: url('../../assets/icons/icon_blue_close.svg');
      background-size: 57%;
      background-repeat: no-repeat;
      background-position-x: 0px;
      background-position-y: 0px;
      position: absolute;
    }
    .contact-reason.reset-btn-icon {
      left: 157px;
      top: 21px;
    }
    .response-names.reset-btn-icon {
      left: 138px;
      top: 21px;
    }
    .related-topics.reset-btn-icon {
      left: 118px;
      top: 21px;
    }
    .intent-names.reset-btn-icon {
      left: 110px;
      top: 21px;
    }
    .agent.reset-btn-icon {
      left: 108px;
      top: 21px;
    }
    .bes-bas.reset-btn-icon {
      left: 106px;
      top: 21px;
    }
    .containment.reset-btn-icon {
      left: 105px;
      top: 20px;
    }
    .handling-time.reset-btn-icon {
      left: 152px;
      top: 21px;
    }
    .response-time.reset-btn-icon {
      left: 125px;
      top: 21px;
    }
    .sentiment.reset-btn-icon {
      left: 90px;
      top: 21px;
    }
    .feedback.reset-btn-icon {
      left: 90px;
      top: 21px;
    }
    .hand-offs.reset-btn-icon {
      left: 83px;
      top: 21px;
    }
    .all-filters.reset-btn-icon {
      left: 104px;
      top: 21px;
    }
  }
  // .reset-btn-icon.selected {
  //   display: block !important;
  //   width: 25px;
  //   height: 25px;
  //   left: 135px;
  //   top: 6px;
  //   float: left;
  //   background-image: url('../../assets/icons/icon_blue_close.svg');
  //   background-size: 57%;
  //   background-repeat: no-repeat;
  //   background-position-x: 0px;
  //   background-position-y: 0px;
  //   position: absolute;
  // }

  .fa-chevron-right {
    font-size: 12px;
    color: #214586;
  }
}
.allFilters-popover .horizontal-line .handoffs{
  width: 446px !important;
  border-radius: 5px;
  div.min-hint {
    right: 52px;
  }
  div.max-hint {
    left: 14px;
  }
  .time{
    display: flex;
    justify-content: space-evenly;
    width: 81%;
    margin-left: 34px;

    .el-input-number {
      margin-right: 2px;
      min-width: 16.5em !important;
      right: 11px;
      height: 33px !important;
      .el-input__inner{
        height: 33px !important;
        text-align: left;
      }

      .el-input-number.is-controls-right .el-input-number__increase {
        background-image: url('../../assets/icons/icon_handoff_arrow_up.svg')
      }
      .el-icon-arrow-:before {
        display: none;
      }
    }
    .el-input-number.is-controls-right .el-input-number__increase, .el-input-number.is-controls-right .el-input-number__decrease {
      border-bottom: 1px solid #DCDFE6;
      background: #E4E5E7;
      width: 22px;
      border-radius: 2px;
      height: 12px;
      margin-top: 2px;
      margin-bottom: 2px;
      margin-right: 2px;
    }
    input.display-time {
      border: 1px solid #d2d2d2;
      width: 14em !important;
      height: 2.6em;
      position: relative;
      border-radius: 4px;
      right: 9px;
      left: -2px;
      color: var(--site-font-tertiary-color);
      margin-right: 0px;
      padding: 0.3em 0.5em;
      font-size: 1em;
    }
    input.display-time:focus {
      outline: none;
      border: 2px solid #106FBC;
      border-radius: 4px;
    }
  }
  .horizontal-line{
    margin-bottom: -20px;
    margin-top: 25px;
  }
  .card-bottom-part{
    max-width: 421px !important;
    padding: 10px 0px 10px 25px !important;
  }
}
.advanced-wrapper {
  padding: 0px !important;
  margin: 0px !important;
  border-radius: 10px !important;
  left: 318px !important
}

.selected-blue {
  background-color: #E8F1FF;
  border: 1px solid #106FBC !important;
  .el-select, .el-input, .el-input .el-input__inner {
    background-color: #E8F1FF !important;
  }
  .search-wrapper {
    background-color: #E8F1FF !important;
  }
  .el-input__inner {
    background-color: #E8F1FF !important;
  }
}

.wy-analytics-transcript-search-dropdown-menu.search-input {
  width: 900px !important;
  height: min-content;
  border-radius: none !important;
  padding: 10px 0px !important;
  color: #202223 !important;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-size: 14.22px;
  line-height: 17px;
  margin-top: 0px !important;
  left: 320px !important;
  box-shadow: 0px 30px 50px 0px rgba(0, 0, 0, 0.20);
  background: white;
  overflow: hidden;
  .heading {
    padding: 0px 20px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 400;
  }
  .body {
    padding: 10px 20px;
    // height: calc(100% - 115px);
    overflow-y: auto;
    margin-right: 4px;
    .remove-border {
      border: none !important;
    }
    .el-input__inner {
      height: 35px !important;
    }
    .el-input__icon {
      line-height: 0px !important;
      font-weight: 1000 !important;
      color: #5C5F62 !important
    }
    .sub-heading {
      font-size: 14px;
      font-weight: 400;
      padding: 10px 0px;
  
    }
    .disabled {
      color: #828E9A;
    }
    .main-search-dropdown {
      width: 300px !important;
    }
    .border {
      margin: 10px 0px;
      border-top: 1px solid #ECEEF0;
    }
    .sub-items {
      padding: 10px 0px;
    }
    .group-wrapper {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .max-constraints-wrapper {
      padding-top: 30px;
    }
    .group-operator {
      padding: 10px 0px;
      width: 105px;
      .el-input__inner::placeholder {
        color: #828E9A !important;
      }
    }
    .group {
      padding: 0px 20px;
      border-left: 1px solid black;
      background: #FAFBFB;
      width: 100%;
    }
    .operator-wrapper {
      .el-select {
        width: 108px;
        .el-input__inner {
          height: 35px !important;
        }
      }
      .el-input {
        width: 108px;
        .el-input__inner {
          height: 35px !important;
        }
      }
    }
    .conversation-id {
      width: 50%;
    }
    .results-wrapper {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
      flex: 1;
      padding-bottom: 10px;

      .grey-trash-icon {
        background-image: url('../../assets/icons/icon_transcript_search_advnaced_filter_grey_filled_trash.svg');
        background-size: 95%;
        background-repeat: no-repeat;
        background-position-x: 0px;
        background-position-y: 0px;
        width: 16px;
        height: 20px;
        cursor: pointer;
      }
      .dropdown-wrapper {
        flex: 2;
        .el-select {
          .el-input.is-disabled .el-input__inner {
            background: white !important;
          }
          .el-input__inner {
            background: transparent !important;
          }
        }
        // placeholder text color
        .el-input__inner::placeholder {
          color: #C0C4CC !important;
        }
        .select-box {
          display: flex;
          align-items: center;
          border: 1px solid #CAD2DA;
          height: 39px;
          border-radius: 4px;
          cursor: pointer;
        }
        .placeholder-text {
          color: #C0C4CC;
        }
        .value-text {
          color: #2A2E32;
        }
        .value-box {
          display: flex;
          align-items: center;
          width: 100%;
          height: 100%;
          padding-left: 10px;
          .icon-placement-default {
            position: absolute;
            right: 50px;
            bottom: 6px;
          }
          .icon-placement-group {
            position: absolute;
            right: 50px;
            bottom: 6px;
          }
          .icon-placement-rotate {
            transform: rotate(-180deg);
            transition: transform 0.3s;
          }
          .icon-placement-rotate-back {
            transform: rotate(0deg);
            transition: transform 0.3s;
          }
          .el-icon-arrow-down:before {
            line-height: 0px !important;
            font-weight: 1000 !important;
            color: #5C5F62 !important;
          }

        }
      }
      
      .search-wrapper {
        flex: 4;
        border: 1px solid #CAD2DA;
        border-radius: 5px;
        height: 39px;
        display: flex;
        align-items: center;
        // change bg color of the disabled search for input
        .el-input.is-disabled .el-input__inner {
          background: white !important;
        }
        .el-input__inner {
          border: none;
          padding-left: 13px !important;
        }
      }
    }
    .search-condition-group {
      width: 100%;
      padding: 20px 0px;
      display: flex;
      align-items: center;
      gap: 25px;

      .btn-body{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
      }

      .blue-plus-icon {
        background-image: url('../../assets/icons/icon_transcript_search_advnaced_filter_blue_plus.svg');
        background-size: 95%;
        background-repeat: no-repeat;
        background-position-x: 0px;
        background-position-y: 0px;
        width: 16px;
        height: 16px;
        cursor: pointer;
        border: none;
        img {
          content: ""
        }
      }

      .blue-trash-icon {
        background-image: url('../../assets/icons/icon_transcript_search_advnaced_filter_blue_filled_trash.svg');
        background-size: 95%;
        background-repeat: no-repeat;
        background-position-x: 0px;
        background-position-y: 0px;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }


    }
    .action-btn {
      padding: 10px 20px;
      border: none;
      padding-left: 0px;
      padding-right: 0px;
      font-weight: 400;
      color: #1A55AD;
      background: transparent;
      font-size: 15px;
    }
    .garbage-wrapper {
      flex: 0.5;
    }
    .sub-actions {
      padding-top: 10px;
      padding-bottom: 0px;
    }
    .el-checkbox-group {
      display: flex;
      align-items: center;
      justify-content: space-between;
  
      .el-checkbox {
        margin: 0px !important;
        margin-right: 4px !important;
        .el-checkbox__inner {
          font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
          border: 2px solid var(--primary-checkbox-button-border-color) !important;
          width: 16px;
          height: 16px;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: var(--primary-checkbox-button-check-color) !important;
          border-color: var(--primary-checkbox-button-checked-border-color) !important;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner::after {
          left: 5px;
          top: 2px;
        }
        .el-checkbox__input.is-disabled .el-checkbox__inner {
          background-color: var(--primary-checkbox-button-disabled-background-color) !important;
          border-color: var(--primary-checkbox-button-disabled-border-color) !important;
        }
      }
    }

    // vertical scroll
    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #CAD2DA !important;
      border-radius: 50px !important;
    }
  }
  .footer {
    padding: 0px 20px;
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .actions {
      display: flex;
    }
    .actions-btn {
      padding: 10px 16px;
      color: #202223;
      border: 1px solid #CAD2DA;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: normal;
      font-size: 14px;
    }
    .reset {
      border: none;
      margin-left: -14px;
    }
    .clear-btn {
      position: relative;
      font-size: 14px;
      font-weight: normal;
      margin-right: 14px;
      color: var(--site-button-cancel-btn-primary-color);
      border: 0px solid var(--site-button-cancel-btn-primary-border-color);
      padding: 0px;
      .char {
        margin-left: auto;
      }
    }

    .apply-btn {
      position: relative;
      color: var(--site-font-chart-color);
      background: var(--site-button-primary-btn-background-primary-color);
      color: var(--site-button-primary-btn-text-primary-color);
      border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
      border-radius: 4px;
      width: 80px;
    }
    .apply-btn:hover {
      border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
      background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
      border-radius: 5px;
      color: var(--site-button-primary-btn-text-primary-color) !important;
    }
    .apply-btn:active {
      background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
    }
    .apply-btn:focus {
      border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
      // background-color: unset;
      border-radius: 5px;
      color: var(--site-button-primary-btn-text-primary-color) !important;
    }
    .disabled {
      background: #E4E5E7;
      color: #C9CCCF;
    }
  }
  .divider {
    border-bottom: 1px solid #CAD2DA;
  }
  .el-select {
    width: 100%;
    border: none;
    border: 1px solid #CAD2DA;
    border-radius: 5px;
    padding: 2px 0px;
    .el-input__inner {
      padding-left: 10px !important;
      border: none;
    }
    .el-input__inner:hover {
      border: none;
    } 
    // change the color of placeholder
    .el-input__inner::placeholder {
      color: #202223 !important;
      font-size: 14.22px;
    }
  }
}
.wy-analytics-transcript-search-dropdown-menu.handoffs {
  width: 446px !important;
  border-radius: 5px;
  .time{
    display: flex;
    justify-content: space-evenly;
    .el-input-number {
      margin-right: 2px;
      min-width: 11.5em !important;
      right: 11px;
      height: 33px !important;
      .el-input__inner{
        height: 33px !important;
        text-align: left;
      }

      .el-icon-arrow-up {
        color: transparent;
      }
      .el-icon-arrow-up:before {
        background-image: url('../../assets/icons/icon_handoff_arrow_up.svg');
        background-position-x: 16px;
      }
      .el-icon-arrow-down {
        color: transparent;
      }
      .el-icon-arrow-down:before {
        background-image: url('../../assets/icons/icon_handoff_arrow_down.svg');
        background-position-x: 16px;
      }
    }
    .el-input-number.is-controls-right .el-input-number__increase, .el-input-number.is-controls-right .el-input-number__decrease {
      border-bottom: 1px solid #DCDFE6;
      background: #E4E5E7;
      width: 21px;
      border-radius: 2px;
      height: 11.5px;
      margin-top: 2px;
      margin-bottom: 2px;
      margin-right: 2px;
    }
    input.display-time {
      border: 1px solid #d2d2d2;
      width: 14em !important;
      height: 2.6em;
      position: relative;
      border-radius: 4px;
      right: 9px;
      left: -2px;
      color: #C9CCCF;
      margin-right: 0px;
      padding: 0.3em 0.5em;
      font-size: 1em;
    }
    input.display-time:focus {
      outline: none;
      border: 2px solid #106FBC;
      border-radius: 4px;
    }
  }
  .horizontal-line{
    margin-bottom: -20px;
    margin-top: 25px;
  }
  .card-bottom-part{
    max-width: 419px !important;
    padding: 10px 0px 10px 25px !important;
  }
  .cus-msg-card .clear-btn {
    position: relative;
    bottom: -1px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: 162px !important;
  }
}
.time {
  .hours li {
    // border-left: 1px solid #CCC;
    border-right: 1px solid #CCC;
  }
  ul.minutes li {
    border-left: 1px solid #CCC;
    border-right: 1px solid #CCC;
  }
  ul.seconds li {
    border-left: 1px solid #CCC;
    border-right: 1px solid #CCC;
  }
}
.allFilters-popover .horizontal-line .handle-time .time {
  width: 100% !important;
}
.allFilters-popover .horizontal-line .handle-time .time, .allFilters-popover .horizontal-line .response-time .time{
  // width: 81%;
  // justify-content: space-evenly;

  // margin-left: -20px !important;
 
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  // margin-top: 8px;
  // margin-left: 0px !important;
  // margin-bottom: 6px !important;
  .dropdown-btn{
    display: none;
  }
}
.allFilters-popover .horizontal-line .handoffs .time{
  .el-icon-arrow-up {
    color: transparent;
  }
  .el-icon-arrow-up:before {
    background-image: url('../../assets/icons/icon_handoff_arrow_up.svg');
    background-position-x: 16px;
  }
  .el-icon-arrow-down {
    color: transparent;
  }
  .el-icon-arrow-down:before {
    background-image: url('../../assets/icons/icon_handoff_arrow_down.svg');
    background-position-x: 16px;
  }
}
.wy-analytics-transcript-search-dropdown-menu.handling-time .time input.display-time {
  left: -14px !important;
}

.wy-analytics-transcript-search-dropdown-menu .time {
  margin-left: 14px !important;
}
.wy-analytics-transcript-search-dropdown-menu.handling-time.time {
  margin-left: 0px !important;
  width: 300px !important;
}
.wy-analytics-transcript-search-dropdown-menu.handling-time {
  .time .dropdown {
    left: -12px !important;
  }
}
.wy-analytics-transcript-search-dropdown-menu.handling-time, .wy-analytics-transcript-search-dropdown-menu.response-time, .allFilters-popover .horizontal-line .handle-time, .allFilters-popover .horizontal-line .response-time{
  width: 580px !important;
  // border-radius: 5px;

  .cus-msg-card .card-bottom-part .clear-btn {
    position: relative;
    bottom: -1px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: 162px !important;
  }

  .time{
    width: 81%;
    // margin-left: 12px;
    display: flex;
    justify-content: space-evenly;
    .vue__time-picker {
      width: 11em !important;
      margin-right: 2px;
      min-width: 13.5em !important;
      // right: 11px;
      right: 0px;
      .controls{
        align-items: center;
        .clear-btn {
          color: #5C5F62;
        }
      }
      .dropdown{
        width: 14em !important;
        height: 17em !important;
        top: calc(2.2em + 7px) !important;
        .select-list{
          width: 14em !important;
          height: 17em !important;
        }
        ul li:not([disabled]).active {
          background: #E8F1FF;
          color: var(--site-font-tertiary-color);
        }
        ul li {
          line-height: 40px;
        }
        .hint {
          font-size: 14px;
          color: var(--site-font-tertiary-color) !important;
        }
        ul{
          &::-webkit-scrollbar {
            background-color: white !important;
            width: 15px !important;
          }
          &::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background: #CAD2DA !important;
            border-radius: 50px !important;
          }
        }
      }
    }
    input.display-time {
      border: 1px solid #d2d2d2;
      width: 14em !important;
      height: 2.6em;
      position: relative;
      border-radius: 4px;
      right: 9px;
      left: -2px;
      color: var(--site-font-tertiary-color);
      margin-right: 0px;
      padding: 0.3em 0.5em;
      font-size: 1em;
    }
    input.display-time:focus {
      outline: none;
      border: 2px solid #106FBC;
      border-radius: 4px;
    }

    .clear-btn {
      right: 17px !important;
    }
    // .vue__time-picker .dropdown {
    //   left: -12px;
    // }
  }
  .horizontal-line{
    margin-bottom: -20px;
    margin-top: 25px;
    padding-left: 17px;
    width: 90%;
  }
  .card-bottom-part{
    max-width: 550px !important;
    padding: 10px 0px 10px 25px !important;
  }
}
.wy-analytics-transcript-search-dropdown-menu.handling-time, .wy-analytics-transcript-search-dropdown-menu.response-time{
  .time{
    // width: 93% !important;
  }
  .cus-msg-card .card-bottom-part .clear-btn {
    right: 295px !important;
  }
}
.allFilters-popover .horizontal-line .containment, .allFilters-popover .horizontal-line .sentiment{
  .el-checkbox__inner {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
    width: 16px;
    height: 16px;
  }
}
.allFilters-popover .horizontal-line .containment, .allFilters-popover .horizontal-line .feedback{
  .el-checkbox__inner {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
    width: 16px;
    height: 16px;
  }
}

.wy-analytics-transcript-search-dropdown-menu.contact-reasons, .all-filters-contact-reasons {
  .check-box-section {
    .el-loading-mask {
      bottom: 12px;
      background-color: #FFF;

      .el-loading-spinner {
        top: 35%;
        background: var(--site-loading-icon);

        background-repeat: no-repeat;
        background-size: 18px;
        background-position: center;

        .circular {
          display: inline-block;
          width: 65px;
          height: 65px;
        }
      }

      .el-loading-spinner .path {
        -webkit-animation: loading-dash 2s ease-in-out infinite;
        animation: loading-dash 2s ease-in-out infinite;
        stroke-dasharray: 90, 150;
        stroke-dashoffset: 0;
        stroke-width: 2.5 !important;
        stroke: #0C2837 !important;
        stroke-linecap: round;

      }
    }
  }
}
.wy-analytics-transcript-search-dropdown-menu.contact-reasons, 
.wy-analytics-transcript-search-dropdown-menu.containment,
.wy-analytics-transcript-search-dropdown-menu.response-names,
.wy-analytics-transcript-search-dropdown-menu.intent-names, 
.wy-analytics-transcript-search-dropdown-menu.related-topics 
{
  width: 620px !important;
  border-radius: 5px;
  .el-checkbox__inner {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
    width: 16px;
    height: 16px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--primary-checkbox-button-check-color);
    border-color: var(--primary-checkbox-button-checked-border-color) !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }
}
.wy-analytics-transcript-search-dropdown-menu.sentiment{
  width: 446px !important;
  border-radius: 5px;
  .el-checkbox__inner {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
    width: 16px;
    height: 16px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--primary-checkbox-button-check-color);
    border-color: var(--primary-checkbox-button-checked-border-color) !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }
  .cus-msg-card .card-bottom-part {
    max-width: 406px;
  }
  .cus-msg-card .clear-btn {
    position: relative;
    bottom: -1px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: 150px !important;
  }
}
.wy-analytics-transcript-search-dropdown-menu.feedback{
  width: 446px !important;
  border-radius: 5px;
  .el-checkbox__inner {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    border: 2px solid var(--primary-checkbox-button-border-color) !important;
    width: 16px;
    height: 16px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--primary-checkbox-button-check-color);
    border-color: var(--primary-checkbox-button-checked-border-color) !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    left: 5px;
    top: 2px;
  }
  .cus-msg-card .card-bottom-part {
    max-width: 406px;
  }
  .cus-msg-card .clear-btn {
    position: relative;
    bottom: -1px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: 150px !important;
  }
}
.wy-analytics-transcript-search-dropdown-menu.agents {
  width: 484px !important;
  border-radius: 5px;
  // left: 708px !important;
  .el-select .el-input .el-select__caret {
    color: #5C5F62 !important;
  }
  .btn-select-all {
    float: right;
    padding-right: 0px;
    margin-top: -1px;
    cursor: pointer;
    font-size: 14px;
    background-image: var(--icon_close_popup);
    background-repeat: no-repeat;
    height: 36px;
    width: 36px;
  }

  .cus-msg-card .clear-btn {
    position: relative;
    bottom: -1px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: 168px;
  }

  .horizontal-line {
    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6px !important;
    }
    &::-webkit-scrollbar-thumb{
      border-radius: 10px;
      background: #CAD2DA !important;
      border-radius: 50px !important;

    }
  }
  .agent-time-filter {
    .flex {
      padding-top: 12px;
    }
    div.min-hint {
      right: 56px;
    }
    div.max-hint {
      left: -76px;
    }
    .agent-time-title {
      margin-top: 16px;
      margin-left: 20px;
      font-size: 14px;
      color: #202223;
    }
    .time{
      display: flex;
      margin-top: 8px;
      margin-left: 29px !important;
      margin-bottom: 6px !important;
      .vue__time-picker {
        width: 11em !important;
        margin-right: 2px;
        min-width: 13.5em !important;
        right: 11px;
        .controls{
          align-items: center;
          .clear-btn {
            color: #5C5F62;
          }
        }
        .dropdown{
          width: 14em !important;
          height: 17em !important;
          top: calc(2.2em + 15px) !important;
          .select-list{
            width: 14em !important;
            height: 17em !important;
          }
          ul li:not([disabled]).active {
            background: #E8F1FF;
            color: #2A2E32;
          }
          ul li {
            line-height: 40px;
          }
          .hint {
            font-size: 14px;
            color: #2A2E32 !important;
          }
          ul{
            &::-webkit-scrollbar {
              background-color: white !important;
              width: 15px !important;
            }
            &::-webkit-scrollbar-thumb{
              border-radius: 10px;
              background: #CAD2DA !important;
              border-radius: 50px !important;
            }
          }
        }
      }
      input.display-time {
        border: 1px solid #CAD2DA;
        width: 14em !important;
        height: 3.2em;
        position: relative;
        border-radius: 4px;
        right: 9px;
        left: -2px;
        color: #2A2E32;
        margin-right: 0px;
        padding: 0.3em 0.5em;
        font-size: 1em;
      }
      input.display-time:focus {
        outline: none;
        border: 2px solid #106FBC;
        border-radius: 4px;
      }
    }
    .flex {
      left: 0px;
    }
    .clear-btn {
        position: relative;
        bottom: -3px;
        right: 8px;
        // right: 174px;
        font-size: 14.22px;
        color: #106FBC;
        border: none !important;
        padding: 0px;
        .char {
          margin-left: auto;
        }
    }
    .invalid-time-range {
      background: #F1D3D5;
      background-image: url("../../assets/icons/icon_red_stop.svg");
      background-repeat: no-repeat;
      background-size: 14px;
      background-position-x: 10px;
      background-position-y: center;
      font-size: 13px;
      color: #59333E;
      border-radius: 5px;
      width: 245px;
      padding: 10px 0 10px 32px;
      line-height: 1;
      z-index: 1;
    }
  }
  .card-bottom-part {
    max-width: 441px !important;
  }
}

.wy-analytics-transcript-search-dropdown-menu {
  margin-top: 15px !important;
  box-shadow: 5px 5px 6px #00000029;
  border: 1px solid #F4F6F8 !important;
  border-radius: 10px;
  .agents {
    width: 620px !important;
    border-radius: 5px;

    .btn-select-all {
      float: right;
      padding-right: 0px;
      margin-top: -1px;
      cursor: pointer;
      font-size: 14px;
      background-image: var(--icon_close_popup);
      background-repeat: no-repeat;
      height: 36px;
      width: 36px;
    }
  }
  .contact-reasons, .containment {
    width: 620px !important;
    border-radius: 5px;
  }
  .el-checkbox{
    margin-top: 25px !important;
  }
  .title{
    margin-top: 0px !important;
  }
  .flex{
    display: flex;
    justify-content: space-around;
    position: relative;
    bottom: 14px;
    left: 12px;
    margin-bottom: 22px !important;
    .min-hint{
      position: relative;
      right: 93px;
      font-size: 14px;
      color: #4B5158;
    }
    .max-hint{
      position: relative;
      right: 131px;
      font-size: 14px;
      color: #4B5158;
    }
  }
  .cus-msg-card.handoffs .flex{
    .min-hint{
      position: relative;
      right: 76px;
      font-size: 14px;
      color: #4B5158;
    }
    .max-hint{
      position: relative;
      right: 76px;
      font-size: 14px;
      color: #4B5158;
    }
  }
  .top-part-flex{
    display: flex;
    justify-content: space-around;
    position: relative;
    bottom: 14px;
    right: 27px;
    width: 100%;
    margin-bottom: -35px !important;
  }
  .containment {
    /* vertical-align: top; */
    position: relative;
    bottom: 15px;
  }
  .cancel-text{
    font-size: 14px;
  }
  .cus-msg-card.handling-time,.cus-msg-card.response-time,.cus-msg-card.handoffs {
    .filter-header {
      .invalid-time-range {
        position: absolute;
        background: #F1D3D5;
        background-image: url("../../assets/icons/icon_red_stop.svg");
        background-repeat: no-repeat;
        background-size: 14px;
        background-position-x: 10px;
        background-position-y: center;
        font-size: 13px;
        color: #59333E;
        border-radius: 5px;
        width: 245px;
        padding: 10px 0 10px 32px;
        line-height: 1;
        z-index: 1;
        top: 0px;
      }
    }
    .horizontal-line {
      .time {
        .el-input-number.el-input-number--mini {
          border: 2px solid transparent;
        }
        .el-input-number.el-input-number--mini.has-error {
          border: 2px solid #E6494C;
          outline: unset;
          border-radius: 7px;
        }
        .el-input-number.el-input-number--mini.is-focused {
          border: 2px solid #106FBC;
          outline: unset;
          border-radius: 4px !important;
        }
      }
    }
    .clear-btn {
      position: relative;
      bottom: -1px;
      right: 8px;
      // right: 174px;
      font-size: 14.22px;
      color: var(--site-button-cancel-btn-primary-color);
      border: 1px solid var(--site-button-cancel-btn-primary-border-color);
      padding: 0px;
      .char {
        margin-left: auto;
        color: #5C5F62;
      }
    }
    .dropdown-btn{
      display: none;
    }
    .el-input-number__increase:hover {
      color: #214586;
    }
  }

  .cus-msg-card.handoffs {
    .invalid-time-range {
      width: 262px !important;
    }
  }
  .clear-filter-text{
    position: relative;
    right: 21px;
    font-weight: normal;
    font-size: 14px;
  }
  .all-filter-top-title{
    color:#214586;
    font-size: 15px;
    font-weight: bold;
    // margin-top: 40px;
  }
  .other {
    color: #214586;
    background-color: #fff;
    border-color: #214586;
    height: 35px;
    margin-top: 35px;
    margin-right: 10px;
    display: flex;
    align-items: center;
  }

  .all-filter-top-two-title {
    margin-top: 30px;
    font-size: 14.22px;
    color: #202223;
    .filter-title{
      font-size: 14.22px;
      color: #202223;
    }
  }

  .dash {
    padding: 0px 0px;
    color: #CAD2DA;
    font-size: 25px;
    position: relative;
    right: 11px;
  }
  // .reset-btn{
  //   cursor: pointer;
  // }

  .text {
    font-size: 16px;
  }
  span.contact-reason-dropdown-text {
    position: relative;
    bottom: 4px;
    right: 33px;
    color: #647B86;
    font-weight: normal;
    font-size: 15px;
  }
  .el-icon--right {
    margin-left: 5px;
    position: relative;
    left: 35px;
    bottom: 4px;
    color: #5C5F62;
  }
  span.max-hint {
    position: relative;
    right: 32px;
    font-size: 14px;
    color: #4B5158;
  }
  label.el-checkbox.checkbox.containment-checkbox {
    position: relative;
    right: 25px;
  }
  span.max-hint.last-max-hint {
    position: relative;
    right: 90px;
  }
  .reset-btn{
    text-decoration: underline;
    color: var(--site-font-primary-color);
    font-size: 15px;
    align-self: left;
    left: -40px;
    position: relative;
    cursor: pointer;
  }
  button.el-button.contact-reasons-dropdown.el-button--default.is-plain.el-dropdown-selfdefine {
    border-radius: 4px;
    width: 100%;
    height: 31px;
  }
  span.reset-btn.handoff-reset {
  left: -46px !important;
  position: relative;
  }
  .contact-reasons, .agent-filters {
    position: relative;
    left: 24px;
  }
  .all-filter-header{
    position: relative;
    left: 23px;
    color: var(--site-font-primary-color);
    font-size: 15px;
    align-content:left;
    font-weight: bold;
  }
  .cus-msg-card.all-filter-card {
    width: 374px;
  }
  .cus-msg-card {
    overflow: visible;
    width: 100%;
    left: 10px;
    top: 230px;
    background: #ffffff;
    border: 1px solid #f4f4f4;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-top: -15px;
    margin-bottom: -15px;
    .search-button {
      background-color: white;
      border-radius: 8px;
      width: 38px;
      height: 23px;
      text-align: center;
      margin-top: 5px;
      margin-left: 17px;
      padding: 3px 0px 0px 0px;
      font-size: 22px;
      position: absolute;
      z-index: 100;
      background: transparent;
      color: #5C5F62;
      cursor: pointer;
    }

    .card-bottom-part {
      display: flex;
      width: 100%;
      border-top: 1px solid #CAD2DA;
      justify-content: space-between;
      padding: 13px 15px 15px 25px;
      max-width: 420px;
      justify-content: flex-end;
      button.el-button.submit-btn.el-button--default.is-round {
        margin-left: auto;
        padding: 5px 15px;
      }
      span {
        cursor: pointer;
      }
      .transcript-search-cancel-btn {
        padding: 10px 16px;
        color: var(--site-button-cancel-btn-primary-color);
        border: 1px solid var(--site-button-cancel-btn-primary-border-color);
        border-radius: 5px;
        height: 17px;
        width: 45px;
        font-size: 14.22px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .transcript-search-apply-btn {
        padding: 10px 16px;
        cursor: pointer;
        margin-left: 10px;
        margin-right: 13px;
        background: var(--site-button-primary-btn-background-primary-color);
        color: var(--site-button-primary-btn-text-primary-color);
        border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
        border-radius: 5px;
        height: 17px;
        width: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14.22px;
      }
      .transcript-search-apply-btn:hover {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .transcript-search-apply-btn:active {
        background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
      }
      .transcript-search-apply-btn:focus {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
    }

    .horizontal-line .el-checkbox-group {
      height: 105px;
      overflow-y: auto;
      .el-checkbox__input {
        line-height: 1.5;
      }
    }
  }

  .cus-msg-card .agents {
    overflow: hidden;
    width: 343px;
    left: 10px;
    top: 230px;
    padding: 5px 20px 20px 25px;
    background: #ffffff;
    border: 1px solid #f4f4f4;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-top: -15px;
    margin-bottom: -15px;

    .card-bottom-part {
      display: flex;
      width: 100%;
      border-top: 1px solid #CAD2DA;
      button.el-button.submit-btn.el-button--default.is-round {
        margin-left: auto;
        padding: 5px 15px;
      }
      span {
        cursor: pointer;
      }
    }

    .horizontal-line .el-checkbox-group {
      height: 105px;
      overflow-y: auto;
      .el-checkbox__input {
        line-height: 1.5;
      }
    }
  }

  .time-picker > input {
    width: 25px;
  }
  .card-bottom-part {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #CAD2DA;
    padding-top: 33px;
  }
  .checkbox {
    display: block;
  }
  .vue__time-picker .dropdown {
    position: absolute;
    z-index: 5;
    top: calc(2.2em + 2px);
    left: 0;
    background: rgb(255, 255, 255);
    box-shadow: 0 1px 6px rgba(0,0,0,0.15);
    width: 10em;
    height: 6em;
    overflow: hidden;
    border-radius: 5px;
    font-weight: normal;

    .select-list {
      height: 6em;
    }
  }
  .vue__time-picker .controls .char {
    display: inline;
    color: #5C5F62;
  }
  .submit-btn {
    background: #214586;
    border: 2px solid #214586;
    box-sizing: border-box;
    border-radius: 35px;
    color: white;
  }

  .min-time,
  .max-time {
    position: relative;
    right: 10px;
  }

  .el-input[data-v-6d227d34] {
    width: 65px;
  }

  .hf-time {
    width: 65px;
    height: 25px;
  }

  .horizontal-line {
    margin-bottom: 6px;
    margin-right: 0px;
    padding-bottom: 10px;

    .min-handling-time-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-handling-time-label {
      margin-left: 126px;
      font-size: 12px;
    }
    .min-response-time-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-response-time-label {
      margin-left: 126px;
      font-size: 12px;
    }
    .min-handoffs-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-handoffs-label {
      margin-left: 126px;
      font-size: 12px;
    }
  }

  .horizontal-line-senti{
    margin-bottom: 6px;
    margin-right: -21px;
    padding-bottom: 0px;
  }
  .horizontal-line > input {
    margin-left: 25px;
  }
  .check-box-section {
    height: 236px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #CAD2DA !important;
      border-radius: 50px !important;
    }
  }
  .check-box-section .checkbox-first-row {
    margin-left: 16px;
    padding-bottom: 2px !important;
  }
  .el-checkbox {
    color: var(--site-font-primary-color);
    margin-left: 16px;
    margin-bottom: 0px;
    margin-left: 25px;
    margin-right: 25px !important;
    display: flex;
    flex-direction: row;
    align-items: center;

    .el-checkbox__label {
      outline: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .el-checkbox__input {
      vertical-align: baseline;
      top: 0px;
    }
  }
  span.el-checkbox__inner:hover {
    // box-shadow: unset;
    -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow);
    box-shadow: var(--primary-checkbox-button-hover-box-shadow);
  }
  .el-checkbox.is-checked .el-checkbox__label {
    color: var(--site-font-primary-color) !important;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: var(--site-font-primary-color) !important;
  }

  .reg-inp {
    background: #ffffff;
    border: 1px solid #c0c0c0;
    box-sizing: border-box;
    border-radius: 4px;
    margin-left: 38px;
    margin-bottom: 15px;
    padding: 5px 0px 5px 15px;
  }
  .no-matching-data-text{
    display: flex;
    justify-content: center;
  }

  .time-hf {
    padding-left: 25px;
  }
  .min-time[data-v-6d227d34],
  .max-time[data-v-6d227d34] {
    width: 35 !important;
  }

  .time {
    margin-left: 25px;
    margin-bottom:20px;
  }
  .dash {
    padding: 0px 5px;
  }
  .el-dropdown-menu__item {
    max-width: 70%;
    display: inline-block;
    padding: 0px 17px;
    margin-bottom: 17px;
    list-style: none;
    line-height: 36px;
    margin: 0;
    font-size: 14px;
    color: var(--site-font-primary-color);
    cursor: pointer;
    outline: 0;
  }
  .el-select {
    width: 324px;
    position: relative;
  }
}

.wy-analytics-transcript-search-dropdown-menu.agents .cus-msg-card .horizontal-line .el-select__input {
  color: var(--site-font-tertiary-color) !important;
  font-size: 14px;
}

.wy-analytics-transcript-search-dropdown-menu.agents {
    margin-top: 24px !important;
    padding: 0px;
    box-shadow: none;
  .horizontal-line .el-checkbox-group {
    height: fit-content;
  }
}

.wy-analytics-transcript-search-dropdown-menu.containment {
  margin-top: 15px!important;
  max-width: 446px;
  .card-bottom-part {
    max-width: 406px;
  }
  .horizontal-line .el-checkbox-group {
    height: fit-content;
  }
  .horizontal-line .signal-flex {
    display: flex;
    align-items: center;
    gap: 6px;

    .signal-icon {
      height: 20px;
      width: 20px;
    }
  }
  .cus-msg-card .clear-btn {
    position: relative;
    bottom: -1px;
    font-size: 14.22px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    padding: 0px;
    right: 162px;
  }
  .el-checkbox {
    display: flex;
    align-items: center;
    .el-checkbox__input {
      line-height: normal !important;
    }
  }
}

.wy-analytics-transcript-search-dropdown-menu.selected-cus-msg {
  margin-top: 0px !important;
  left: 315px !important;
  .el-radio {
    display: flex;
    margin-left: 25px;
    margin-bottom: 10px;
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #214586;
      background: #214586;
    }
    .el-radio__input.is-checked+.el-radio__label {
      color: #214586;
    }
    .el-radio__inner:hover {
      border-color: #214586;
    }
  }

}
    .filter-header{
      color: var(--site-font-secondary-color);
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 20px;
      font-weight: 400;
      padding: 20px 13px 20px 20px;
      border-bottom: 1px solid #CAD2DA;
      .btn-select-all {
        float: right;
        padding-right: 0px;
        margin-top: -5px;
        cursor: pointer;
        font-size: 14px;
        background-image: var(--icon_close_popup);
        background-repeat: no-repeat;
        height: 36px;
        width: 36px;
      }
    }

.wy-analytics-transcript-search-dropdown-menu.agents {
  .cus-msg-card {
    .filter-header{
      color: var(--site-font-secondary-color);
      margin-bottom: 10px !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 14px;
      font-weight: 500 !important;
    }
    .agent-id-cancel-btn{
      color: #1C4DB2;
      margin-bottom: 10px;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-weight: 400;
      padding: 8px 9px;
      border-radius: 5px;
      position: relative;
      right: 8px;

      &:hover{
        background: #F4F6F8;
      }
    }
    .agent-title{
      color: var(--site-font-secondary-color);
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 20px;
      font-weight: 400;
      padding: 20px;
      border-bottom: 1px solid #CAD2DA;
    }
    .horizontal-line {
      border-bottom: none !important;
      width: 100%;
      height: 400px;
      overflow: auto;
      margin-bottom: 0px;
      
      .agent-ids {
        margin-bottom: 25px !important;
      }
      .el-dropdown-menu__item {
        display: flex;
        margin-top: 18px;
        flex-direction: column;
      }
      .el-input {
        border: 1px solid #CAD2DA;
        border-radius: 5px;
        padding: 1px;

      }
      .el-input__inner {
        border: none !important;
      }
      .el-select__input {
        margin-left: -2px;
      }
      .el-select__input::placeholder {
        color: #828E9A;
      }
      .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: transparent !important;
        color: var(--site-font-secondary-color) !important;
      }
      .el-tag.el-tag--info {
        background-color: #F2F3F3;
        border-color: #F2F3F3;
        color: var(--site-font-tertiary-color);
        font-size: 14px;
        max-width: 211px !important;
        width: fit-content;
        margin-left: -2px !important;
        padding-left: 5px !important;
        padding-right: 9px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .el-select__tags {
        margin-left: 9px !important;
      }
      .el-tag.el-tag--info .el-tag__close {
        color: #909399;
        display: none;
      }
    }
    .el-input {
      width: 93% !important;
    }
  }
}
.wy-analytics-transcript-search-dropdown-menu.agents .cus-msg-card .horizontal-line .el-input__inner {
    &:hover{
      background: #F4F6F8;
    }
}

.el-checkbox__input.is-disabled .el-checkbox__inner {
  border: 1px solid var(--primary-checkbox-button-disabled-border-color) !important;
}
.el-checkbox__input.is-disabled .el-checkbox__inner:hover {
  box-shadow: unset !important;
}

.allFilters-popover .horizontal-line .containment {
  .el-checkbox__input.is-disabled .el-checkbox__inner {
    border: 1px solid var(--primary-checkbox-button-disabled-border-color) !important;
  }
  .el-checkbox__input.is-disabled .el-checkbox__inner:hover {
    box-shadow: unset !important;
  }
}

.wy-analytics-transcript-search-dropdown-menu.intent-names {
  .reset-btn-icon {
    position: relative;
    
  }
}
.wy-analytics-transcript-search-dropdown-menu.contact-reasons,
.wy-analytics-transcript-search-dropdown-menu.response-names, 
.wy-analytics-transcript-search-dropdown-menu.intent-names, 
.wy-analytics-transcript-search-dropdown-menu.related-topics
{
  width: 620px !important;
  .cus-msg-card {
    .horizontal-line {
      margin-right: 0px;
      margin-left: 0px;
      padding-right: 5px;
      margin-bottom: 0px;
      padding-top: 25px;
      padding-bottom: 0px;
      overflow: hidden;
      border-top: 1px solid #CAD2DA;
      .reg-inp {
        background: #ffffff;
        border: 1px solid #CAD2DA;
        box-sizing: border-box;
        border-radius: 4px;
        height: 36px;
        margin-left: 15px !important;
        margin-bottom: 15px;
        padding: 5px 28px 5px 39px;
        width: 575px;
      }
    }
    .card-bottom-part {
      max-width: 582px;
      display: flex;
      justify-content: space-between;
      padding-left: 20px;
      .actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
    .contact-reason-label {
      display: inline-block;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 20px;
      color: var(--site-font-secondary-color);
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 20px;
      font-weight: 400;
    }

    .btn-select-all {
      float: right;
      padding-right: 20px;
      margin-top: 12px;
      cursor: pointer;
      font-size: 14px;
      background-image: var(--icon_close_popup);
      background-repeat: no-repeat;
      height: 36px;
      width: 36px;
    }
    .input-hight-light {
      background-color: #E8F1FF !important;
    }

    .fa-times-circle {
      position: relative;
      left: -25px;
      bottom: -1px;
      color: #214586;
      font-size: 16px;
      cursor: pointer;
    }
    .el-checkbox__inner {
      border: 2px solid var(--primary-checkbox-button-border-color) !important;
    }
    .horizontal-line .el-checkbox-group {
      height: fit-content;
      // overflow-y: auto;
      width: 100%;

      &::-webkit-scrollbar {
        background-color: transparent !important;
        width: 8px !important;
      }
      &::-webkit-scrollbar-thumb{
        background: #CAD2DA !important;
        border-radius: 5px;
      }

      .el-checkbox {
        color: var(--site-font-primary-color);
        margin-bottom: 23px;
        margin-left: 15px;
        margin-right: 15px !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        .el-checkbox__label {
          // max-width: 230px;
          width: 95%;
          .display-topic-name {
            display: inline-block;
            outline: none;
            max-width: 473px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .topic-number {
            float: right;
          }
        }
      }
      .el-checkbox__inner {
        top: 0px;
        width: 16px;
        height: 16px;
      }
    }
  }
  .clear-btn {
    padding: 10px 16px;
    // color: #202223;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    border-radius: 5px;
    height: 17px;
    width: 45px;
    font-size: 14.22px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .apply-btn {
    padding: 10px 16px;
    cursor: pointer;
    margin-left: 10px;
    margin-right: 13px;
    background: var(--site-button-primary-btn-background-primary-color);
    color: var(--site-button-primary-btn-text-primary-color);
    border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14.22px;
    font-weight: 400;
  }
  .apply-btn:hover {
    border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
    background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
    border-radius: 5px;
    color: var(--site-button-primary-btn-text-primary-color) !important;
  }
  .apply-btn:active {
    background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
  }
  .apply-btn:focus {
    border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
    // background-color: unset;
    border-radius: 5px;
    color: var(--site-button-primary-btn-text-primary-color) !important;
  }

  .card-bottom-part {
    padding-top: 16px;
  }
}

.wy-analytics-transcript-search-dropdown-menu.localAgentFilter {
  .cus-msg-card {
    .horizontal-line {
      margin-right: 0px;
      margin-left: 0px;
      border: 1px #e7e6e6 solid;
      padding-top: 10px;
      padding-bottom: 0px;
      border-radius: 10px;
      overflow: hidden;
      .reg-inp {
        background: #ffffff;
        border: 1px solid #c0c0c0;
        box-sizing: border-box;
        border-radius: 4px;
        margin-left: 15px !important;
        margin-bottom: 15px;
        padding: 5px 28px 5px 39px;
        width: 265px;
      }
    }
    .contact-reason-label {
      display: inline-block;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .btn-select-all {
      float: right;
      margin-top: 12px;
      cursor: pointer;
      font-size: 14px;
      text-decoration: underline;
      background-image: var(--icon_close_popup);
      background-repeat: no-repeat;
      height: 36px;
      width: 36px;
    }
    .fa-times-circle {
      position: relative;
      left: 258px;
      bottom: 37px;
      color: #214586;
      font-size: 16px;
      cursor: pointer;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: var(--site-font-primary-color);
    }
    .horizontal-line .el-checkbox-group {
      height: 305px !important;
      overflow-y: auto;
      width: 295px;

      .el-checkbox {
        color: var(--site-font-primary-color);
        margin-bottom: 10px;
        margin-left: 15px;
        margin-right: 15px !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        .el-checkbox__label {
          max-width: 230px;
          width: 95%;
          .display-topic-name {
            display: inline-block;
            outline: none;
            max-width: 180px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .topic-number {
            float: right;
          }
        }
      }
      .el-checkbox__inner {
        top: 0px;
      }
    }
  }
}

.allFilters-popover {
  width: 464px !important;
  // width: 338px !important;
  overflow: hidden;
  // width: 343px;
  left: 10px;
  top: 230px;
  padding: 0px !important;
  background: #ffffff;
  box-sizing: border-box;
  // box-shadow: 5px 5px 6px #00000029;
  border: 1px solid #F4F6F8 !important;
  border-radius: 10px;
  margin-top: -15px;
  margin-bottom: -15px;
  max-height: 610px;
  height: calc(100% - 295px);
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 26px 80px rgba(0, 0, 0, 0.2);
  border-radius: 8px;

  .cus-msg-card.all-filter-card {
    box-sizing: border-box;
    border-radius: 10px;
    border-bottom-right-radius: 0px;
    border-top-right-radius: 0px;
    height: 100%;
    .content {
      padding: 20px;
      max-height: 424px;
      height: calc(100% - 180px);
      overflow-x: hidden;
      overflow-y: auto;
      margin-right: 4px;
      &::-webkit-scrollbar {
        background-color: white !important;
        width: 6px !important;
      }
      &::-webkit-scrollbar-thumb{
        background: #CAD2DA !important;
        border-radius: 50px !important;
      }
      .horizontal-line .el-checkbox__input {
        line-height: 0.5;
      }
    }
    .card-bottom-part {
      display: flex;
      width: 100%;
      border-top: 1px solid #CAD2DA;
      justify-content: space-between;
      padding: 13px 15px 14px 25px;
      max-width: 433px;
      align-items: center;
      span {
        cursor: pointer;
      }
      .all-filters-button-flex{
        display: flex;
      }
      .transcript-search-cancel-btn{
        padding: 10px 16px;
        // color: #202223;
        color: var(--site-button-cancel-btn-primary-color);
        border: 1px solid var(--site-button-cancel-btn-primary-border-color);
        border-radius: 5px;
        height: 17px;
        width: 45px;
        font-size: 14.22px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .transcript-search-apply-btn{
        padding: 10px 16px;
        cursor: pointer;
        margin-left: 10px;
        margin-right: 13px;
        background: var(--site-button-primary-btn-background-primary-color);
        color: var(--site-button-primary-btn-text-primary-color);
        border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
        border-radius: 5px;
        height: 17px;
        width: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14.22px;
      }
      .transcript-search-apply-btn:hover {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
      .transcript-search-apply-btn:active {
        background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
      }
      .transcript-search-apply-btn:focus {
        border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
        border-radius: 5px;
        color: var(--site-button-primary-btn-text-primary-color) !important;
      }
    }

    .signal-flex {
      display: flex;
      align-items: center;
      gap: 6px;

      .signal-icon {
        height: 20px;
        width: 20px;
      }
    }

    .mutiple-select-section{
    .el-dropdown-menu__item{
      display: flex;
      margin-top: 18px;
      flex-direction: column;
    }
    .el-dropdown-menu__item {
        display: flex;
        margin-top: 15px;
        flex-direction: column;
        padding: 0px !important;
      }
      .el-input {
        border: 1px solid #CAD2DA;
        border-radius: 5px;
        padding: 1px;
        width: 94.5%;
        color: var(--site-font-tertiary-color);
        font-size: 14px;
      }
      .el-input__inner {
        border: none !important;
      }
      .el-select__input {
        margin-left: 1px;
      }
      .filter-header {
        color: var(--site-font-secondary-color);
        margin-bottom: 10px !important;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 14px;
        font-weight: 500 !important;
      }
      .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: transparent !important;
        color: var(--site-font-secondary-color) !important;
      }
      .el-tag.el-tag--info {
        background-color: #F2F3F3;
        border-color: #F2F3F3;
        color: var(--site-font-tertiary-color);
        font-size: 14px;
        max-width: 211px !important;
        width: fit-content;
        margin-left: -2px !important;
        padding-left: 5px !important;
        padding-right: 9px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .el-tag.el-tag--info .el-tag__close {
        color: #909399;
        display: none;
      }
      .el-select__tags {
        margin-left: 6px !important;
      }
      .el-select .el-input .el-select__caret {
        color: #5C5F62 !important;
      }

    }
  }
  .sentiment {
    width: 100%;
    //border-bottom: 1px solid #CAD2DA; //commented out for OC-1171
    height: 100px;
    //margin-bottom: 25px; //commented out for OC-1171
  }
  .feedback {
    width: 100%;
    height: 100px;
  }

  .contact-reasons .all-filter-top-two-title {
    // margin-top: 30px;
    margin-top: 0px;
    margin-bottom: 17px;
    display: inline-block;
    font-size: 14.22px;
    color: #202223;
    width: fit-content;
  }
  .agent-filters {
    .all-filter-top-two-title {
      margin-bottom: 20px;
      margin-top: 20px;
      display: inline-block;
      font-size: 14.22px;
      color: #202223;
      width: fit-content;
    }
    .agent-container {
      width: 80%;
      margin-top: -30px;
      .filter-title{
        color: #202223 !important;
        font-size: 14.22px;
        margin-bottom: 7px;
        &:hover{
          color: #202223 !important;
        }
      }
    }
    .agent-time-filter {
      .dash {
        right: -1px !important
      }

      div.min-hint {
        right: 34px;
      }
      div.max-hint {
        left: 38px;
      }
      .agent-time-title {
        margin-top: 20px;
        font-size: 14px;
        color: #202223;
      }
      .time{
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
        margin-left: 0px !important;
        margin-bottom: 6px !important;
        .vue__time-picker {
          width: 11em !important;
          margin-right: 2px;
          min-width: 13.5em !important;
          right: 0px !important;
          .controls{
            align-items: center;
            .clear-btn {
              color: #5C5F62;
            }
          }
          .dropdown{
            width: 14em !important;
            height: 17em !important;
            top: calc(2.2em + 7px) !important;
            .select-list{
              width: 14em !important;
              height: 17em !important;
            }
            ul li:not([disabled]).active {
              background: #E8F1FF;
              color: #2A2E32;
            }
            ul li {
              line-height: 40px;
            }
            .hint {
              font-size: 14px;
              color: #2A2E32 !important;
            }
            ul{
              &::-webkit-scrollbar {
                background-color: white !important;
                width: 15px !important;
              }
              &::-webkit-scrollbar-thumb{
                border-radius: 10px;
                background: #CAD2DA !important;
                border-radius: 50px !important;
              }
            }
          }
        }
        input.display-time {
          border: 1px solid #CAD2DA;
          width: 14em !important;
          height: 2.6em;
          position: relative;
          border-radius: 4px;
          right: 9px;
          left: -2px;
          color: #2A2E32;
          margin-right: 0px;
          padding: 0.3em 0.5em;
          font-size: 1em;
        }
        input.display-time:focus {
          outline: none;
          border: 2px solid #106FBC;
          border-radius: 4px;
        }
      }
      .flex {
        left: 0px;
      }
      .clear-btn {
          position: relative;
          bottom: -3px;
          right: 8px;
          // right: 174px;
          font-size: 14.22px;
          color: #106FBC;
          border: none !important;
          padding: 0px;
          .char {
            margin-left: auto;
          }
      }
      .invalid-time-range {
        background: #F1D3D5;
        background-image: url("../../assets/icons/icon_red_stop.svg");
        background-repeat: no-repeat;
        background-size: 14px;
        background-position-x: 10px;
        background-position-y: center;
        font-size: 13px;
        color: #59333E;
        border-radius: 5px;
        width: 245px;
        padding: 10px 0 10px 32px;
        line-height: 1;
        z-index: 1;
      }
    }
  }
  .all-filters-btn .applied-filter-number {
    color: #214586;
  }
  .horizontal-line .besbas_signals {
    margin-top: 6px;
    border-bottom: 1px solid #CAD2DA;
    .el-checkbox-group{
      padding-bottom: 13px;
      /* overflow-y: auto; */
      display: block;
      .el-checkbox.checkbox.containment-checkbox{
        padding-bottom: 15px;
      }
      .el-checkbox__inner{
        border: 2px solid var(--primary-checkbox-button-border-color) !important;
        width: 16px;
        height: 16px;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: var(--primary-checkbox-button-check-color);
        border-color: var(--primary-checkbox-button-checked-border-color) !important;
      }
    }
  }
  .horizontal-line .el-checkbox-group {
    // height: 17px;
    padding-bottom: 28px;
    /* overflow-y: auto; */
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    .el-checkbox{
      display: flex;
      flex-direction: row;
      align-items: center;
      .el-checkbox__label {
        line-height: 24px;
        top: 0px;
        position: relative;
      }
    }
    span.el-checkbox__inner:hover {
      -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow)  !important;
      box-shadow: var(--primary-checkbox-button-hover-box-shadow) !important;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: var(--primary-checkbox-button-check-color);
      border-color: var(--primary-checkbox-button-checked-border-color) !important;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner::after {
      left: 5px;
      top: 2px;
    }
  }
  .all-filter-top-title{
    color:#214586;
    font-size: 15px;
    font-weight: bold;
    // margin-top: 40px;
  }
  .all-filter-top-two-title {
    // margin-top: 30px;
    position: relative;
    height: 24px;
    margin-bottom: 17px;
    display: inline-block;
    font-size: 14.22px;
    color: #202223;
    width: fit-content;

    .invalid-time-range {
      position: absolute;
      background: #F1D3D5;
      background-image: url("../../assets/icons/icon_red_stop.svg");
      background-repeat: no-repeat;
      background-size: 14px;
      background-position-x: 10px;
      background-position-y: center;
      font-size: 14px;
      color: #59333E;
      border-radius: 5px;
      width: 252px;
      padding: 10px 0 10px 32px;
      line-height: 1;
      z-index: 1;
      top: 0px;
    }
  }
  .horizontal-line .handoffs {
    .invalid-time-range {
      position: absolute;
      background: #F1D3D5;
      background-image: url("../../assets/icons/icon_red_stop.svg");
      background-repeat: no-repeat;
      background-size: 14px;
      background-position-x: 10px;
      background-position-y: center;
      font-size: 14px;
      color: #59333E;
      border-radius: 5px;
      width: 283px;
      padding: 10px 0 10px 32px;
      line-height: 1;
      z-index: 1;
      top: 0px;
    }
    .time {
      .el-input-number.el-input-number--mini {
        border: 2px solid transparent;
      }
      .el-input-number.el-input-number--mini.has-error {
        border: 2px solid #E6494C;
        outline: unset;
        border-radius: 7px;
      }
      .el-input-number.el-input-number--mini.is-focused {
        border: 2px solid #106FBC;
        outline: unset;
        border-radius: 4px;
      }
    }
  }
  .flex-select-all {
    margin-left: auto;
    width: fit-content;
    margin-top: 3px;
    float: right;
  }
  .all-filter-header{
    position: relative;
    // left: 23px;
    color: var(--site-font-primary-color);
    font-size: 15px;
    align-content:left;
    font-weight: bold;
  }
  .dash {
    padding: 0px 0px;
    color: #CAD2DA;
    font-size: 25px;
    position: relative;
    right: 11px;
  }
  .response-time, .handle-time {
    .time .dash {
      padding: 0px 5px;
      color: #CAD2DA;
      font-size: 25px;
      position: relative;
      right: -24px;
    }
    // .time-picker-overlay {
      // display: none;
    // }
  }
  .reset-btn{
    cursor: pointer;
  }
  .horizontal-line {
    // border-bottom: 1px solid #e7e6e6;
    margin-bottom: 6px;
    // padding-bottom: 10px;
    // margin-right: -21px;
    // margin-left: -25px;
    padding-bottom: 10px;
    .min-handling-time-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-handling-time-label {
      margin-left: 126px;
      font-size: 12px;
    }
    .min-response-time-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-response-time-label {
      margin-left: 126px;
      font-size: 12px;
    }
    .min-handoffs-label {
      margin-left: 25px;
      font-size: 12px;
    }
    .max-handoffs-label {
      margin-left: 126px;
      font-size: 12px;
    }
    span.contact-reason-dropdown-text {
      position: relative;
      bottom: 8px;
      // right: 33px;
      color: #647B86;
      font-weight: normal;
      font-size: 15px;
      display: flex;
    }
    span.contact-reason-dropdown-text.grey-shade {
      background-color: #F2F3F3;
      width: fit-content;
      padding: 4px;
      border-radius: 5px;
    }
    span.contact-reason-dropdown-text-all {
      position: relative;
      bottom: 2px;
      // right: 33px;
      color: #C4C4C4;
      font-weight: normal;
      font-size: 15px;
      margin-right: 50px;
      display: flex;
      padding-left: 3px;
    }
    // span.contact-reason-dropdown-text-all.grey-shade {
    //   background-color: #F2F3F3;
    //   width: fit-content;
    //   padding: 4px;
    //   border-radius: 5px;
    // }
    .el-icon--right.grey-shade {
      float: right;
      position: relative;
      // left: 35px;
      bottom: 25px;
      color: #5C5F62;
    }
    .el-icon--right {
      float: right;
      position: relative;
      // left: 35px;
      bottom: 17px;
      color: #5C5F62;
    }
    .el-icon--right-selected {
      float: right;
      position: relative;
      bottom: 25px;
      color: #5C5F62;
    }
    div.min-hint {
      position: relative;
      right: 30px;
      font-size: 14px;
      color: #4B5158;
    }
    div.max-hint {
      position: relative;
      left: 33px;
      font-size: 14px;
      color: #4B5158;
    }
    label.el-checkbox.checkbox.containment-checkbox {
      position: relative;
      // right: 25px;
    }
    span.max-hint.last-max-hint {
      position: relative;
      // right: 90px;
    }
    .reset-btn{
      text-decoration: underline;
      color: var(--site-font-primary-color);
      font-size: 13px;
      align-self: left;
      // left: -40px;
      position: relative;
    }
    button.el-button.contact-reasons-dropdown.el-button--default.is-plain.el-dropdown-selfdefine {
      border-radius: 4px;
      width: 80% !important;
      padding-left: 16px;
      padding-right: 9px;
      height: 40px;
      padding: 15px 6px 15px 3px;
      border: 1px #CAD2DA solid !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span.reset-btn.handoff-reset {
    // left: -46px !important;
    position: relative;
    }
    .contact-reasons {
      position: relative;
      padding-bottom: 20px;
      margin-bottom: 5px;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #CAD2DA;
      width: 100%;
    }

    .handle-time {
      margin-top: 20px;
      padding-bottom: 25px;
      width: 100% !important;
      border-bottom: 1px solid #CAD2DA;
      border-radius: 0px !important;

    }
    .response-time {
      //margin-bottom: 25px;
      padding-bottom: 25px;
      width: 100% !important;
      border-bottom: 1px solid #CAD2DA;
    }
    .handoffs {
      margin-bottom: 10px;
    }

    .title{
      margin-top: 0px !important;
    }
    .flex{
      // display: flex;
      justify-content: space-around;
      position: relative;
      // bottom: 14px;
      // left: 9px;
      display: flex;
      // margin-bottom: 22px !important;
      margin-top: 2px;
      width: 305px;
    }

    .top-part-flex{
      display: inline-flex;
      justify-content: space-around;
      position: relative;
      width: 100%;
      flex-direction: column;
      border-bottom: 1px solid #CAD2DA;
    }
    .containment {
      /* vertical-align: top; */
      position: relative;
      border-top: 1px solid #FFF;
      border-bottom: 1px solid #CAD2DA;
      margin-top: 0px;
      .all-filter-top-two-title {
        margin-top: 0px;
      }
    }
    .containment.with-border {
      .all-filter-top-two-title {
        margin-top: 19px;
      }
    }
    .el-button.is-plain:focus {
      border-color: #CCC;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: var(--site-font-primary-color);
    }
  }
  .time-picker {
    .clear-btn {
      padding: 2px 7px 0 7px;
    }
  }

  .card-bottom-part {
    display: flex;
    border-top: 1px solid #CAD2DA;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
    button.el-button.submit-btn.el-button--default.is-round {
      margin-left: auto;
      padding: 5px 15px;
    }
    span {
      cursor: pointer;
    }
    div {
      margin-top: 5px;
    }
    .cancel-text{
      font-size: 14px;
      padding-left: 25px;
      padding-right: 25px;
    }
    .clear-btn {
      position: relative;
      bottom: -5px;
      right: 8px;
      // right: 174px;
      font-size: 14.22px;
      color: var(--site-button-cancel-btn-primary-color);
      border: 0px solid var(--site-button-cancel-btn-primary-border-color);
      padding: 0px;
      .char {
        margin-left: auto;
      }
    }
    .clear-filter-text{
      position: relative;
      // right: 21px;
      font-weight: normal;
      font-size: 14px;
    }
  }
  .el-button.is-plain:focus, .el-button.is-plain:hover {
    border-color: #DCDFE6;
  }
  .time {
    .vue__time-picker.time-picker {
      width: 11em !important;
      margin-right: 2px;
      min-width: 13.5em !important;
      // right: -24px !important;
    }
  }
  .popper__arrow, .popper__arrow::after{
    display: none !important;
  }

}

/**
.allFilters-popover.contact-reason-transcript {
  height: calc(100% - 345px);
  top: 325px !important;
}
*/

.all-filters-contact-reasons {
  padding: 0 0 0px 0;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0);
  border: 1px solid #EBEEF5 !important;
  width: 310px;

  .cus-msg-card {
    border-radius: 10px;
    .horizontal-line {
      margin-right: 0px;
      margin-left: 0px;
      border: 1px #e7e6e6 solid;
      padding-top: 10px;
      padding-bottom: 0px;
      padding-right: 6px;
      border-bottom: 0px;
      border-right: 0px;
      overflow: hidden;
      .reg-inp {
        background: #ffffff;
        border: 1px solid #c0c0c0;
        box-sizing: border-box;
        border-radius: 4px;
        margin-left: 15px !important;
        margin-right: 15px !important;
        margin-bottom: 15px;
        padding: 5px 21px 3px 15px;
        width: 280px;
      }
      .flex-reset-all {
        display: inline;
        font-size: 12px;
        float: right;
        margin-top: 12px;
        margin-right: 9px;
        text-decoration: underline;
      }
      .btn-select-all {
        float: right;
        font-size: 12px;
        margin-right: 15px;
        margin-top: 8px;
        cursor: pointer;
        text-decoration: underline;
        background-image: var(--icon_close_popup);
        background-repeat: no-repeat;
        height: 36px;
        width: 36px;
      }
      .fa-times-circle {
        position: relative;
        left: -35px;
        bottom: 1px;
        color: #214586;
        font-size: 12px;
        cursor: pointer;
      }
      i.fas.fa-times-circle.circle-all-filter {
        // left: 365px !important;
        // bottom: 38px !important;
      }
      .input-hight-light {
        background-color: #E8F1FF !important;
      }
      .check-box-section {
        height: 265px;
        overflow-y: auto;
        overflow-x: hidden;
          .no-matching-data-text{
            display: flex;
            justify-content: center;
          }
        .el-checkbox{
          .el-checkbox__label {
            color: var(--site-font-primary-color) !important;
            width: 250px !important;
          }
        }
        &::-webkit-scrollbar {
          background-color: white !important;
          width: 6px !important;
        }
        &::-webkit-scrollbar-thumb{
          background: #CAD2DA !important;
          border-radius: 50px !important;
        }
      }
      .check-box-section .el-checkbox {
        margin-left: 16px;
        padding-bottom: 4px;
        margin-bottom: 10px
      }
      span.el-checkbox__inner {
        border: 2px solid var(--primary-checkbox-button-border-color) !important;
      }
      span.el-checkbox__inner:hover {
        -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow);
        box-shadow: var(--primary-checkbox-button-hover-box-shadow);
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: var(--primary-checkbox-button-check-color);
        border-color: var(--primary-checkbox-button-checked-border-color) !important;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner::after {
        left: 3px;
        top: 0px;
      }
    }
    .horizontal-line .el-checkbox-group {
      height: fit-content;
      padding-bottom: 0px;
      /* overflow-y: auto; */
      // display: flex;
      width: 378px;

      .el-checkbox {
        color: var(--site-font-primary-color);
        margin-bottom: 10px;
        margin-left: 15px;
        margin-right: 5px !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        .el-checkbox__input {
          line-height: 1.5;
        }
        .el-checkbox__label {
          // max-width: 230px;
          // width: 95%;
          width: 100%;
          color: var(--site-font-primary-color);
          .display-topic-name {
            display: inline-block;
            outline: none;
            max-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .topic-number {
            float: right;
          }
        }
        .el-checkbox__inner {
          top: 0px;
        }
        span.el-checkbox__inner:hover {
          -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow);
          box-shadow: var(--primary-checkbox-button-hover-box-shadow);
        }
      }
    }
  }
}

// .allFilters-popover.agent-popper {
//   width: 270px;
//   border: none;
//   min-width: 303px !important;
// }
.agent-popper {
  width: 270px;
  border: none;
  min-width: 303px !important;

  .el-scrollbar {
    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #CAD2DA !important;
      border-radius: 50px !important;
    }
  }

  .el-select-dropdown__wrap {
    max-height: 206px !important;
  }
  .el-popper .popper__arrow, .el-popper .popper__arrow::after {
    display: none !important;
  }
  .el-select-dropdown__list {
    padding: 0px 0;

    .el-select-dropdown__item.selected {
      border: none;
      font-weight: unset;
    }
    .el-select-dropdown__item {
      padding: 0 26px 0 12px;
      margin: 7px 0px;
      border-radius: 5px;
    }
    .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: transparent;
    }
  }
  .el-select-dropdown__list .el-select-dropdown__item.selected {
    background-color: #E8F1FF !important;
    color: #000 !important;
    border-radius: 0px !important;
  }
  .el-select-dropdown__wrap {
    background: white;
    color: var(--site-font-tertiary-color) !important;
  }
  .el-select-dropdown__item {
    color: var(--site-font-tertiary-color) !important;
  }
  .el-select-dropdown__item:hover {
    background: #F4F6F8 !important;
    color: var(--site-font-tertiary-color) !important;
    border-radius: 0px !important;
  }

  .el-select-dropdown__item {
    color: var(--site-font-tertiary-color) !important;
  }
  .el-select-dropdown__list {
    padding: 0px 0;
    background: white;
    color: var(--site-font-tertiary-color) !important;
  }
  .el-select-dropdown__item.selected::after {
    right: 11px;
    top: 5px !important;
    content: url('../../assets/icons/icon_agent_dropdown_check.svg') !important;
    top: 3px !important;
  }
  .popper__arrow::after {
    border-bottom-color: transparent !important;
    background: transparent;
  }
  .popper__arrow{
    display: none !important;
  }
}

.el-popper .popper__arrow, .el-popper .popper__arrow::after {
  display: none !important;
}


.allFilters-popover.contact-reason-transcript {
  height: calc(100% - 378px);

  .cus-msg-card.all-filter-card {
    .content {
      max-height: 448px;
      height: calc(100% - 158px);
      padding: 0px 20px 20px 20px;
    }
    .card-bottom-part {
      padding: 10px 15px 0px 25px;
    }
  }
}
</style>